import React, { useEffect, useState, useRef } from "react";
import "./dashboard.scss";
import DataTable from "./DataTable/DataTable";
import axios from "axios";
import { Api_Url } from "../../../utils/ApiUrl";
import Modal from "react-bootstrap/Modal";
// import axios from 'axios';
// import { Api_Url } from '../../../utils/ApiUrl';
import { useHistory } from "react-router-dom";
import Web3 from "web3";
import { toast } from "react-toastify";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css";
import { DateRange } from "react-date-range";
import { useDetectClickOutside } from "react-detect-click-outside";
import { CopyToClipboard } from "react-copy-to-clipboard";
import CuurentRound from "../../../hooks/dataFetchers/round";
import tableup from "../../../assets/tableup.svg";
import tabledown from "../../../assets/tabledown.svg";

import moment from "moment";
import Countrychart from "./CountryChart";

const Dashboard = ({ user, setUser, tomiPrice, usdPrice, btcPrice }) => {
  let userRole = user?.role;
  const [topThreeApiCalled, setTopThreeApiCalled] = useState(false);

  const [topTenApiCalled, setTopTenApiCalled] = useState(false);
  const [transactionApiCalled, setTransactionApiCalled] = useState(false);
  const { cuurentRound } = CuurentRound();
  const [totalRound, setTotalRound] = useState([]);

  const [codeDataCall, setCodeDataCall] = useState();
  const tok = localStorage?.getItem("accessToken");
  const [data, setData] = useState([]);
  const [totalT, setTotalT] = useState(0);
  const [welcome, setwelcome] = useState();
  const [purchases, setPurchases] = useState(null);
  const [earnings, setEarnings] = useState(null);
  const [netRevenue, setnetRevenue] = useState(null);
  // const [usdPrice, setUsdPrice] = useState(0);
  // console.log("sdfdsfsdf", usdPrice)
  // const [tomiPrice, setchange24hr1] = useState(0);
  const [transactions, setTransactions] = useState([]);
  const [specialAccess, setSpecialAccess] = useState([]);
  const [myTree, setMyTree] = useState([]);
  const [otherLeaders, setOtherLeaders] = useState([]);
  const [otherLeadersEarnings, setOtherLeadersEarnings] = useState([]);
  const [myTreePurchasedAmount, setMyTreePurchasedAmount] = useState([]);

  const [otherLeadersPurchasedAmount, setOtherLeadersPurchasedAmount] =
    useState([]);

  const [userselectdate, setuserselectdate] = useState(false);
  const [pc, setPC] = useState(0);
  const [pmc, setPMC] = useState(0);
  const [nrc, setNRC] = useState(0);
  const [lc, setLC] = useState(0);
  const [dpc, setDPC] = useState(0);
  const [lec, setLEC] = useState(0);
  const [a, seta] = useState(0);
  const [m, setm] = useState(0);
  const [s, sets] = useState(0);
  const [g, setg] = useState(0);
  const [gmini, setgmini] = useState(0);

  const [mm, setmm] = useState(0);
  const [ss, setss] = useState(0);
  const [gg, setgg] = useState(0);
  const [ggmini, setggmini] = useState(0);

  const [purchasesAndEarnings, setPurchasedAndEarnings] = useState(0);

  const [pee, setPEE] = useState(0);
  const [peu, setPEU] = useState(0);
  const [pet, setPET] = useState(0);

  const [totPurchases, setTotPurchases] = useState(0);
  const [dopPurchased, setDOPPurchased] = useState(0);

  const [ind, setIND] = useState(0);
  const [dt, setDT] = useState(0);
  const [totalleader, settotalleader] = useState(0);
  const [activeleader, setactiveleader] = useState(0);
  const [round, setRound] = useState("");

  const [dops, setDops] = useState(null);
  const [dopPrice, setDopPrice] = useState(0);
  const [search, setSearch] = useState("");
  const [topLeaderSearch, setTopLeaderSearch] = useState("");

  const [dataTime, setDataTime] = useState("1");
  const [dataTimeTop, setDataTimeTop] = useState("1");
  const [showtext, SetShowtext] = useState(false);

  const [orderField, setOrderField] = useState("transactionTime");
  const [orderDirection, setOrderDirection] = useState("-1");
  const [page, setPage] = useState(0);
  const [pageCount, setPageCount] = useState([]);
  const [topTenLeaders, setTopTenLeaders] = useState([]);
  const [topTenData, setTopTenData] = useState([]);
  const [topThreeData, setTopThreeData] = useState([]);
  const [topThreeLeadersData, setTopThreeLeadersData] = useState([]);
  const [chartsData, setChartsData] = useState();

  const [tokenNftStats, setTokenNftStats] = useState();
  // const [tomiPrice, setTomiPrice] = useState("");
  const [state, setState] = useState([
    {
      startDate: new Date(),
      endDate: null,
      key: "selection",
    },
  ]);

  const [showcalendar, setShowCalendar] = useState(false);

  const [Users1, setUsers1] = useState(null);
  const [Users2, setUsers2] = useState(null);
  const [Users3, setUsers3] = useState(null);
  const [Users4, setUsers4] = useState(null);

  const history = useHistory();

  const [loader, setLoader] = useState(false);
  const [alllset, setalllset] = useState("1");
  const [show, setShow] = useState(false);
  const [agents, setAgents] = useState([]);
  const [name, setName] = useState("");
  const [role, setRole] = useState(null);
  const [addr, setAddr] = useState("");
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [show1, setShow1] = useState(false);
  const handleClose1 = () => {
    setName("");
    setAddr("");
    setEmail("");
    // setRole(null);
    setShow1(false);
  };

  const [activeTab, setActiveTab] = useState("home-tab");

  const [show2, setShow2] = useState(false);
  const handleClose2 = () => {
    setShow2(false);
    setRole(null);
  };
  function isValidEmail(email) {
    var pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return pattern.test(email);
  }

  function isAddressValid(address) {
    return Web3.utils.isAddress(address);
  }

  // const getTomiPrice = async () => {
  //   try {
  //     const response = await axios.get(
  //       `https://api.coingecko.com/api/v3/simple/price`,
  //       {
  //         params: {
  //           ids: "tomiNet",
  //           vs_currencies: "usd",
  //         },
  //       }
  //     );

  //     const data = response?.data;
  //     const priceInUSD = data["tominet"]?.usd;

  //     setTomiPrice(priceInUSD);
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //     // throw error;
  //   }
  // };

  useEffect(() => {
    if (activeTab == "profile-tab" && user?.role != "mini_agent") {
      GetTopTenLeaders();
    } else if (activeTab == "top-ten" || activeTab == "special-access") {
      GetTopTenData();
    } else if (user?.role == "admin" && activeTab == "top-three") {
      GetTopThreeData();
    } else if (userRole != "admin" && userRole != undefined) {
      GetTopThreeData();
    }
  }, [activeTab, topLeaderSearch, dataTime, dataTimeTop, round, userRole]);

  const GetTopThreeData = async () => {
    // if (account) {
    setTopThreeData([]);

    let time;
    if (dataTime && user?.role == "admin") {
      time = dataTime;
    } else if (dataTimeTop && user?.role != "admin") {
      time = dataTimeTop;
    }
    let date = null;
    let date1 = null;
    if (time == "1") {
      var date12 = new Date();
      // var datesnd = (date12.getDate() - 7)
      var dateOffset = 24 * 60 * 60 * 1000 * 0; //1 month
      var myDate = new Date();
      myDate.setTime(myDate.getTime() - dateOffset);
      // console.log(“dsdssdfsdfsdf”,myDate,date12)
      //     let a = new Date(datesnd)
      date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");

      //////////////////////////////////////////
      // var date12 = new Date();

      // var dateOffset = 24 * 60 * 60 * 1000; // 24 hours (1 day) in milliseconds
      // var myDate = new Date(date12.getTime() - dateOffset); // Subtract 24 hours from the current time

      // date = myDate.toISOString(); // Start time (24 hours ago)
      // date1 = date12.toISOString(); // Current time as end time
    } else if (time == "seven") {
      var date12 = new Date();
      // var datesnd = (date12.getDate() - 7)
      var dateOffset = 24 * 60 * 60 * 1000 * 7; //1 month
      var myDate = new Date();
      myDate.setTime(myDate.getTime() - dateOffset);
      // console.log(“dsdssdfsdfsdf”,myDate,date12)
      //     let a = new Date(datesnd)
      date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");
    } else if (time == "year") {
      var date12 = new Date();
      // var datesnd = (date12.getDate() - 7)
      var dateOffset = 24 * 60 * 60 * 1000 * 365; //1 month
      var myDate = new Date();
      myDate.setTime(myDate.getTime() - dateOffset);
      // console.log(“dsdssdfsdfsdf”,myDate,date12)
      //     let a = new Date(datesnd)
      date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");
    } else if (time == "month") {
      var date12 = new Date();
      // var datesnd = (date12.getDate() - 7)
      var dateOffset = 24 * 60 * 60 * 1000 * 31; //1 month
      var myDate = new Date();
      myDate.setTime(myDate.getTime() - dateOffset);
      // console.log(“dsdssdfsdfsdf”,myDate,date12)
      //     let a = new Date(datesnd)
      date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");
    }

    let url = "";
    if (user?.role === "admin" && activeTab == "top-three") {
      url = `${Api_Url}/users/top-three?limit=3&privateSale=GEMS`;
      // remove the private sale url from here

      if (url != null) {
        let dynamicQuery = url;

        if (time) {
          dynamicQuery += `&startDate=${date}&endDate=${date1}`;
        }
        if (round) {
          dynamicQuery += `&round=${round}`;
        }

        url = dynamicQuery;
        var config = {
          method: "get",
          url: url,
          headers: {
            authorization: `Bearer ` + tok,
          },
        };

        axios(config)
          .then(function (response) {
            setTopThreeData(response?.data?.data);
            setTopThreeApiCalled(true);
          })
          .catch(function (error) {
            setTopThreeApiCalled(true);

            console.log(error);
          });
      }
    } else if (userRole != "admin") {
      url = `${Api_Url}/users/top-three?limit=3&privateSale=GEMS`;
      // remove the private sale url from here

      if (url != null) {
        let dynamicQuery = url;

        if (time) {
          dynamicQuery += `&startDate=${date}&endDate=${date1}`;
        }
        if (round) {
          dynamicQuery += `&round=${round}`;
        }

        url = dynamicQuery;
        var config = {
          method: "get",
          url: url,
          headers: {
            authorization: `Bearer ` + tok,
          },
        };

        axios(config)
          .then(function (response) {
            setTopThreeLeadersData(response?.data?.data);
            setTopThreeApiCalled(true);
          })
          .catch(function (error) {
            setTopThreeApiCalled(true);

            console.log(error);
          });
      }
    }

    // }
  };

  const GetTopThreeData1 = async (times) => {
    // if (account) {
    setTopThreeData([]);
    setalllset();
    setuserselectdate(true);
    setState(times);
    let date = null;
    let date1 = null;
    if (times) {
      let a = new Date(times[0]?.startDate);
      let b = new Date(times[0]?.endDate);
      date = moment(a).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(b).utc().format("Y-MM-DDT23:59:59");
    }

    if (date && date1) {
      let url = "";
      if (user?.role === "admin" && activeTab == "top-three") {
        url = `${Api_Url}/users/top-three?limit=3&privateSale=GEMS`;
        // remove the private sale url from here

        if (url != null) {
          let dynamicQuery = url;

          dynamicQuery += `&startDate=${date}&endDate=${date1}`;
          if (round) {
            dynamicQuery += `&round=${round}`;
          }

          url = dynamicQuery;
          var config = {
            method: "get",
            url: url,
            headers: {
              authorization: `Bearer ` + tok,
            },
          };

          axios(config)
            .then(function (response) {
              setTopThreeData(response?.data?.data);

              setTopThreeApiCalled(true);
            })
            .catch(function (error) {
              setTopThreeApiCalled(true);

              console.log(error);
            });
        }
      } else if (user?.role != "admin") {
        url = `${Api_Url}/users/top-three?limit=3&privateSale=GEMS`;
        // remove the private sale url from here

        if (url != null) {
          let dynamicQuery = url;

          dynamicQuery += `&startDate=${date}&endDate=${date1}`;
          if (round) {
            dynamicQuery += `&round=${round}`;
          }

          url = dynamicQuery;
          var config = {
            method: "get",
            url: url,
            headers: {
              authorization: `Bearer ` + tok,
            },
          };

          axios(config)
            .then(function (response) {
              setTopThreeLeadersData(response?.data?.data);

              setTopThreeApiCalled(true);
            })
            .catch(function (error) {
              setTopThreeApiCalled(true);

              console.log(error);
            });
        }
      }
    }
    // }
  };

  /////////////////////////////////////////////////////////////////////////////////////////////////////
  const GetTopTenData = async () => {
    // if (account) {
    setTopTenData([]);

    let time;
    if (dataTime && user?.role == "admin") {
      time = dataTime;
    } else if (dataTimeTop && user?.role != "admin") {
      time = dataTimeTop;
    }
    let date = null;
    let date1 = null;
    if (time == "1") {
      var date12 = new Date();
      // var datesnd = (date12.getDate() - 7)
      var dateOffset = 24 * 60 * 60 * 1000 * 0; //1 month
      var myDate = new Date();
      myDate.setTime(myDate.getTime() - dateOffset);
      // console.log(“dsdssdfsdfsdf”,myDate,date12)
      //     let a = new Date(datesnd)
      date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");

      //////////////////////////////////////////
      // var date12 = new Date();

      // var dateOffset = 24 * 60 * 60 * 1000; // 24 hours (1 day) in milliseconds
      // var myDate = new Date(date12.getTime() - dateOffset); // Subtract 24 hours from the current time

      // date = myDate.toISOString(); // Start time (24 hours ago)
      // date1 = date12.toISOString(); // Current time as end time
    } else if (time == "seven") {
      var date12 = new Date();
      // var datesnd = (date12.getDate() - 7)
      var dateOffset = 24 * 60 * 60 * 1000 * 7; //1 month
      var myDate = new Date();
      myDate.setTime(myDate.getTime() - dateOffset);
      // console.log(“dsdssdfsdfsdf”,myDate,date12)
      //     let a = new Date(datesnd)
      date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");
    } else if (time == "year") {
      var date12 = new Date();
      // var datesnd = (date12.getDate() - 7)
      var dateOffset = 24 * 60 * 60 * 1000 * 365; //1 month
      var myDate = new Date();
      myDate.setTime(myDate.getTime() - dateOffset);
      // console.log(“dsdssdfsdfsdf”,myDate,date12)
      //     let a = new Date(datesnd)
      date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");
    } else if (time == "month") {
      var date12 = new Date();
      // var datesnd = (date12.getDate() - 7)
      var dateOffset = 24 * 60 * 60 * 1000 * 31; //1 month
      var myDate = new Date();
      myDate.setTime(myDate.getTime() - dateOffset);
      // console.log(“dsdssdfsdfsdf”,myDate,date12)
      //     let a = new Date(datesnd)
      date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");
    }

    let url = null;
    if (user?.role === "admin" && activeTab == "top-ten") {
      url = `${Api_Url}/users/top-ten?limit=10&privateSale=GEMS`;
    } else if (
      user?.role == "god_agent" &&
      user?.specialAccess &&
      user?.specialAccess?.length > 0 &&
      activeTab == "special-access"
    ) {
      url = `${Api_Url}/users/god-special-accesses?limit=10&offset=1&privateSale=GEMS`;
    }
    if (url != null) {
      let dynamicQuery = url;

      if (topLeaderSearch) {
        dynamicQuery += `&search=${topLeaderSearch}`;
      }

      if (time) {
        dynamicQuery += `&startDate=${date}&endDate=${date1}`;
      }
      if (round) {
        dynamicQuery += `&round=${round}`;
      }

      url = dynamicQuery;
      var config = {
        method: "get",
        url: url,
        headers: {
          authorization: `Bearer ` + tok,
        },
      };

      axios(config)
        .then(function (response) {
          if (user?.role === "admin" && activeTab == "top-ten") {
            setTopTenData(response?.data?.data);
          } else if (
            user?.role == "god_agent" &&
            user?.specialAccess &&
            user?.specialAccess?.length > 0 &&
            activeTab == "special-access"
          ) {
            setTopTenData(response?.data?.data?.specialAccesses);
          }

          setTopTenApiCalled(true);
        })
        .catch(function (error) {
          setTopTenApiCalled(true);

          console.log(error);
        });
    }
    // }
  };

  const GetTopTenData1 = async (times) => {
    // if (account) {
    setTopTenData([]);
    setalllset();
    setuserselectdate(true);
    setState(times);
    let date = null;
    let date1 = null;
    if (times) {
      let a = new Date(times[0]?.startDate);
      let b = new Date(times[0]?.endDate);
      date = moment(a).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(b).utc().format("Y-MM-DDT23:59:59");
    }

    if (date && date1) {
      let url = null;
      if (user?.role === "admin" && activeTab == "top-ten") {
        url = `${Api_Url}/users/top-ten?limit=10&privateSale=GEMS`;
      } else if (
        user?.role == "god_agent" &&
        user?.specialAccess &&
        user?.specialAccess?.length > 0 &&
        activeTab == "special-access"
      ) {
        url = `${Api_Url}/users/god-special-accesses?limit=10&offset=1&privateSale=GEMS`;
      }
      if (url != null) {
        let dynamicQuery = url;

        if (topLeaderSearch) {
          dynamicQuery += `&search=${topLeaderSearch}`;
        }

        dynamicQuery += `&startDate=${date}&endDate=${date1}`;
        if (round) {
          dynamicQuery += `&round=${round}`;
        }

        url = dynamicQuery;
        var config = {
          method: "get",
          url: url,
          headers: {
            authorization: `Bearer ` + tok,
          },
        };

        axios(config)
          .then(function (response) {
            if (user?.role === "admin" && activeTab == "top-ten") {
              setTopTenData(response?.data?.data);
            } else if (
              user?.role == "god_agent" &&
              user?.specialAccess &&
              user?.specialAccess?.length > 0 &&
              activeTab == "special-access"
            ) {
              setTopTenData(response?.data?.data?.specialAccesses);
            }

            setTopTenApiCalled(true);
          })
          .catch(function (error) {
            setTopTenApiCalled(true);

            console.log(error);
          });
      }
    }
    // }
  };

  ///////////////////////////////////////////////////////////////////////////////////
  const GetTopTenLeaders = async () => {
    // if (account) {
    let time;
    if (dataTime && user?.role == "admin") {
      time = dataTime;
    } else if (dataTimeTop && user?.role != "admin") {
      time = dataTimeTop;
    }
    let date = null;
    let date1 = null;
    if (time == "1") {
      var date12 = new Date();
      // var datesnd = (date12.getDate() - 7)
      var dateOffset = 24 * 60 * 60 * 1000 * 0; //1 month
      var myDate = new Date();
      myDate.setTime(myDate.getTime() - dateOffset);
      // console.log(“dsdssdfsdfsdf”,myDate,date12)
      //     let a = new Date(datesnd)
      date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");

      //////////////////////////////////////////
      // var date12 = new Date();

      // var dateOffset = 24 * 60 * 60 * 1000; // 24 hours (1 day) in milliseconds
      // var myDate = new Date(date12.getTime() - dateOffset); // Subtract 24 hours from the current time

      // date = myDate.toISOString(); // Start time (24 hours ago)
      // date1 = date12.toISOString(); // Current time as end time
    } else if (time == "seven") {
      var date12 = new Date();
      // var datesnd = (date12.getDate() - 7)
      var dateOffset = 24 * 60 * 60 * 1000 * 7; //1 month
      var myDate = new Date();
      myDate.setTime(myDate.getTime() - dateOffset);
      // console.log(“dsdssdfsdfsdf”,myDate,date12)
      //     let a = new Date(datesnd)
      date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");
    } else if (time == "year") {
      var date12 = new Date();
      // var datesnd = (date12.getDate() - 7)
      var dateOffset = 24 * 60 * 60 * 1000 * 365; //1 month
      var myDate = new Date();
      myDate.setTime(myDate.getTime() - dateOffset);
      // console.log(“dsdssdfsdfsdf”,myDate,date12)
      //     let a = new Date(datesnd)
      date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");
    } else if (time == "month") {
      var date12 = new Date();
      // var datesnd = (date12.getDate() - 7)
      var dateOffset = 24 * 60 * 60 * 1000 * 31; //1 month
      var myDate = new Date();
      myDate.setTime(myDate.getTime() - dateOffset);
      // console.log(“dsdssdfsdfsdf”,myDate,date12)
      //     let a = new Date(datesnd)
      date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");
    }

    let url = null;
    if (user?.role === "admin") {
      url = `${Api_Url}/users/top-leaders?limit=10&privateSale=GEMS`;
    } else if (user?.role === "god_agent") {
      url = `${Api_Url}/users/god-top-leaders?limit=10&privateSale=GEMS`;
    } else if (
      user?.role === "mega_agent" ||
      user?.role === "super_agent" ||
      user?.role === "agent"
    ) {
      url = `${Api_Url}/users/mega-super-top-leaders?limit=10&privateSale=GEMS`;
    }
    if (url != null) {
      let dynamicQuery = url;

      if (topLeaderSearch) {
        dynamicQuery += `&search=${topLeaderSearch}`;
      }

      if (time) {
        dynamicQuery += `&startDate=${date}&endDate=${date1}`;
      }
      if (round) {
        dynamicQuery += `&round=${round}`;
      }

      url = dynamicQuery;
      var config = {
        method: "get",
        url: url,
        headers: {
          authorization: `Bearer ` + tok,
        },
      };

      axios(config)
        .then(function (response) {
          setTopTenLeaders(response?.data?.data);
          setTopTenApiCalled(true);
        })
        .catch(function (error) {
          setTopTenApiCalled(true);

          console.log(error);
        });
    }
    // }
  };

  const GetTopTenLeaders1 = async (times) => {
    // if (account) {
    setalllset();
    setuserselectdate(true);
    setState(times);
    let date = null;
    let date1 = null;
    if (times) {
      let a = new Date(times[0]?.startDate);
      let b = new Date(times[0]?.endDate);
      date = moment(a).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(b).utc().format("Y-MM-DDT23:59:59");
    }

    if (date && date1) {
      let url = null;
      if (user?.role === "admin") {
        url = `${Api_Url}/users/top-leaders?limit=10&privateSale=GEMS`;
      } else if (user?.role === "god_agent") {
        url = `${Api_Url}/users/god-top-leaders?limit=10&privateSale=GEMS`;
      } else if (
        user?.role === "mega_agent" ||
        user?.role === "super_agent" ||
        user?.role === "agent"
      ) {
        url = `${Api_Url}/users/mega-super-top-leaders?limit=10&privateSale=GEMS`;
      }
      if (url != null) {
        let dynamicQuery = url;

        if (topLeaderSearch) {
          dynamicQuery += `&search=${topLeaderSearch}`;
        }
        dynamicQuery += `&startDate=${date}&endDate=${date1}`;

        if (round) {
          dynamicQuery += `&round=${round}`;
        }

        url = dynamicQuery;
        var config = {
          method: "get",
          url: url,
          headers: {
            authorization: `Bearer ` + tok,
          },
        };

        axios(config)
          .then(function (response) {
            setTopTenLeaders(response?.data?.data);
            setTopTenApiCalled(true);
          })
          .catch(function (error) {
            setTopTenApiCalled(true);

            console.log(error);
          });
      }
    }
    // }
  };

  const AddAgent = () => {
    const lowerCaseEmail = email.toLowerCase();
    const val = localStorage.getItem("accessToken");
    let url = null;
    if (user?.role === "admin") {
      url = `${Api_Url}/users/god-agents`;
    } else if (role === "mega_agent") {
      url = `${Api_Url}/users/mega-agents`;
    } else if (role === "super_agent") {
      url = `${Api_Url}/users/super-agents`;
    } else if (role === "agent") {
      url = `${Api_Url}/users/agents`;
    } else if (role === "mini_agent") {
      url = `${Api_Url}/users/mini-agents`;
    }
    if (name?.length > 2) {
      if (isAddressValid(addr)) {
        if (isValidEmail(email)) {
          setLoader(true);
          var config = {
            method: "post",
            url: url,
            data: {
              name: name,
              walletAddress: addr,
              email: lowerCaseEmail,
              name: name,
            },
            headers: {
              Authorization: "Bearer " + val,
            },
          };
          axios(config)
            .then(function (response) {
              setLoader(false);
              GetMyData();
              setName("");
              setAddr("");
              setEmail("");
              // setRole(null);
              handleClose1();
              setShow2(true);
            })
            .catch(function (error) {
              setLoader(false);
              setRole(null);

              toast.error(error?.response?.data?.message);
              if (error?.response?.status == 401) {
                // localStorage.removeItem("accessToken");
                // history.push("/");
              }
            });
        } else {
          setError("Incorrect Email!");
        }
      } else {
        setError("Incorrect wallet address!");
      }
    } else {
      setError("Name must be of length 3!");
    }
  };

  function convertToTitleCase(input) {
    if (input) {
      let words = input
        .split("_")
        .map(
          (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        );
      if (words[0] === "mini" || words[0] === "Mini") {
        return "Ambassador";
      }
      if (
        words[words.length - 1].toLowerCase() === "agent" &&
        (words[0] != "mini" || words[0] != "Mini")
      ) {
        words[words.length - 1] = "Leader";
      }
      if (words[0] === "super" || words[0] === "Super") {
        return "Super";
      } else if (words[0] !== "agent") {
        return words.join(" ");
      } else {
        return "Leader";
      }
    } else {
      return "";
    }
  }

  useEffect(() => {
    // getTomiPrice();

    // axios
    //   .get("https://min-api.cryptocompare.com/data/price?fsym=ETH&tsyms=USD")
    //   .then((res) => {
    //     setUsdPrice(res?.data?.USD);
    //     // setEthUsd(res.data);
    //   });

    firstTimeData();
  }, []);

  const handlePageChange = (e) => {
    const selectedPage = e.selected;

    setPage(selectedPage);
  };

  const getTransactionsData = () => {
    var config = {
      method: "get",
      url: `${Api_Url}/users/all-transactions?privateSale=GEMS&limit=20&offset=1`,
      // remove the private sale url from here

      headers: {
        Authorization: "Bearer " + tok,
      },
    };

    let dynamicQuery = config.url;

    if (search) {
      dynamicQuery += `&by=${search}`;
    }

    if (orderField) {
      dynamicQuery += `&orderField=${orderField}&orderDirection=${orderDirection}`;
    }
    if (user?.role == "god_agent") {
      dynamicQuery += `&myTree=true`;
    }
    if (round) {
      dynamicQuery += `&round=${round}`;
    }

    config.url = dynamicQuery;

    axios(config)
      .then(function (res) {
        // console.log("trx data: ", res?.data?.data?.transactions);
        setTransactions(res?.data?.data?.transactions);
        setPageCount(res?.data?.data?.pages);
        setTransactionApiCalled(true);
        setLoader(false);
      })
      .catch(function (error) {
        setTransactionApiCalled(true);

        setLoader(false);
      });
  };

  // const getTotalList = async () => {
  //   var data = null;
  //   if (user?.role === "admin") {
  //     data = JSON.stringify({
  //       query: `query MyQuery {
  //                   investments(orderBy: blockTimestamp, orderDirection: desc) {
  //                     tokenSelected
  //                     by
  //                     blockTimestamp
  //                     code_AgentAddress
  //                     code_AgentPercentage
  //                     code_GodAgentAddress
  //                     code_GodAgentPercentage
  //                     code_SuperAgentAddress
  //                     code_SuperAgentPercentage
  //                     dopPurchased
  //                     code_code
  //                     id
  //                     index
  //                     price
  //                     round
  //                     transactionHash
  //                     AgentAmount
  //                     amountInvested
  //                     GodAgentAmount
  //                     MegaAgentAmount
  //                     SuperAgentAmount
  //                   }
  //                 }`,
  //       variables: {},
  //     });
  //     var config = {
  //       method: "post",
  //       url: "https://api.studio.thegraph.com/query/51007/dop-sale/version/latest",
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       data: data,
  //     };
  //   } else {
  //     if (user?.role === "agent") {
  //       data = JSON.stringify({
  //         query: `query MyQuery {
  //         investments(orderBy: blockTimestamp
  //           orderDirection: desc
  //           where: { code_AgentAddress_contains: "${user?.walletAddress}"}) {
  //           tokenSelected
  //           by
  //           blockTimestamp
  //           code_AgentAddress
  //           code_AgentPercentage
  //           code_GodAgentAddress
  //           code_GodAgentPercentage
  //           code_SuperAgentAddress
  //           code_SuperAgentPercentage
  //           dopPurchased
  //           code_code
  //           id
  //           index
  //           price
  //           round
  //           transactionHash
  //           AgentAmount
  //           amountInvested
  //           GodAgentAmount
  //           MegaAgentAmount
  //           SuperAgentAmount
  //         }
  //       }`,
  //         variables: {},
  //       });
  //     } else if (user?.role === "super_agent") {
  //       data = JSON.stringify({
  //         query: `query MyQuery {
  //         investments(orderBy: blockTimestamp
  //           orderDirection: desc
  //           where: { code_SuperAgentAddress_contains: "${user?.walletAddress}"}) {
  //           tokenSelected
  //           by
  //           blockTimestamp
  //           code_AgentAddress
  //           code_AgentPercentage
  //           code_GodAgentAddress
  //           code_GodAgentPercentage
  //           code_SuperAgentAddress
  //           code_SuperAgentPercentage
  //           dopPurchased
  //           code_code
  //           id
  //           index
  //           price
  //           round
  //           transactionHash
  //           AgentAmount
  //           amountInvested
  //           GodAgentAmount
  //           MegaAgentAmount
  //           SuperAgentAmount
  //         }
  //       }`,
  //         variables: {},
  //       });
  //     } else if (user?.role === "mega_agent") {
  //       data = JSON.stringify({
  //         query: `query MyQuery {
  //         investments(orderBy: blockTimestamp
  //           orderDirection: desc where: { code_MegaAgentAddress_contains: "${user?.walletAddress}"}) {
  //           tokenSelected
  //           by
  //           blockTimestamp
  //           code_AgentAddress
  //           code_AgentPercentage
  //           code_GodAgentAddress
  //           code_GodAgentPercentage
  //           code_SuperAgentAddress
  //           code_SuperAgentPercentage
  //           dopPurchased
  //           code_code
  //           id
  //           index
  //           price
  //           round
  //           transactionHash
  //           AgentAmount
  //           amountInvested
  //           GodAgentAmount
  //           MegaAgentAmount
  //           SuperAgentAmount
  //         }
  //       }`,
  //         variables: {},
  //       });
  //     } else if (user?.role === "god_agent") {
  //       data = JSON.stringify({
  //         query: `query MyQuery {
  //         investments(orderBy: blockTimestamp
  //           orderDirection: desc
  //           where: { code_GodAgentAddress_contains: "${user?.walletAddress}"}) {
  //           tokenSelected
  //           by
  //           blockTimestamp
  //           code_AgentAddress
  //           code_AgentPercentage
  //           code_GodAgentAddress
  //           code_GodAgentPercentage
  //           code_SuperAgentAddress
  //           code_SuperAgentPercentage
  //           dopPurchased
  //           code_code
  //           id
  //           index
  //           price
  //           round
  //           transactionHash
  //           AgentAmount
  //           amountInvested
  //           GodAgentAmount
  //           MegaAgentAmount
  //           SuperAgentAmount
  //         }
  //       }`,
  //         variables: {},
  //       });
  //     }
  //     var config = {
  //       method: "post",
  //       url: "https://api.studio.thegraph.com/query/51007/dop-sale/version/latest",
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       data: data,
  //     };
  //   }

  //   await axios(config)
  //     .then(async function (response) {
  //       setTransactions(response?.data?.data?.investments);
  //       // console.log("sadsdfsdf", response?.data?.data?.investments)
  //       if (response?.data?.data?.investments?.length > 0) {
  //         setData(response?.data?.data?.investments);
  //         // setUserObj(response?.data?.data?.investments[0]);
  //         let amountT = 0;
  //         let percUs = 0;
  //         let percEth = 0;
  //         let amoUs = 0;
  //         let amoEth = 0;
  //         let sumT = 0;
  //         let a = 0;
  //         let g = 0;
  //         let m = 0;
  //         let s = 0;
  //         let dop = 0;
  //         let dopUs = 0;
  //         let netRevEth = 0;
  //         let netRevUsd = 0;
  //         let earneth = 0;
  //         let earnusd = 0;
  //         for (let i of response?.data?.data?.investments) {
  //           if (i?.tokenSelected === "ETH") {
  //             amoEth =
  //               parseInt(i?.amountInvested) / 1000000000000000000 + amoEth;
  //             dop =
  //               (usdPrice *
  //                 (parseInt(i?.amountInvested) / 1000000000000000000)) /
  //                 (parseInt(i?.price) / 1000000000000000000) +
  //               dop;
  //           } else {
  //             amoUs = parseInt(i?.amountInvested) / 1000000 + amoUs;
  //             dopUs =
  //               parseInt(i?.amountInvested) /
  //                 1000000 /
  //                 (parseInt(i?.price) / 1000000000000000000) +
  //               dopUs;
  //           }

  //           if (i?.tokenSelected === "ETH") {
  //             let vals =
  //               parseFloat(i?.AgentAmount) / 1000000000000000000 +
  //               parseFloat(i?.GodAgentAmount) / 1000000000000000000 +
  //               parseFloat(i?.MegaAgentAmount) / 1000000000000000000 +
  //               parseFloat(i?.SuperAgentAmount) / 1000000000000000000;
  //             let invest = parseFloat(i?.amountInvested) / 1000000000000000000;
  //             netRevEth = invest - vals + netRevEth;
  //             earneth = vals + earneth;
  //           } else {
  //             let vals =
  //               parseFloat(i?.AgentAmount) / 1000000 +
  //               parseFloat(i?.GodAgentAmount) / 1000000 +
  //               parseFloat(i?.MegaAgentAmount) / 1000000 +
  //               parseFloat(i?.SuperAgentAmount) / 1000000;
  //             let invest = parseFloat(i?.amountInvested) / 1000000;
  //             netRevUsd = invest - vals + netRevUsd;
  //             earnusd = vals + earnusd;
  //           }
  //           // }
  //         }
  //         setPurchases({
  //           eth: amoEth,
  //           us: amoUs,
  //         });
  //         setEarnings({
  //           eth: earneth,
  //           us: earnusd,
  //         });
  //         setnetRevenue({
  //           eth: netRevEth,
  //           us: netRevUsd,
  //         });
  //         setDops({
  //           eth: dop,
  //           us: dopUs,
  //         });
  //         setDopPrice(
  //           parseInt(response?.data?.data?.investments[0]?.price) /
  //             1000000000000000000
  //         );
  //         // setEarnings({
  //         //     eth: percEth,
  //         //     us: percUs
  //         // })
  //         // setTotalT(amountT)
  //         // setSumTomi(sumT)
  //       }
  //     })
  //     .catch(function (error) {
  //       console.log(error, "error");
  //     });
  // };
  const [adminobj, setadminobj] = useState();

  // console.log("value ",user)

  const GetAllRounds = async () => {
    // if (account) {
    var config = {
      method: "get",
      url: `${Api_Url}/users/admin/stats`,
      headers: {
        authorization: `Bearer ` + tok,
      },
    };
    axios(config)
      .then(function (response) {
        if (response?.data?.data?.stats?.length > 0) {
          setadminobj(response?.data?.data?.stats[0]);
        }
        let value = response?.data?.data;
        setPC();
        setPMC();
        setNRC();
        setLC();
        setDPC();
        setLEC();
        seta(value?.agents);
        setg(value?.godAgents);
        setm(value?.megaAgents);
        sets(value?.superAgents);
        setgmini(value?.miniAgents);
        settotalleader(
          value?.agents +
            value?.godAgents +
            value?.megaAgents +
            value?.superAgents +
            value?.miniAgents
        );
        setactiveleader(value?.activeLeaders);
      })
      .catch(function (error) {
        console.log(error);
      });
    // }
  };

  useEffect(() => {
    // GetAllRounds();
    // GetMyData();
    if (usdPrice && user) {
      getTransactionsData();
      // getTotalList();
    }
  }, [usdPrice, user, search, orderField, orderDirection, round]);

  useEffect(() => {
    if (usdPrice && tomiPrice) {
      if (user?.role == "mini_agent") {
        setwelcome("Ambassador");
        GetDashboardDataMyUsers1("1");
      } else if (user?.role == "agent") {
        setwelcome("Leader");
        GetDashboardDataMyUsers1("1");
      } else if (user?.role == "god_agent") {
        setwelcome("God Leader");
        GetDashboardDataMyUsers1("1");
      } else if (user?.role == "mega_agent") {
        setwelcome("Mega Leader");
        GetDashboardDataMyUsers1("1");
      } else if (user?.role == "super_agent") {
        setwelcome("Super Leader");
        GetDashboardDataMyUsers1("1");
      } else if (user?.role == "admin") {
        setwelcome("Admin");
        GetDashboardData1();
        GetChartsData();
      }
    }
  }, [user, round, dataTime, usdPrice, tomiPrice]);

  const GetChartsDataCalendar = (times) => {
    setalllset();
    setState(times);
    let date = null;
    let date1 = null;
    if (times) {
      let a = new Date(times[0]?.startDate);
      let b = new Date(times[0]?.endDate);
      date = moment(a).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(b).utc().format("Y-MM-DDT23:59:59");
    }

    var config = {
      method: "get",
      url: `${Api_Url}/emails/country/stats`,
      // url: `${Api_Url}/users/leader-counts?startDate=${stDate}&&endDate=${enDate}`,
      headers: {
        authorization: `Bearer ` + tok,
      },
    };

    let dynamicQuery = config.url;

    if (times) {
      dynamicQuery += `?startDate=${date}&endDate=${date1}`;
    }
    if (times) {
      if (round) {
        dynamicQuery += `&round=${round}`;
      }
    } else {
      if (round) {
        dynamicQuery += `?round=${round}`;
      }
    }

    config.url = dynamicQuery;

    axios(config)
      .then(function (response) {
        let resData = response?.data?.data;
        setChartsData(resData);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const GetChartsData = () => {
    let date = null;
    let date1 = null;
    if (dataTime == "1") {
      var date12 = new Date();
      // var datesnd = (date12.getDate() - 7)
      var dateOffset = 24 * 60 * 60 * 1000 * 0; //1 month
      var myDate = new Date();
      myDate.setTime(myDate.getTime() - dateOffset);
      // console.log(“dsdssdfsdfsdf”,myDate,date12)
      //     let a = new Date(datesnd)
      date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");

      //////////////////////////////////////////
      // var date12 = new Date();

      // var dateOffset = 24 * 60 * 60 * 1000; // 24 hours (1 day) in milliseconds
      // var myDate = new Date(date12.getTime() - dateOffset); // Subtract 24 hours from the current time

      // date = myDate.toISOString(); // Start time (24 hours ago)
      // date1 = date12.toISOString(); // Current time as end time
    } else if (dataTime == "seven") {
      var date12 = new Date();
      // var datesnd = (date12.getDate() - 7)
      var dateOffset = 24 * 60 * 60 * 1000 * 7; //1 month
      var myDate = new Date();
      myDate.setTime(myDate.getTime() - dateOffset);
      // console.log(“dsdssdfsdfsdf”,myDate,date12)
      //     let a = new Date(datesnd)
      date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");
    } else if (dataTime == "year") {
      var date12 = new Date();
      // var datesnd = (date12.getDate() - 7)
      var dateOffset = 24 * 60 * 60 * 1000 * 365; //1 month
      var myDate = new Date();
      myDate.setTime(myDate.getTime() - dateOffset);
      // console.log(“dsdssdfsdfsdf”,myDate,date12)
      //     let a = new Date(datesnd)
      date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");
    } else if (dataTime == "month") {
      var date12 = new Date();
      // var datesnd = (date12.getDate() - 7)
      var dateOffset = 24 * 60 * 60 * 1000 * 31; //1 month
      var myDate = new Date();
      myDate.setTime(myDate.getTime() - dateOffset);
      // console.log(“dsdssdfsdfsdf”,myDate,date12)
      //     let a = new Date(datesnd)
      date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");
    }

    var config = {
      method: "get",
      url: `${Api_Url}/emails/country/stats`,
      // url: `${Api_Url}/users/leader-counts?startDate=${stDate}&&endDate=${enDate}`,
      headers: {
        authorization: `Bearer ` + tok,
      },
    };

    // console.log("dates: ", date, date1);
    let dynamicQuery = config.url;

    if (dataTime) {
      dynamicQuery += `?startDate=${date}&endDate=${date1}`;
    }
    if (dataTime != "") {
      if (round) {
        dynamicQuery += `&round=${round}`;
      }
    } else {
      if (round) {
        dynamicQuery += `&round=${round}`;
      }
    }

    config.url = dynamicQuery;

    axios(config)
      .then(function (response) {
        setChartsData(response?.data?.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  // Admin data upper stats
  const GetDashboardData = (times) => {
    setalllset();
    setState(times);
    let date = null;
    let date1 = null;
    if (times) {
      let a = new Date(times[0]?.startDate);
      let b = new Date(times[0]?.endDate);
      date = moment(a).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(b).utc().format("Y-MM-DDT23:59:59");
    }

    var config = {
      method: "get",
      url: `${Api_Url}/users/admin/stats?privateSale=GEMS`,
      // url: `${Api_Url}/users/leader-counts?startDate=${stDate}&&endDate=${enDate}`,
      headers: {
        authorization: `Bearer ` + tok,
      },
    };

    let dynamicQuery = config.url;

    if (times) {
      dynamicQuery += `&startDate=${date}&endDate=${date1}`;
    }
    if (times) {
      if (round) {
        dynamicQuery += `&round=${round}`;
      }
    } else {
      if (round) {
        dynamicQuery += `?round=${round}`;
      }
    }

    config.url = dynamicQuery;

    axios(config)
      .then(function (response) {
        if (response?.data?.data?.stats?.length > 0) {
          setadminobj(response?.data?.data?.stats[0]);
        } else {
          setadminobj();
        }
        let value = response?.data?.data;
        // console.log("value: ", value);
        setTokenNftStats(value);
        if (times) {
          let purchaseChange =
            ((value?.stats[0]?.TotalPurchases -
              value?.oldleadersStats[0]?.TotalPurchases) /
              value?.oldleadersStats[0]?.TotalPurchases) *
            100;
          setPC(purchaseChange);

          let newPurchasedAmount =
            value?.stats[0]?.totalPurchaseEth * usdPrice +
            value?.stats[0]?.totalPurchaseUsdt +
            value?.stats[0]?.totalPurchaseTomi * tomiPrice;
          let oldPurchasedAmount =
            value?.oldleadersStats[0]?.totalPurchaseEth * usdPrice +
            value?.oldleadersStats[0]?.totalPurchaseUsdt +
            value?.oldleadersStats[0]?.totalPurchaseTomi * tomiPrice;

          let purchasedAmountChange = 0;

          if (newPurchasedAmount === 0 && oldPurchasedAmount === 0) {
            purchasedAmountChange = 0;
          } else if (newPurchasedAmount === 0 || oldPurchasedAmount === 0) {
            if (newPurchasedAmount === 0) {
              purchasedAmountChange =
                ((0 - oldPurchasedAmount) / oldPurchasedAmount) * 100;
            }
            if (oldPurchasedAmount === 0) {
              purchasedAmountChange = ((newPurchasedAmount + 1 - 1) / 1) * 100;
            }
          } else {
            purchasedAmountChange =
              ((newPurchasedAmount - oldPurchasedAmount) / oldPurchasedAmount) *
              100;
          }

          setPMC(purchasedAmountChange);

          setNRC(value?.netRevenueChange);

          let newLeadersCount =
            value?.agents +
            value?.godAgents +
            value?.megaAgents +
            value?.superAgents +
            value?.miniAgents;
          let oldLeadersCount =
            value?.oldleaders +
            value?.oldgodLeaders +
            value?.oldmegaLeaders +
            value?.oldsuperLeaders +
            value?.oldminiLeaders;
          let leadersChange = 0;
          if (newLeadersCount === 0 && oldLeadersCount === 0) {
            leadersChange = 0;
          } else if (newLeadersCount === 0 || oldLeadersCount === 0) {
            if (newLeadersCount === 0) {
              leadersChange = ((0 - oldLeadersCount) / oldLeadersCount) * 100;
            }
            if (oldLeadersCount === 0) {
              leadersChange = ((newLeadersCount + 1 - 1) / 1) * 100;
            }
          } else {
            leadersChange =
              ((newLeadersCount - oldLeadersCount) / oldLeadersCount) * 100;
          }
          setLC(leadersChange);
          let dopChange =
            ((value?.stats[0]?.totalDopPurchased -
              value?.oldleadersStats[0]?.totalDopPurchased) /
              value?.oldleadersStats[0]?.totalDopPurchased) *
            100;
          setDPC(dopChange);

          let totalLeaderEarningsEthValueOld =
            value?.oldleadersStats[0]?.totalLeaderEarningsEth * usdPrice;
          let totalLeaderEarningsTomiValueOld =
            value?.oldleadersStats[0]?.totalLeaderEarningsTomi * tomiPrice;
          let totalLeaderEarningsEthValueNew =
            value?.stats[0]?.totalLeaderEarningsEth * usdPrice;
          let totalLeaderEarningsTomiValueNew =
            value?.stats[0]?.totalLeaderEarningsTomi * tomiPrice;

          let totalLeaderEarningsOldPrice =
            totalLeaderEarningsEthValueOld +
            value?.oldleadersStats[0]?.totalLeaderEarningsUsdt +
            totalLeaderEarningsTomiValueOld;
          let totalLeaderEarningsNewPrice =
            totalLeaderEarningsEthValueNew +
            value?.stats[0]?.totalLeaderEarningsUsdt +
            totalLeaderEarningsTomiValueNew;

          let totalLeadersEarningChange = 0;

          if (
            totalLeaderEarningsNewPrice === 0 &&
            totalLeaderEarningsOldPrice === 0
          ) {
            totalLeadersEarningChange = 0;
          } else if (
            totalLeaderEarningsNewPrice === 0 ||
            totalLeaderEarningsOldPrice === 0
          ) {
            if (totalLeaderEarningsNewPrice === 0) {
              totalLeadersEarningChange =
                ((0 - totalLeaderEarningsOldPrice) /
                  totalLeaderEarningsOldPrice) *
                100;
            }
            if (totalLeaderEarningsOldPrice === 0) {
              totalLeadersEarningChange =
                ((totalLeaderEarningsNewPrice + 1 - 1) / 1) * 100;
            }
          } else {
            totalLeadersEarningChange =
              ((totalLeaderEarningsNewPrice - totalLeaderEarningsOldPrice) /
                totalLeaderEarningsOldPrice) *
              100;
          }

          setLEC(totalLeadersEarningChange);
        } else {
          setPC("");
          setPMC("");

          setNRC("");
          setLC("");
          setDPC("");
          setLEC("");
        }

        seta(value?.agents);
        setg(value?.godAgents);
        setm(value?.megaAgents);
        sets(value?.superAgents);
        setgmini(value?.miniAgents);

        settotalleader(
          value?.agents +
            value?.godAgents +
            value?.megaAgents +
            value?.superAgents +
            value?.miniAgents
        );
        setactiveleader(value?.activeLeaders);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const GetDashboardData1 = () => {
    let date = null;
    let date1 = null;
    if (dataTime == "1") {
      var date12 = new Date();
      // var datesnd = (date12.getDate() - 7)
      var dateOffset = 24 * 60 * 60 * 1000 * 0; //1 month
      var myDate = new Date();
      myDate.setTime(myDate.getTime() - dateOffset);
      // console.log(“dsdssdfsdfsdf”,myDate,date12)
      //     let a = new Date(datesnd)
      date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");

      //////////////////////////////////////////
      // var date12 = new Date();

      // var dateOffset = 24 * 60 * 60 * 1000; // 24 hours (1 day) in milliseconds
      // var myDate = new Date(date12.getTime() - dateOffset); // Subtract 24 hours from the current time

      // date = myDate.toISOString(); // Start time (24 hours ago)
      // date1 = date12.toISOString(); // Current time as end time
    } else if (dataTime == "seven") {
      var date12 = new Date();
      // var datesnd = (date12.getDate() - 7)
      var dateOffset = 24 * 60 * 60 * 1000 * 7; //1 month
      var myDate = new Date();
      myDate.setTime(myDate.getTime() - dateOffset);
      // console.log(“dsdssdfsdfsdf”,myDate,date12)
      //     let a = new Date(datesnd)
      date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");
    } else if (dataTime == "year") {
      var date12 = new Date();
      // var datesnd = (date12.getDate() - 7)
      var dateOffset = 24 * 60 * 60 * 1000 * 365; //1 month
      var myDate = new Date();
      myDate.setTime(myDate.getTime() - dateOffset);
      // console.log(“dsdssdfsdfsdf”,myDate,date12)
      //     let a = new Date(datesnd)
      date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");
    } else if (dataTime == "month") {
      var date12 = new Date();
      // var datesnd = (date12.getDate() - 7)
      var dateOffset = 24 * 60 * 60 * 1000 * 31; //1 month
      var myDate = new Date();
      myDate.setTime(myDate.getTime() - dateOffset);
      // console.log(“dsdssdfsdfsdf”,myDate,date12)
      //     let a = new Date(datesnd)
      date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");
    }

    var config = {
      method: "get",
      url: `${Api_Url}/users/admin/stats?privateSale=GEMS`,
      // url: `${Api_Url}/users/leader-counts?startDate=${stDate}&&endDate=${enDate}`,
      headers: {
        authorization: `Bearer ` + tok,
      },
    };

    // console.log("dates: ", date, date1);
    let dynamicQuery = config.url;

    if (dataTime) {
      dynamicQuery += `&startDate=${date}&endDate=${date1}`;
    }
    if (dataTime != "") {
      if (round) {
        dynamicQuery += `&round=${round}`;
      }
    } else {
      if (round) {
        dynamicQuery += `&round=${round}`;
      }
    }

    config.url = dynamicQuery;

    axios(config)
      .then(function (response) {
        // console.log("asdasdasdasdasdas", response);
        if (response?.data?.data?.stats?.length > 0) {
          setadminobj(response?.data?.data?.stats[0]);
        } else {
          setadminobj();
        }
        let value = response?.data?.data;
        setTokenNftStats(value);
        if (dataTime) {
          let purchaseChange =
            ((value?.stats[0]?.TotalPurchases -
              value?.oldleadersStats[0]?.TotalPurchases) /
              value?.oldleadersStats[0]?.TotalPurchases) *
            100;
          setPC(purchaseChange);

          let newPurchasedAmount =
            value?.stats[0]?.totalPurchaseEth * usdPrice +
            value?.stats[0]?.totalPurchaseUsdt +
            value?.stats[0]?.totalPurchaseTomi * tomiPrice;
          let oldPurchasedAmount =
            value?.oldleadersStats[0]?.totalPurchaseEth * usdPrice +
            value?.oldleadersStats[0]?.totalPurchaseUsdt +
            value?.oldleadersStats[0]?.totalPurchaseTomi * tomiPrice;

          let purchasedAmountChange = 0;

          if (newPurchasedAmount === 0 && oldPurchasedAmount === 0) {
            purchasedAmountChange = 0;
          } else if (newPurchasedAmount === 0 || oldPurchasedAmount === 0) {
            if (newPurchasedAmount === 0) {
              purchasedAmountChange =
                ((0 - oldPurchasedAmount) / oldPurchasedAmount) * 100;
            }
            if (oldPurchasedAmount === 0) {
              purchasedAmountChange = ((newPurchasedAmount + 1 - 1) / 1) * 100;
            }
          } else {
            purchasedAmountChange =
              ((newPurchasedAmount - oldPurchasedAmount) / oldPurchasedAmount) *
              100;
          }

          setPMC(purchasedAmountChange);
          setNRC(value?.netRevenueChange);

          let newLeadersCount =
            value?.agents +
            value?.godAgents +
            value?.megaAgents +
            value?.superAgents +
            value?.miniAgents;
          let oldLeadersCount =
            value?.oldleaders +
            value?.oldgodLeaders +
            value?.oldmegaLeaders +
            value?.oldsuperLeaders +
            value?.oldminiLeaders;
          let leadersChange = 0;
          if (newLeadersCount === 0 && oldLeadersCount === 0) {
            leadersChange = 0;
          } else if (newLeadersCount === 0 || oldLeadersCount === 0) {
            if (newLeadersCount === 0) {
              leadersChange = ((0 - oldLeadersCount) / oldLeadersCount) * 100;
            }
            if (oldLeadersCount === 0) {
              leadersChange = ((newLeadersCount + 1 - 1) / 1) * 100;
            }
          } else {
            leadersChange =
              ((newLeadersCount - oldLeadersCount) / oldLeadersCount) * 100;
          }
          setLC(leadersChange);
          let dopChange =
            ((value?.stats[0]?.totalDopPurchased -
              value?.oldleadersStats[0]?.totalDopPurchased) /
              value?.oldleadersStats[0]?.totalDopPurchased) *
            100;
          setDPC(dopChange);

          let totalLeaderEarningsEthValueOld =
            value?.oldleadersStats[0]?.totalLeaderEarningsEth * usdPrice;
          let totalLeaderEarningsTomiValueOld =
            value?.oldleadersStats[0]?.totalLeaderEarningsTomi * tomiPrice;
          let totalLeaderEarningsEthValueNew =
            value?.stats[0]?.totalLeaderEarningsEth * usdPrice;
          let totalLeaderEarningsTomiValueNew =
            value?.stats[0]?.totalLeaderEarningsTomi * tomiPrice;

          let totalLeaderEarningsOldPrice =
            totalLeaderEarningsEthValueOld +
            value?.oldleadersStats[0]?.totalLeaderEarningsUsdt +
            totalLeaderEarningsTomiValueOld;
          let totalLeaderEarningsNewPrice =
            totalLeaderEarningsEthValueNew +
            value?.stats[0]?.totalLeaderEarningsUsdt +
            totalLeaderEarningsTomiValueNew;

          let totalLeadersEarningChange = 0;

          if (
            totalLeaderEarningsNewPrice === 0 &&
            totalLeaderEarningsOldPrice === 0
          ) {
            totalLeadersEarningChange = 0;
          } else if (
            totalLeaderEarningsNewPrice === 0 ||
            totalLeaderEarningsOldPrice === 0
          ) {
            if (totalLeaderEarningsNewPrice === 0) {
              totalLeadersEarningChange =
                ((0 - totalLeaderEarningsOldPrice) /
                  totalLeaderEarningsOldPrice) *
                100;
            }
            if (totalLeaderEarningsOldPrice === 0) {
              totalLeadersEarningChange =
                ((totalLeaderEarningsNewPrice + 1 - 1) / 1) * 100;
            }
          } else {
            totalLeadersEarningChange =
              ((totalLeaderEarningsNewPrice - totalLeaderEarningsOldPrice) /
                totalLeaderEarningsOldPrice) *
              100;
          }
          setLEC(totalLeadersEarningChange);
        } else {
          setPC("");
          setPMC("");

          setNRC("");
          setLC("");
          setDPC("");
          setLEC("");
        }
        seta(value?.agents);
        setg(value?.godAgents);
        setm(value?.megaAgents);
        sets(value?.superAgents);
        setgmini(value?.miniAgents);

        settotalleader(
          value?.agents +
            value?.godAgents +
            value?.megaAgents +
            value?.superAgents +
            value?.miniAgents
        );
        setactiveleader(value?.activeLeaders);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  // User gode mega leader super data upper stats
  const GetDashboardDataMyUsers = (times) => {
    setalllset();
    setuserselectdate(true);
    setState(times);
    let date = null;
    let date1 = null;
    if (times) {
      let a = new Date(times[0]?.startDate);
      let b = new Date(times[0]?.endDate);
      date = moment(a).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(b).utc().format("Y-MM-DDT23:59:59");
    }

    if (date && date1) {
      var config = {
        method: "get",
        url: `${Api_Url}/users/my/stats?startDate=${date}&endDate=${date1}&privateSale=GEMS`,
        headers: {
          authorization: `Bearer ` + tok,
        },
      };
      axios(config)
        .then(function (response) {
          let value = response?.data?.data;
          // console.log("sdfsfsdfsdfsdfdsfsdfdf", value);
          setTokenNftStats(value);

          setSpecialAccess(value?.specialAccess);
          setMyTree(value?.myTree);
          setOtherLeaders(value?.otherLeaders);
          setOtherLeadersEarnings(value?.otherLeadersEarnings);
          setMyTreePurchasedAmount(value?.myTreePurchasedAmount);
          setOtherLeadersPurchasedAmount(value?.otherLeadersPurchasedAmount);

          setTotPurchases(value?.totalPurchases);
          setDOPPurchased(value?.totalDopPurchased);

          setPurchasedAndEarnings(value?.purchasedAndEarnings);

          setIND(value?.inDirectSales);
          setDT(value?.directSales);
          let purchasesOld =
            value?.oldPurchasesAndDopPurchased[0]?.TotalPurchases;
          let purchasesNew = value?.totalPurchases;

          let purchaseChange =
            ((purchasesNew - purchasesOld) / purchasesOld) * 100;
          setPC(purchaseChange);

          let oldPurchasedEth =
            value?.oldPurchasedAndEarnings[0]?._id?.tokenSelected == "ETH"
              ? value?.oldPurchasedAndEarnings[0]?.totalPurchase
              : value?.oldPurchasedAndEarnings[1]?._id?.tokenSelected == "ETH"
              ? value?.oldPurchasedAndEarnings[1]?.totalPurchase
              : value?.oldPurchasedAndEarnings[2]?._id?.tokenSelected == "ETH"
              ? value?.oldPurchasedAndEarnings[2]?.totalPurchase
              : 0;
          let oldPurchasedUsdt =
            value?.oldPurchasedAndEarnings[0]?._id?.tokenSelected == "USDT"
              ? value?.oldPurchasedAndEarnings[0]?.totalPurchase
              : value?.oldPurchasedAndEarnings[1]?._id?.tokenSelected == "USDT"
              ? value?.oldPurchasedAndEarnings[1]?.totalPurchase
              : value?.oldPurchasedAndEarnings[2]?._id?.tokenSelected == "USDT"
              ? value?.oldPurchasedAndEarnings[2]?.totalPurchase
              : 0;
          let oldPurchasedTomi =
            value?.oldPurchasedAndEarnings[0]?._id?.tokenSelected == "TOMI"
              ? value?.oldPurchasedAndEarnings[0]?.totalPurchase
              : value?.oldPurchasedAndEarnings[1]?._id?.tokenSelected == "TOMI"
              ? value?.oldPurchasedAndEarnings[1]?.totalPurchase
              : value?.oldPurchasedAndEarnings[2]?._id?.tokenSelected == "TOMI"
              ? value?.oldPurchasedAndEarnings[2]?.totalPurchase
              : 0;

          let newPurchasedEth =
            value?.purchasedAndEarnings[0]?._id?.tokenSelected == "ETH"
              ? value?.purchasedAndEarnings[0]?.totalPurchase
              : value?.purchasedAndEarnings[1]?._id?.tokenSelected == "ETH"
              ? value?.purchasedAndEarnings[1]?.totalPurchase
              : value?.purchasedAndEarnings[2]?._id?.tokenSelected == "EETH"
              ? value?.purchasedAndEarnings[2]?.totalPurchase
              : 0;
          let newPurchasedUsdt =
            value?.purchasedAndEarnings[0]?._id?.tokenSelected == "USDT"
              ? value?.purchasedAndEarnings[0]?.totalPurchase
              : value?.purchasedAndEarnings[1]?._id?.tokenSelected == "USDT"
              ? value?.purchasedAndEarnings[1]?.totalPurchase
              : value?.purchasedAndEarnings[2]?._id?.tokenSelected == "USDT"
              ? value?.purchasedAndEarnings[2]?.totalPurchase
              : 0;
          let newPurchasedTomi =
            value?.purchasedAndEarnings[0]?._id?.tokenSelected == "TOMI"
              ? value?.purchasedAndEarnings[0]?.totalPurchase
              : value?.purchasedAndEarnings[1]?._id?.tokenSelected == "TOMI"
              ? value?.purchasedAndEarnings[1]?.totalPurchase
              : value?.purchasedAndEarnings[2]?._id?.tokenSelected == "TOMI"
              ? value?.purchasedAndEarnings[2]?.totalPurchase
              : 0;

          let newPurchasedAmount =
            newPurchasedEth * usdPrice +
            newPurchasedUsdt +
            newPurchasedTomi * tomiPrice;
          let oldPurchasedAmount =
            oldPurchasedEth * usdPrice +
            oldPurchasedUsdt +
            oldPurchasedTomi * tomiPrice;

          let purchasedAmountChange = 0;

          if (newPurchasedAmount === 0 && oldPurchasedAmount === 0) {
            purchasedAmountChange = 0;
          } else if (newPurchasedAmount === 0 || oldPurchasedAmount === 0) {
            if (newPurchasedAmount === 0) {
              purchasedAmountChange =
                ((0 - oldPurchasedAmount) / oldPurchasedAmount) * 100;
            }
            if (oldPurchasedAmount === 0) {
              purchasedAmountChange = ((newPurchasedAmount + 1 - 1) / 1) * 100;
            }
          } else {
            purchasedAmountChange =
              ((newPurchasedAmount - oldPurchasedAmount) / oldPurchasedAmount) *
              100;
          }

          setPMC(purchasedAmountChange);

          let newLeadersCount =
            value?.agents +
            value?.godAgents +
            value?.megaAgents +
            value?.superAgents +
            value?.miniAgents;
          let oldLeadersCount =
            value?.oldleaders +
            value?.oldgodLeaders +
            value?.oldmegaLeaders +
            value?.oldsuperLeaders +
            value?.oldminiLeaders;
          let leadersChange = 0;
          if (newLeadersCount === 0 && oldLeadersCount === 0) {
            leadersChange = 0;
          } else if (newLeadersCount === 0 || oldLeadersCount === 0) {
            if (newLeadersCount === 0) {
              leadersChange = ((0 - oldLeadersCount) / oldLeadersCount) * 100;
            }
            if (oldLeadersCount === 0) {
              leadersChange = ((newLeadersCount + 1 - 1) / 1) * 100;
            }
          } else {
            leadersChange =
              ((newLeadersCount - oldLeadersCount) / oldLeadersCount) * 100;
          }

          setLC(leadersChange);
          let dopChange =
            ((value?.totalDopPurchased -
              value?.oldPurchasesAndDopPurchased[0]?.totalDopPurchased) /
              value?.oldPurchasesAndDopPurchased[0]?.totalDopPurchased) *
            100;

          setDPC(dopChange);

          let oldEarningsEth =
            value?.oldPurchasedAndEarnings[0]?._id?.tokenSelected == "ETH"
              ? value?.oldPurchasedAndEarnings[0]?.totalLeaderEarnings
              : value?.oldPurchasedAndEarnings[1]?._id?.tokenSelected == "ETH"
              ? value?.oldPurchasedAndEarnings[1]?.totalLeaderEarnings
              : value?.oldPurchasedAndEarnings[2]?._id?.tokenSelected == "ETH"
              ? value?.oldPurchasedAndEarnings[2]?.totalLeaderEarnings
              : 0;
          let oldEarningsUsdt =
            value?.oldPurchasedAndEarnings[0]?._id?.tokenSelected == "USDT"
              ? value?.oldPurchasedAndEarnings[0]?.totalLeaderEarnings
              : value?.oldPurchasedAndEarnings[1]?._id?.tokenSelected == "USDT"
              ? value?.oldPurchasedAndEarnings[1]?.totalLeaderEarnings
              : value?.oldPurchasedAndEarnings[2]?._id?.tokenSelected == "USDT"
              ? value?.oldPurchasedAndEarnings[2]?.totalLeaderEarnings
              : 0;
          let oldEarningsTomi =
            value?.oldPurchasedAndEarnings[0]?._id?.tokenSelected == "TOMI"
              ? value?.oldPurchasedAndEarnings[0]?.totalLeaderEarnings
              : value?.oldPurchasedAndEarnings[1]?._id?.tokenSelected == "TOMI"
              ? value?.oldPurchasedAndEarnings[1]?.totalLeaderEarnings
              : value?.oldPurchasedAndEarnings[2]?._id?.tokenSelected == "TOMI"
              ? value?.oldPurchasedAndEarnings[2]?.totalLeaderEarnings
              : 0;

          let newEarningsEth =
            value?.purchasedAndEarnings[0]?._id?.tokenSelected == "ETH"
              ? value?.purchasedAndEarnings[0]?.totalLeaderEarnings
              : value?.purchasedAndEarnings[1]?._id?.tokenSelected == "ETH"
              ? value?.purchasedAndEarnings[1]?.totalLeaderEarnings
              : value?.purchasedAndEarnings[2]?._id?.tokenSelected == "EETH"
              ? value?.purchasedAndEarnings[2]?.totalLeaderEarnings
              : 0;
          let newEarningsUsdt =
            value?.purchasedAndEarnings[0]?._id?.tokenSelected == "USDT"
              ? value?.purchasedAndEarnings[0]?.totalLeaderEarnings
              : value?.purchasedAndEarnings[1]?._id?.tokenSelected == "USDT"
              ? value?.purchasedAndEarnings[1]?.totalLeaderEarnings
              : value?.purchasedAndEarnings[2]?._id?.tokenSelected == "USDT"
              ? value?.purchasedAndEarnings[2]?.totalLeaderEarnings
              : 0;
          let newEarningsTomi =
            value?.purchasedAndEarnings[0]?._id?.tokenSelected == "TOMI"
              ? value?.purchasedAndEarnings[0]?.totalLeaderEarnings
              : value?.purchasedAndEarnings[1]?._id?.tokenSelected == "TOMI"
              ? value?.purchasedAndEarnings[1]?.totalLeaderEarnings
              : value?.purchasedAndEarnings[2]?._id?.tokenSelected == "TOMI"
              ? value?.purchasedAndEarnings[2]?.totalLeaderEarnings
              : 0;

          let earningsChange =
            ((newEarningsEth * usdPrice +
              newEarningsUsdt +
              newEarningsTomi * tomiPrice -
              (oldEarningsEth * usdPrice +
                oldEarningsUsdt +
                oldEarningsTomi * tomiPrice)) /
              (oldEarningsEth * usdPrice +
                oldEarningsUsdt +
                oldEarningsTomi * tomiPrice)) *
            100;

          let totalLeaderEarningsOldPrice =
            oldEarningsEth * usdPrice +
            oldEarningsUsdt +
            oldEarningsTomi * tomiPrice;
          let totalLeaderEarningsNewPrice =
            newEarningsEth * usdPrice +
            newEarningsUsdt +
            newEarningsTomi * tomiPrice;

          let totalLeadersEarningChange = 0;

          if (
            totalLeaderEarningsNewPrice === 0 &&
            totalLeaderEarningsOldPrice === 0
          ) {
            totalLeadersEarningChange = 0;
          } else if (
            totalLeaderEarningsNewPrice === 0 ||
            totalLeaderEarningsOldPrice === 0
          ) {
            if (totalLeaderEarningsNewPrice === 0) {
              totalLeadersEarningChange =
                ((0 - totalLeaderEarningsOldPrice) /
                  totalLeaderEarningsOldPrice) *
                100;
            }
            if (totalLeaderEarningsOldPrice === 0) {
              totalLeadersEarningChange =
                ((totalLeaderEarningsNewPrice + 1 - 1) / 1) * 100;
            }
          } else {
            totalLeadersEarningChange =
              ((totalLeaderEarningsNewPrice - totalLeaderEarningsOldPrice) /
                totalLeaderEarningsOldPrice) *
              100;
          }

          setLEC(totalLeadersEarningChange);
          setgg(value?.leaders);
          setggmini(value?.miniLeaders);
          setactiveleader(value?.activeLeaders);

          setmm(value?.megas);
          setss(value?.supers);
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  };

  const GetDashboardDataMyUsers1 = (alll) => {
    setuserselectdate(true);
    let date = null;
    let date1 = null;
    if (alll == "1") {
      var date12 = new Date();
      var dateOffset = 24 * 60 * 60 * 1000 * 0; //1 month
      var myDate = new Date();
      myDate.setTime(myDate.getTime() - dateOffset);
      date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");

      ///////////////////////////////
      // var date12 = new Date();

      // var dateOffset = 24 * 60 * 60 * 1000; // 24 hours (1 day) in milliseconds
      // var myDate = new Date(date12.getTime() - dateOffset); // Subtract 24 hours from the current time

      // date = myDate.toISOString(); // Start time (24 hours ago)
      // date1 = date12.toISOString(); // Current time as end time
    } else if (alll == "seven") {
      var date12 = new Date();
      var dateOffset = 24 * 60 * 60 * 1000 * 7; //1 month
      var myDate = new Date();
      myDate.setTime(myDate.getTime() - dateOffset);
      date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");
    } else if (alll == "year") {
      var date12 = new Date();
      var dateOffset = 24 * 60 * 60 * 1000 * 365; //1 month
      var myDate = new Date();
      myDate.setTime(myDate.getTime() - dateOffset);
      date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");
    } else if (alll == "month") {
      var date12 = new Date();
      var dateOffset = 24 * 60 * 60 * 1000 * 31; //1 month
      var myDate = new Date();
      myDate.setTime(myDate.getTime() - dateOffset);
      date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");
    }
    if (date && date1) {
      var config = {
        method: "get",
        url: `${Api_Url}/users/my/stats?startDate=${date}&&endDate=${date1}&privateSale=GEMS`,
        headers: {
          authorization: `Bearer ` + tok,
        },
      };
      axios(config)
        .then(function (response) {
          // console.log("responce",response)
          let value = response?.data?.data;
          // console.log("sdfsfsdfsdfsdfdsfsdfdf", value)
          setTokenNftStats(value);

          setSpecialAccess(value?.specialAccess);
          setMyTree(value?.myTree);
          setOtherLeaders(value?.otherLeaders);
          setOtherLeadersEarnings(value?.otherLeadersEarnings);

          setMyTreePurchasedAmount(value?.myTreePurchasedAmount);
          setOtherLeadersPurchasedAmount(value?.otherLeadersPurchasedAmount);
          setTotPurchases(value?.totalPurchases);
          setDOPPurchased(value?.totalDopPurchased);
          setPurchasedAndEarnings(value?.purchasedAndEarnings);

          setIND(value?.inDirectSales);
          setDT(value?.directSales);

          let purchasesOld =
            value?.oldPurchasesAndDopPurchased[0]?.TotalPurchases;
          let purchasesNew = value?.totalPurchases;

          let purchaseChange =
            ((purchasesNew - purchasesOld) / purchasesOld) * 100;
          setPC(purchaseChange);

          let oldPurchasedEth =
            value?.oldPurchasedAndEarnings[0]?._id?.tokenSelected == "ETH"
              ? value?.oldPurchasedAndEarnings[0]?.totalPurchase
              : value?.oldPurchasedAndEarnings[1]?._id?.tokenSelected == "ETH"
              ? value?.oldPurchasedAndEarnings[1]?.totalPurchase
              : value?.oldPurchasedAndEarnings[2]?._id?.tokenSelected == "ETH"
              ? value?.oldPurchasedAndEarnings[2]?.totalPurchase
              : 0;
          let oldPurchasedUsdt =
            value?.oldPurchasedAndEarnings[0]?._id?.tokenSelected == "USDT"
              ? value?.oldPurchasedAndEarnings[0]?.totalPurchase
              : value?.oldPurchasedAndEarnings[1]?._id?.tokenSelected == "USDT"
              ? value?.oldPurchasedAndEarnings[1]?.totalPurchase
              : value?.oldPurchasedAndEarnings[2]?._id?.tokenSelected == "USDT"
              ? value?.oldPurchasedAndEarnings[2]?.totalPurchase
              : 0;
          let oldPurchasedTomi =
            value?.oldPurchasedAndEarnings[0]?._id?.tokenSelected == "TOMI"
              ? value?.oldPurchasedAndEarnings[0]?.totalPurchase
              : value?.oldPurchasedAndEarnings[1]?._id?.tokenSelected == "TOMI"
              ? value?.oldPurchasedAndEarnings[1]?.totalPurchase
              : value?.oldPurchasedAndEarnings[2]?._id?.tokenSelected == "TOMI"
              ? value?.oldPurchasedAndEarnings[2]?.totalPurchase
              : 0;

          let newPurchasedEth =
            value?.purchasedAndEarnings[0]?._id?.tokenSelected == "ETH"
              ? value?.purchasedAndEarnings[0]?.totalPurchase
              : value?.purchasedAndEarnings[1]?._id?.tokenSelected == "ETH"
              ? value?.purchasedAndEarnings[1]?.totalPurchase
              : value?.purchasedAndEarnings[2]?._id?.tokenSelected == "EETH"
              ? value?.purchasedAndEarnings[2]?.totalPurchase
              : 0;
          let newPurchasedUsdt =
            value?.purchasedAndEarnings[0]?._id?.tokenSelected == "USDT"
              ? value?.purchasedAndEarnings[0]?.totalPurchase
              : value?.purchasedAndEarnings[1]?._id?.tokenSelected == "USDT"
              ? value?.purchasedAndEarnings[1]?.totalPurchase
              : value?.purchasedAndEarnings[2]?._id?.tokenSelected == "USDT"
              ? value?.purchasedAndEarnings[2]?.totalPurchase
              : 0;
          let newPurchasedTomi =
            value?.purchasedAndEarnings[0]?._id?.tokenSelected == "TOMI"
              ? value?.purchasedAndEarnings[0]?.totalPurchase
              : value?.purchasedAndEarnings[1]?._id?.tokenSelected == "TOMI"
              ? value?.purchasedAndEarnings[1]?.totalPurchase
              : value?.purchasedAndEarnings[2]?._id?.tokenSelected == "TOMI"
              ? value?.purchasedAndEarnings[2]?.totalPurchase
              : 0;

          let newPurchasedAmount =
            newPurchasedEth * usdPrice +
            newPurchasedUsdt +
            newPurchasedTomi * tomiPrice;
          let oldPurchasedAmount =
            oldPurchasedEth * usdPrice +
            oldPurchasedUsdt +
            oldPurchasedTomi * tomiPrice;

          let purchasedAmountChange = 0;

          if (newPurchasedAmount === 0 && oldPurchasedAmount === 0) {
            purchasedAmountChange = 0;
          } else if (newPurchasedAmount === 0 || oldPurchasedAmount === 0) {
            if (newPurchasedAmount === 0) {
              purchasedAmountChange =
                ((0 - oldPurchasedAmount) / oldPurchasedAmount) * 100;
            }
            if (oldPurchasedAmount === 0) {
              purchasedAmountChange = ((newPurchasedAmount + 1 - 1) / 1) * 100;
            }
          } else {
            purchasedAmountChange =
              ((newPurchasedAmount - oldPurchasedAmount) / oldPurchasedAmount) *
              100;
          }

          setPMC(purchasedAmountChange);
          let newLeadersCount =
            value?.agents +
            value?.godAgents +
            value?.megaAgents +
            value?.superAgents +
            value?.miniAgents;
          let oldLeadersCount =
            value?.oldleaders +
            value?.oldgodLeaders +
            value?.oldmegaLeaders +
            value?.oldsuperLeaders +
            value?.oldminiLeaders;
          let leadersChange = 0;
          if (newLeadersCount === 0 && oldLeadersCount === 0) {
            leadersChange = 0;
          } else if (newLeadersCount === 0 || oldLeadersCount === 0) {
            if (newLeadersCount === 0) {
              leadersChange = ((0 - oldLeadersCount) / oldLeadersCount) * 100;
            }
            if (oldLeadersCount === 0) {
              leadersChange = ((newLeadersCount + 1 - 1) / 1) * 100;
            }
          } else {
            leadersChange =
              ((newLeadersCount - oldLeadersCount) / oldLeadersCount) * 100;
          }

          setLC(leadersChange);
          let oldDOPChange =
            value?.oldPurchasesAndDopPurchased[0]?.totalDopPurchased;
          let dopChange =
            ((value?.totalDopPurchased - oldDOPChange) / oldDOPChange) * 100;

          setDPC(dopChange);

          let oldEarningsEth =
            value?.oldPurchasedAndEarnings[0]?._id?.tokenSelected == "ETH"
              ? value?.oldPurchasedAndEarnings[0]?.totalLeaderEarnings
              : value?.oldPurchasedAndEarnings[1]?._id?.tokenSelected == "ETH"
              ? value?.oldPurchasedAndEarnings[1]?.totalLeaderEarnings
              : value?.oldPurchasedAndEarnings[2]?._id?.tokenSelected == "ETH"
              ? value?.oldPurchasedAndEarnings[2]?.totalLeaderEarnings
              : 0;
          let oldEarningsUsdt =
            value?.oldPurchasedAndEarnings[0]?._id?.tokenSelected == "USDT"
              ? value?.oldPurchasedAndEarnings[0]?.totalLeaderEarnings
              : value?.oldPurchasedAndEarnings[1]?._id?.tokenSelected == "USDT"
              ? value?.oldPurchasedAndEarnings[1]?.totalLeaderEarnings
              : value?.oldPurchasedAndEarnings[2]?._id?.tokenSelected == "USDT"
              ? value?.oldPurchasedAndEarnings[2]?.totalLeaderEarnings
              : 0;
          let oldEarningsTomi =
            value?.oldPurchasedAndEarnings[0]?._id?.tokenSelected == "TOMI"
              ? value?.oldPurchasedAndEarnings[0]?.totalLeaderEarnings
              : value?.oldPurchasedAndEarnings[1]?._id?.tokenSelected == "TOMI"
              ? value?.oldPurchasedAndEarnings[1]?.totalLeaderEarnings
              : value?.oldPurchasedAndEarnings[2]?._id?.tokenSelected == "TOMI"
              ? value?.oldPurchasedAndEarnings[2]?.totalLeaderEarnings
              : 0;

          let newEarningsEth =
            value?.purchasedAndEarnings[0]?._id?.tokenSelected == "ETH"
              ? value?.purchasedAndEarnings[0]?.totalLeaderEarnings
              : value?.purchasedAndEarnings[1]?._id?.tokenSelected == "ETH"
              ? value?.purchasedAndEarnings[1]?.totalLeaderEarnings
              : value?.purchasedAndEarnings[2]?._id?.tokenSelected == "EETH"
              ? value?.purchasedAndEarnings[2]?.totalLeaderEarnings
              : 0;
          let newEarningsUsdt =
            value?.purchasedAndEarnings[0]?._id?.tokenSelected == "USDT"
              ? value?.purchasedAndEarnings[0]?.totalLeaderEarnings
              : value?.purchasedAndEarnings[1]?._id?.tokenSelected == "USDT"
              ? value?.purchasedAndEarnings[1]?.totalLeaderEarnings
              : value?.purchasedAndEarnings[2]?._id?.tokenSelected == "USDT"
              ? value?.purchasedAndEarnings[2]?.totalLeaderEarnings
              : 0;
          let newEarningsTomi =
            value?.purchasedAndEarnings[0]?._id?.tokenSelected == "TOMI"
              ? value?.purchasedAndEarnings[0]?.totalLeaderEarnings
              : value?.purchasedAndEarnings[1]?._id?.tokenSelected == "TOMI"
              ? value?.purchasedAndEarnings[1]?.totalLeaderEarnings
              : value?.purchasedAndEarnings[2]?._id?.tokenSelected == "TOMI"
              ? value?.purchasedAndEarnings[2]?.totalLeaderEarnings
              : 0;

          let totalLeaderEarningsOldPrice =
            oldEarningsEth * usdPrice +
            oldEarningsUsdt +
            oldEarningsTomi * tomiPrice;
          let totalLeaderEarningsNewPrice =
            newEarningsEth * usdPrice +
            newEarningsUsdt +
            newEarningsTomi * tomiPrice;

          let totalLeadersEarningChange = 0;

          if (
            totalLeaderEarningsNewPrice === 0 &&
            totalLeaderEarningsOldPrice === 0
          ) {
            totalLeadersEarningChange = 0;
          } else if (
            totalLeaderEarningsNewPrice === 0 ||
            totalLeaderEarningsOldPrice === 0
          ) {
            if (totalLeaderEarningsNewPrice === 0) {
              totalLeadersEarningChange =
                ((0 - totalLeaderEarningsOldPrice) /
                  totalLeaderEarningsOldPrice) *
                100;
            }
            if (totalLeaderEarningsOldPrice === 0) {
              totalLeadersEarningChange =
                ((totalLeaderEarningsNewPrice + 1 - 1) / 1) * 100;
            }
          } else {
            totalLeadersEarningChange =
              ((totalLeaderEarningsNewPrice - totalLeaderEarningsOldPrice) /
                totalLeaderEarningsOldPrice) *
              100;
          }

          setLEC(totalLeadersEarningChange);
          setgg(value?.leaders);
          setggmini(value?.miniLeaders);
          setactiveleader(value?.activeLeaders);

          setmm(value?.megas);
          setss(value?.supers);
          // if (response?.data?.data?.stats?.length > 0) {
          //   // setadminobj(response?.data?.data?.stats[0]);
          // }
          // let value = response?.data?.data;
          // setPC(value?.purchasesChange)
          // setPMC(value?.purchasesAmountChange)
          // setNRC(value?.netRevenueChange)
          // setLC(value?.leadersChange)
          // setDPC(value?.dopPurchasedChange)
          // setLEC(value?.leaderEarningsChange)

          // seta(value?.agents);
          // setg(value?.godAgents);
          // setm(value?.megaAgents);
          // sets(value?.superAgents);
          // settotalleader(
          //   value?.agents +
          //   value?.godAgents +
          //   value?.megaAgents +
          //   value?.superAgents
          // );
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  };

  const firstTimeData = async () => {
    try {
      let b = await cuurentRound();

      if (b) {
        const result = [];
        for (let i = 1; i <= b; i++) {
          result.push(i);
        }
        setTotalRound(result);
      }
    } catch (err) {
      console.log(err.message);
    }
  };

  const GetMyData = async () => {
    const tok = localStorage?.getItem("accessToken");
    // if (account) {
    var config = {
      method: "get",
      url: `${Api_Url}/users/my/stats?privateSale=GEMS`,
      headers: {
        authorization: `Bearer ` + tok,
      },
    };
    axios(config)
      .then(function (response) {
        setuserselectdate(false);
        let value = response?.data?.data;
        setTokenNftStats(value);

        // console.log("sdfsfsdfsdfsdfdsfsdfdf", value);
        setSpecialAccess(value?.specialAccess);
        setMyTree(value?.myTree);
        setOtherLeaders(value?.otherLeaders);
        setOtherLeadersEarnings(value?.otherLeadersEarnings);

        setMyTreePurchasedAmount(value?.myTreePurchasedAmount);
        setOtherLeadersPurchasedAmount(value?.otherLeadersPurchasedAmount);

        setTotPurchases(value?.totalPurchases);
        setDOPPurchased(value?.totalDopPurchased);
        setPurchasedAndEarnings(value?.purchasedAndEarnings);

        setIND(value?.inDirectSales);
        setDT(value?.directSales);
        let purchasesOld =
          value?.oldPurchasesAndDopPurchased[0]?.TotalPurchases;
        let purchasesNew = value?.totalPurchases;

        let purchaseChange =
          ((purchasesNew - purchasesOld) / purchasesOld) * 100;
        setPC(purchaseChange);

        let oldPurchasedEth =
          value?.oldPurchasedAndEarnings[0]?._id?.tokenSelected == "ETH"
            ? value?.oldPurchasedAndEarnings[0]?.totalPurchase
            : value?.oldPurchasedAndEarnings[1]?._id?.tokenSelected == "ETH"
            ? value?.oldPurchasedAndEarnings[1]?.totalPurchase
            : value?.oldPurchasedAndEarnings[2]?._id?.tokenSelected == "ETH"
            ? value?.oldPurchasedAndEarnings[2]?.totalPurchase
            : 0;
        let oldPurchasedUsdt =
          value?.oldPurchasedAndEarnings[0]?._id?.tokenSelected == "USDT"
            ? value?.oldPurchasedAndEarnings[0]?.totalPurchase
            : value?.oldPurchasedAndEarnings[1]?._id?.tokenSelected == "USDT"
            ? value?.oldPurchasedAndEarnings[1]?.totalPurchase
            : value?.oldPurchasedAndEarnings[2]?._id?.tokenSelected == "USDT"
            ? value?.oldPurchasedAndEarnings[2]?.totalPurchase
            : 0;
        let oldPurchasedTomi =
          value?.oldPurchasedAndEarnings[0]?._id?.tokenSelected == "TOMI"
            ? value?.oldPurchasedAndEarnings[0]?.totalPurchase
            : value?.oldPurchasedAndEarnings[1]?._id?.tokenSelected == "TOMI"
            ? value?.oldPurchasedAndEarnings[1]?.totalPurchase
            : value?.oldPurchasedAndEarnings[2]?._id?.tokenSelected == "TOMI"
            ? value?.oldPurchasedAndEarnings[2]?.totalPurchase
            : 0;

        let newPurchasedEth =
          value?.purchasedAndEarnings[0]?._id?.tokenSelected == "ETH"
            ? value?.purchasedAndEarnings[0]?.totalPurchase
            : value?.purchasedAndEarnings[1]?._id?.tokenSelected == "ETH"
            ? value?.purchasedAndEarnings[1]?.totalPurchase
            : value?.purchasedAndEarnings[2]?._id?.tokenSelected == "EETH"
            ? value?.purchasedAndEarnings[2]?.totalPurchase
            : 0;
        let newPurchasedUsdt =
          value?.purchasedAndEarnings[0]?._id?.tokenSelected == "USDT"
            ? value?.purchasedAndEarnings[0]?.totalPurchase
            : value?.purchasedAndEarnings[1]?._id?.tokenSelected == "USDT"
            ? value?.purchasedAndEarnings[1]?.totalPurchase
            : value?.purchasedAndEarnings[2]?._id?.tokenSelected == "USDT"
            ? value?.purchasedAndEarnings[2]?.totalPurchase
            : 0;
        let newPurchasedTomi =
          value?.purchasedAndEarnings[0]?._id?.tokenSelected == "TOMI"
            ? value?.purchasedAndEarnings[0]?.totalPurchase
            : value?.purchasedAndEarnings[1]?._id?.tokenSelected == "TOMI"
            ? value?.purchasedAndEarnings[1]?.totalPurchase
            : value?.purchasedAndEarnings[2]?._id?.tokenSelected == "TOMI"
            ? value?.purchasedAndEarnings[2]?.totalPurchase
            : 0;
        let newPurchasedAmount =
          newPurchasedEth * usdPrice +
          newPurchasedUsdt +
          newPurchasedTomi * tomiPrice;
        let oldPurchasedAmount =
          oldPurchasedEth * usdPrice +
          oldPurchasedUsdt +
          oldPurchasedTomi * tomiPrice;

        let purchasedAmountChange = 0;

        if (newPurchasedAmount === 0 && oldPurchasedAmount === 0) {
          purchasedAmountChange = 0;
        } else if (newPurchasedAmount === 0 || oldPurchasedAmount === 0) {
          if (newPurchasedAmount === 0) {
            purchasedAmountChange =
              ((0 - oldPurchasedAmount) / oldPurchasedAmount) * 100;
          }
          if (oldPurchasedAmount === 0) {
            purchasedAmountChange = ((newPurchasedAmount + 1 - 1) / 1) * 100;
          }
        } else {
          purchasedAmountChange =
            ((newPurchasedAmount - oldPurchasedAmount) / oldPurchasedAmount) *
            100;
        }

        setPMC(purchasedAmountChange);
        let newLeadersCount =
          value?.agents +
          value?.godAgents +
          value?.megaAgents +
          value?.superAgents +
          value?.miniAgents;
        let oldLeadersCount =
          value?.oldleaders +
          value?.oldgodLeaders +
          value?.oldmegaLeaders +
          value?.oldsuperLeaders +
          value?.oldminiLeaders;
        let leadersChange = 0;
        if (newLeadersCount === 0 && oldLeadersCount === 0) {
          leadersChange = 0;
        } else if (newLeadersCount === 0 || oldLeadersCount === 0) {
          if (newLeadersCount === 0) {
            leadersChange = ((0 - oldLeadersCount) / oldLeadersCount) * 100;
          }
          if (oldLeadersCount === 0) {
            leadersChange = ((newLeadersCount + 1 - 1) / 1) * 100;
          }
        } else {
          leadersChange =
            ((newLeadersCount - oldLeadersCount) / oldLeadersCount) * 100;
        }

        setLC(leadersChange);
        let dopChange =
          ((value?.totalDopPurchased -
            value?.oldPurchasesAndDopPurchased[0]?.totalDopPurchased) /
            value?.oldPurchasesAndDopPurchased[0]?.totalDopPurchased) *
          100;

        setDPC(dopChange);
        let oldEarningsEth =
          value?.oldPurchasedAndEarnings[0]?._id?.tokenSelected == "ETH"
            ? value?.oldPurchasedAndEarnings[0]?.totalLeaderEarnings
            : value?.oldPurchasedAndEarnings[1]?._id?.tokenSelected == "ETH"
            ? value?.oldPurchasedAndEarnings[1]?.totalLeaderEarnings
            : value?.oldPurchasedAndEarnings[2]?._id?.tokenSelected == "ETH"
            ? value?.oldPurchasedAndEarnings[2]?.totalLeaderEarnings
            : 0;
        let oldEarningsUsdt =
          value?.oldPurchasedAndEarnings[0]?._id?.tokenSelected == "USDT"
            ? value?.oldPurchasedAndEarnings[0]?.totalLeaderEarnings
            : value?.oldPurchasedAndEarnings[1]?._id?.tokenSelected == "USDT"
            ? value?.oldPurchasedAndEarnings[1]?.totalLeaderEarnings
            : value?.oldPurchasedAndEarnings[2]?._id?.tokenSelected == "USDT"
            ? value?.oldPurchasedAndEarnings[2]?.totalLeaderEarnings
            : 0;
        let oldEarningsTomi =
          value?.oldPurchasedAndEarnings[0]?._id?.tokenSelected == "TOMI"
            ? value?.oldPurchasedAndEarnings[0]?.totalLeaderEarnings
            : value?.oldPurchasedAndEarnings[1]?._id?.tokenSelected == "TOMI"
            ? value?.oldPurchasedAndEarnings[1]?.totalLeaderEarnings
            : value?.oldPurchasedAndEarnings[2]?._id?.tokenSelected == "TOMI"
            ? value?.oldPurchasedAndEarnings[2]?.totalLeaderEarnings
            : 0;

        let newEarningsEth =
          value?.purchasedAndEarnings[0]?._id?.tokenSelected == "ETH"
            ? value?.purchasedAndEarnings[0]?.totalLeaderEarnings
            : value?.purchasedAndEarnings[1]?._id?.tokenSelected == "ETH"
            ? value?.purchasedAndEarnings[1]?.totalLeaderEarnings
            : value?.purchasedAndEarnings[2]?._id?.tokenSelected == "EETH"
            ? value?.purchasedAndEarnings[2]?.totalLeaderEarnings
            : 0;
        let newEarningsUsdt =
          value?.purchasedAndEarnings[0]?._id?.tokenSelected == "USDT"
            ? value?.purchasedAndEarnings[0]?.totalLeaderEarnings
            : value?.purchasedAndEarnings[1]?._id?.tokenSelected == "USDT"
            ? value?.purchasedAndEarnings[1]?.totalLeaderEarnings
            : value?.purchasedAndEarnings[2]?._id?.tokenSelected == "USDT"
            ? value?.purchasedAndEarnings[2]?.totalLeaderEarnings
            : 0;
        let newEarningsTomi =
          value?.purchasedAndEarnings[0]?._id?.tokenSelected == "TOMI"
            ? value?.purchasedAndEarnings[0]?.totalLeaderEarnings
            : value?.purchasedAndEarnings[1]?._id?.tokenSelected == "TOMI"
            ? value?.purchasedAndEarnings[1]?.totalLeaderEarnings
            : value?.purchasedAndEarnings[2]?._id?.tokenSelected == "TOMI"
            ? value?.purchasedAndEarnings[2]?.totalLeaderEarnings
            : 0;

        let totalLeaderEarningsOldPrice =
          oldEarningsEth * usdPrice +
          oldEarningsUsdt +
          oldEarningsTomi * tomiPrice;
        let totalLeaderEarningsNewPrice =
          newEarningsEth * usdPrice +
          newEarningsUsdt +
          newEarningsTomi * tomiPrice;

        let totalLeadersEarningChange = 0;

        if (
          totalLeaderEarningsNewPrice === 0 &&
          totalLeaderEarningsOldPrice === 0
        ) {
          totalLeadersEarningChange = 0;
        } else if (
          totalLeaderEarningsNewPrice === 0 ||
          totalLeaderEarningsOldPrice === 0
        ) {
          if (totalLeaderEarningsNewPrice === 0) {
            totalLeadersEarningChange =
              ((0 - totalLeaderEarningsOldPrice) /
                totalLeaderEarningsOldPrice) *
              100;
          }
          if (totalLeaderEarningsOldPrice === 0) {
            totalLeadersEarningChange =
              ((totalLeaderEarningsNewPrice + 1 - 1) / 1) * 100;
          }
        } else {
          totalLeadersEarningChange =
            ((totalLeaderEarningsNewPrice - totalLeaderEarningsOldPrice) /
              totalLeaderEarningsOldPrice) *
            100;
        }

        setLEC(totalLeadersEarningChange);
        setgg(value?.leaders);
        setggmini(value?.miniLeaders);
        setactiveleader(value?.activeLeaders);

        setmm(value?.megas);
        setss(value?.supers);
      })
      .catch(function (error) {
        // console.log("status: ", error?.response);
        if (error?.response?.status == 401) {
          // history.push("/login");
        }

        console.log(error);
      });
    // }
  };

  // const closeDropdown = () => {
  //   // console.log("ddddddd")
  //   setShowCalendar(!showcalendar);
  // };
  // const ref = useDetectClickOutside({ onTriggered: closeDropdown });
  // console.log("ddddddd", showcalendar);

  const [copy, setCopy] = useState(false);
  const textCopiedFun2 = () => {
    setCopy(true);
    setTimeout(() => {
      setCopy(false);
    }, 1000);
  };

  const [hoveredElements, setHoveredElements] = useState({
    icon1: false,
    icon2: false,
    icon3: false,
    icon4: false,
    icon5: false,
    icon6: false,
  });
  const handleMouseEnter = (element) => {
    setHoveredElements({ ...hoveredElements, [element]: true });
    const isMobileView = window.innerWidth < 768;
    if (isMobileView) {
      setTimeout(() => {
        setHoveredElements({ ...hoveredElements, [element]: false });
      }, 5000);
    }
  };
  const handleMouseLeave = (element) => {
    setHoveredElements({ ...hoveredElements, [element]: false });
  };

  return (
    <>
      <section className="dashboard">
        <div className="custom-container">
          {user?.role == "mini_agent" ||
          user?.role == "god_agent" ||
          user?.role == "agent" ||
          user?.role == "mega_agent" ||
          user?.role == "super_agent" ? (
            <h3 className="welcomesss">
              Hi {welcome ? welcome : ""} {user ? user?.name : ""} Your code is:
              {copy ? (
                <span className="adadasdasdasdasdasdsad">
                  {" "}
                  {user?.accessCode}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    className=""
                  >
                    <path
                      d="M13 10.5V13.5C13 16 12 17 9.5 17H6.5C4 17 3 16 3 13.5V10.5C3 8 4 7 6.5 7H9.5C12 7 13 8 13 10.5Z"
                      stroke="green"
                      stroke-width="2.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M17 6.5V9.5C17 12 16 13 13.5 13H12.7143V10.7857C12.7143 8.28571 11.7143 7.28571 9.21429 7.28571H7V6.5C7 4 8 3 10.5 3H13.5C16 3 17 4 17 6.5Z"
                      stroke="green"
                      stroke-width="2.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
              ) : (
                <>
                  {user?.accessCode && (
                    <CopyToClipboard
                      text={user?.accessCode}
                      onCopy={textCopiedFun2}
                    >
                      <span className="adadasdasdasdasdasdsad">
                        {user?.accessCode}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          className=""
                        >
                          <path
                            d="M13 10.5V13.5C13 16 12 17 9.5 17H6.5C4 17 3 16 3 13.5V10.5C3 8 4 7 6.5 7H9.5C12 7 13 8 13 10.5Z"
                            stroke="white"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M17 6.5V9.5C17 12 16 13 13.5 13H12.7143V10.7857C12.7143 8.28571 11.7143 7.28571 9.21429 7.28571H7V6.5C7 4 8 3 10.5 3H13.5C16 3 17 4 17 6.5Z"
                            stroke="white"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </span>
                    </CopyToClipboard>
                  )}
                </>
              )}
              {/* <span>
                {user?.accessCode}
                <img
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    navigator.clipboard.writeText(user?.accessCode);
                  }}
                  src="\assets\copy.svg"
                  alt="img"
                  className="img-fluid ms-2"
                />
              </span> */}
            </h3>
          ) : (
            ""
          )}
          {user?.role == "admin" ? (
            <h3 className="welcomesss">Hi {welcome ? welcome : ""}</h3>
          ) : (
            ""
          )}

          <div className="mainbuttonsss">
            <div className="main-heading m-0">
              <h6>Dashboard</h6>
            </div>
            <button className="gusvtsvtvtsvxs" onClick={() => setShow1(true)}>
              Add Leader
            </button>
            {user?.role == "admin" ? (
              <div className="parent-twice-custom">
                <div class="dropdown">
                  <button
                    class="btn btn-secondary dropdown-toggle"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    {round == "" ? "All Rounds" : "Round " + round}
                    <img
                      src="\assets\arrow-down.svg"
                      alt="img"
                      className="img-fluid"
                    />
                  </button>
                  <ul class="dropdown-menu">
                    <li>
                      <a
                        class="dropdown-item"
                        href="#"
                        onClick={() => {
                          setRound("");
                        }}
                      >
                        All Rounds
                      </a>
                    </li>
                    {totalRound?.map((elem, index) => {
                      return (
                        <li
                          onClick={() => {
                            setRound(index + 1);
                          }}
                        >
                          <a class="dropdown-item" href="#">
                            Round {index + 1}
                          </a>
                        </li>
                      );
                    })}
                  </ul>
                </div>
                <div className="custom-tab-bar">
                  <a
                    onClick={() => {
                      setalllset("1");
                      setDataTime("1");
                    }}
                    className={alllset == "1" ? "active" : "noactive"}
                  >
                    1D
                  </a>
                  <a
                    onClick={() => {
                      setalllset("seven");
                      setDataTime("seven");
                    }}
                    className={alllset == "seven" ? "active" : "noactive"}
                  >
                    7D
                  </a>
                  <a
                    onClick={() => {
                      setalllset("month");
                      setDataTime("month");
                    }}
                    className={alllset == "month" ? "active" : "noactive"}
                  >
                    1M
                  </a>
                  <a
                    onClick={() => {
                      setalllset("year");
                      setDataTime("year");
                    }}
                    className={alllset == "year" ? "active" : "noactive"}
                  >
                    1Y
                  </a>
                  <a
                    onClick={() => {
                      setalllset("all");
                      setDataTime("");
                    }}
                    className={alllset == "all" ? "active" : "noactive"}
                  >
                    All
                  </a>
                  <a onClick={() => setShowCalendar(!showcalendar)}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="25"
                      height="24"
                      viewBox="0 0 25 24"
                      fill="none"
                    >
                      <path
                        d="M17.1667 3.56V2C17.1667 1.59 16.8267 1.25 16.4167 1.25C16.0067 1.25 15.6667 1.59 15.6667 2V3.5H9.16673V2C9.16673 1.59 8.82673 1.25 8.41673 1.25C8.00673 1.25 7.66673 1.59 7.66673 2V3.56C4.96673 3.81 3.65673 5.42 3.45673 7.81C3.43673 8.1 3.67673 8.34 3.95673 8.34H20.8767C21.1667 8.34 21.4067 8.09 21.3767 7.81C21.1767 5.42 19.8667 3.81 17.1667 3.56Z"
                        fill="white"
                      />
                      <path
                        d="M20.4167 9.84009H4.41675C3.86675 9.84009 3.41675 10.2901 3.41675 10.8401V17.0001C3.41675 20.0001 4.91675 22.0001 8.41675 22.0001H16.4167C19.9167 22.0001 21.4167 20.0001 21.4167 17.0001V10.8401C21.4167 10.2901 20.9667 9.84009 20.4167 9.84009ZM9.62675 18.2101C9.57675 18.2501 9.52675 18.3001 9.47675 18.3301C9.41675 18.3701 9.35675 18.4001 9.29675 18.4201C9.23675 18.4501 9.17675 18.4701 9.11675 18.4801C9.04675 18.4901 8.98675 18.5001 8.91675 18.5001C8.78675 18.5001 8.65675 18.4701 8.53675 18.4201C8.40675 18.3701 8.30675 18.3001 8.20675 18.2101C8.02675 18.0201 7.91675 17.7601 7.91675 17.5001C7.91675 17.2401 8.02675 16.9801 8.20675 16.7901C8.30675 16.7001 8.40675 16.6301 8.53675 16.5801C8.71675 16.5001 8.91675 16.4801 9.11675 16.5201C9.17675 16.5301 9.23675 16.5501 9.29675 16.5801C9.35675 16.6001 9.41675 16.6301 9.47675 16.6701C9.52675 16.7101 9.57675 16.7501 9.62675 16.7901C9.80675 16.9801 9.91675 17.2401 9.91675 17.5001C9.91675 17.7601 9.80675 18.0201 9.62675 18.2101ZM9.62675 14.7101C9.43675 14.8901 9.17675 15.0001 8.91675 15.0001C8.65675 15.0001 8.39675 14.8901 8.20675 14.7101C8.02675 14.5201 7.91675 14.2601 7.91675 14.0001C7.91675 13.7401 8.02675 13.4801 8.20675 13.2901C8.48675 13.0101 8.92675 12.9201 9.29675 13.0801C9.42675 13.1301 9.53675 13.2001 9.62675 13.2901C9.80675 13.4801 9.91675 13.7401 9.91675 14.0001C9.91675 14.2601 9.80675 14.5201 9.62675 14.7101ZM13.1267 18.2101C12.9367 18.3901 12.6767 18.5001 12.4167 18.5001C12.1567 18.5001 11.8967 18.3901 11.7067 18.2101C11.5267 18.0201 11.4167 17.7601 11.4167 17.5001C11.4167 17.2401 11.5267 16.9801 11.7067 16.7901C12.0767 16.4201 12.7567 16.4201 13.1267 16.7901C13.3067 16.9801 13.4167 17.2401 13.4167 17.5001C13.4167 17.7601 13.3067 18.0201 13.1267 18.2101ZM13.1267 14.7101C13.0767 14.7501 13.0267 14.7901 12.9767 14.8301C12.9167 14.8701 12.8567 14.9001 12.7967 14.9201C12.7367 14.9501 12.6767 14.9701 12.6167 14.9801C12.5467 14.9901 12.4867 15.0001 12.4167 15.0001C12.1567 15.0001 11.8967 14.8901 11.7067 14.7101C11.5267 14.5201 11.4167 14.2601 11.4167 14.0001C11.4167 13.7401 11.5267 13.4801 11.7067 13.2901C11.7967 13.2001 11.9067 13.1301 12.0367 13.0801C12.4067 12.9201 12.8467 13.0101 13.1267 13.2901C13.3067 13.4801 13.4167 13.7401 13.4167 14.0001C13.4167 14.2601 13.3067 14.5201 13.1267 14.7101ZM16.6267 18.2101C16.4367 18.3901 16.1767 18.5001 15.9167 18.5001C15.6567 18.5001 15.3967 18.3901 15.2067 18.2101C15.0267 18.0201 14.9167 17.7601 14.9167 17.5001C14.9167 17.2401 15.0267 16.9801 15.2067 16.7901C15.5767 16.4201 16.2567 16.4201 16.6267 16.7901C16.8067 16.9801 16.9167 17.2401 16.9167 17.5001C16.9167 17.7601 16.8067 18.0201 16.6267 18.2101ZM16.6267 14.7101C16.5767 14.7501 16.5267 14.7901 16.4767 14.8301C16.4167 14.8701 16.3567 14.9001 16.2967 14.9201C16.2367 14.9501 16.1767 14.9701 16.1167 14.9801C16.0467 14.9901 15.9767 15.0001 15.9167 15.0001C15.6567 15.0001 15.3967 14.8901 15.2067 14.7101C15.0267 14.5201 14.9167 14.2601 14.9167 14.0001C14.9167 13.7401 15.0267 13.4801 15.2067 13.2901C15.3067 13.2001 15.4067 13.1301 15.5367 13.0801C15.7167 13.0001 15.9167 12.9801 16.1167 13.0201C16.1767 13.0301 16.2367 13.0501 16.2967 13.0801C16.3567 13.1001 16.4167 13.1301 16.4767 13.1701C16.5267 13.2101 16.5767 13.2501 16.6267 13.2901C16.8067 13.4801 16.9167 13.7401 16.9167 14.0001C16.9167 14.2601 16.8067 14.5201 16.6267 14.7101Z"
                        fill="white"
                      />
                    </svg>
                  </a>
                  {/* {showcalendar && ( */}
                  {showcalendar && (
                    <div className="cal set-custom-calendar-div">
                      <DateRange
                        editableDateInputs={true}
                        onChange={(item) => {
                          GetChartsDataCalendar([item.selection]);
                          GetDashboardData([item.selection]);

                          if (activeTab == "profile-tab") {
                            GetTopTenLeaders1([item.selection]);
                          } else if (activeTab == "top-three") {
                            GetTopThreeData1([item.selection]);
                          } else {
                            GetTopTenData1([item.selection]);
                          }
                        }}
                        moveRangeOnFirstSelection={false}
                        ranges={state}
                      />
                    </div>
                  )}

                  {/* )} */}
                  {/* {showcalendar && (
                  <div className="cal set-custom-calendar-div" ref={ref}>
                    <DateRange
                      editableDateInputs={true}
                      onChange={(item) => GetDashboardData([item.selection])}
                      moveRangeOnFirstSelection={false}
                      ranges={state}
                    />
                  </div>
                )} */}
                </div>
              </div>
            ) : (
              <div className="custom-tab-bar">
                <a
                  onClick={() => {
                    setalllset("1");
                    GetDashboardDataMyUsers1("1");
                    setDataTimeTop("1");
                  }}
                  className={alllset == "1" ? "active" : "noactive"}
                >
                  1D
                </a>
                <a
                  onClick={() => {
                    setalllset("seven");
                    GetDashboardDataMyUsers1("seven");
                    setDataTimeTop("seven");
                  }}
                  className={alllset == "seven" ? "active" : "noactive"}
                >
                  7D
                </a>
                <a
                  onClick={() => {
                    setalllset("month");
                    GetDashboardDataMyUsers1("month");
                    setDataTimeTop("month");
                  }}
                  className={alllset == "month" ? "active" : "noactive"}
                >
                  1M
                </a>
                <a
                  onClick={() => {
                    setalllset("year");
                    GetDashboardDataMyUsers1("year");
                    setDataTimeTop("year");
                  }}
                  className={alllset == "year" ? "active" : "noactive"}
                >
                  1Y
                </a>
                <a
                  onClick={() => {
                    setalllset("all");
                    setDataTimeTop("");
                    GetMyData();
                    setDataTimeTop("");
                  }}
                  className={alllset == "all" ? "active" : "noactive"}
                >
                  All
                </a>
                <a onClick={() => setShowCalendar(!showcalendar)}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="24"
                    viewBox="0 0 25 24"
                    fill="none"
                  >
                    <path
                      d="M17.1667 3.56V2C17.1667 1.59 16.8267 1.25 16.4167 1.25C16.0067 1.25 15.6667 1.59 15.6667 2V3.5H9.16673V2C9.16673 1.59 8.82673 1.25 8.41673 1.25C8.00673 1.25 7.66673 1.59 7.66673 2V3.56C4.96673 3.81 3.65673 5.42 3.45673 7.81C3.43673 8.1 3.67673 8.34 3.95673 8.34H20.8767C21.1667 8.34 21.4067 8.09 21.3767 7.81C21.1767 5.42 19.8667 3.81 17.1667 3.56Z"
                      fill="white"
                    />
                    <path
                      d="M20.4167 9.84009H4.41675C3.86675 9.84009 3.41675 10.2901 3.41675 10.8401V17.0001C3.41675 20.0001 4.91675 22.0001 8.41675 22.0001H16.4167C19.9167 22.0001 21.4167 20.0001 21.4167 17.0001V10.8401C21.4167 10.2901 20.9667 9.84009 20.4167 9.84009ZM9.62675 18.2101C9.57675 18.2501 9.52675 18.3001 9.47675 18.3301C9.41675 18.3701 9.35675 18.4001 9.29675 18.4201C9.23675 18.4501 9.17675 18.4701 9.11675 18.4801C9.04675 18.4901 8.98675 18.5001 8.91675 18.5001C8.78675 18.5001 8.65675 18.4701 8.53675 18.4201C8.40675 18.3701 8.30675 18.3001 8.20675 18.2101C8.02675 18.0201 7.91675 17.7601 7.91675 17.5001C7.91675 17.2401 8.02675 16.9801 8.20675 16.7901C8.30675 16.7001 8.40675 16.6301 8.53675 16.5801C8.71675 16.5001 8.91675 16.4801 9.11675 16.5201C9.17675 16.5301 9.23675 16.5501 9.29675 16.5801C9.35675 16.6001 9.41675 16.6301 9.47675 16.6701C9.52675 16.7101 9.57675 16.7501 9.62675 16.7901C9.80675 16.9801 9.91675 17.2401 9.91675 17.5001C9.91675 17.7601 9.80675 18.0201 9.62675 18.2101ZM9.62675 14.7101C9.43675 14.8901 9.17675 15.0001 8.91675 15.0001C8.65675 15.0001 8.39675 14.8901 8.20675 14.7101C8.02675 14.5201 7.91675 14.2601 7.91675 14.0001C7.91675 13.7401 8.02675 13.4801 8.20675 13.2901C8.48675 13.0101 8.92675 12.9201 9.29675 13.0801C9.42675 13.1301 9.53675 13.2001 9.62675 13.2901C9.80675 13.4801 9.91675 13.7401 9.91675 14.0001C9.91675 14.2601 9.80675 14.5201 9.62675 14.7101ZM13.1267 18.2101C12.9367 18.3901 12.6767 18.5001 12.4167 18.5001C12.1567 18.5001 11.8967 18.3901 11.7067 18.2101C11.5267 18.0201 11.4167 17.7601 11.4167 17.5001C11.4167 17.2401 11.5267 16.9801 11.7067 16.7901C12.0767 16.4201 12.7567 16.4201 13.1267 16.7901C13.3067 16.9801 13.4167 17.2401 13.4167 17.5001C13.4167 17.7601 13.3067 18.0201 13.1267 18.2101ZM13.1267 14.7101C13.0767 14.7501 13.0267 14.7901 12.9767 14.8301C12.9167 14.8701 12.8567 14.9001 12.7967 14.9201C12.7367 14.9501 12.6767 14.9701 12.6167 14.9801C12.5467 14.9901 12.4867 15.0001 12.4167 15.0001C12.1567 15.0001 11.8967 14.8901 11.7067 14.7101C11.5267 14.5201 11.4167 14.2601 11.4167 14.0001C11.4167 13.7401 11.5267 13.4801 11.7067 13.2901C11.7967 13.2001 11.9067 13.1301 12.0367 13.0801C12.4067 12.9201 12.8467 13.0101 13.1267 13.2901C13.3067 13.4801 13.4167 13.7401 13.4167 14.0001C13.4167 14.2601 13.3067 14.5201 13.1267 14.7101ZM16.6267 18.2101C16.4367 18.3901 16.1767 18.5001 15.9167 18.5001C15.6567 18.5001 15.3967 18.3901 15.2067 18.2101C15.0267 18.0201 14.9167 17.7601 14.9167 17.5001C14.9167 17.2401 15.0267 16.9801 15.2067 16.7901C15.5767 16.4201 16.2567 16.4201 16.6267 16.7901C16.8067 16.9801 16.9167 17.2401 16.9167 17.5001C16.9167 17.7601 16.8067 18.0201 16.6267 18.2101ZM16.6267 14.7101C16.5767 14.7501 16.5267 14.7901 16.4767 14.8301C16.4167 14.8701 16.3567 14.9001 16.2967 14.9201C16.2367 14.9501 16.1767 14.9701 16.1167 14.9801C16.0467 14.9901 15.9767 15.0001 15.9167 15.0001C15.6567 15.0001 15.3967 14.8901 15.2067 14.7101C15.0267 14.5201 14.9167 14.2601 14.9167 14.0001C14.9167 13.7401 15.0267 13.4801 15.2067 13.2901C15.3067 13.2001 15.4067 13.1301 15.5367 13.0801C15.7167 13.0001 15.9167 12.9801 16.1167 13.0201C16.1767 13.0301 16.2367 13.0501 16.2967 13.0801C16.3567 13.1001 16.4167 13.1301 16.4767 13.1701C16.5267 13.2101 16.5767 13.2501 16.6267 13.2901C16.8067 13.4801 16.9167 13.7401 16.9167 14.0001C16.9167 14.2601 16.8067 14.5201 16.6267 14.7101Z"
                      fill="white"
                    />
                  </svg>
                </a>
                {/* {showcalendar && ( */}
                {showcalendar && (
                  <div className="cal set-custom-calendar-div">
                    <DateRange
                      editableDateInputs={true}
                      onChange={(item) => {
                        GetDashboardDataMyUsers([item.selection]);
                        if (activeTab == "profile-tab") {
                          GetTopTenLeaders1([item.selection]);
                        } else if (activeTab == "top-three") {
                          GetTopThreeData1([item.selection]);
                        } else {
                          GetTopTenData1([item.selection]);
                        }
                      }}
                      moveRangeOnFirstSelection={false}
                      ranges={state}
                    />
                  </div>
                )}

                {/* )} */}
                {/* {showcalendar && (
                  <div className="cal set-custom-calendar-div" ref={ref}>
                    <DateRange
                      editableDateInputs={true}
                      onChange={(item) =>
                        GetDashboardDataMyUsers([item.selection])
                      }
                      moveRangeOnFirstSelection={false}
                      ranges={state}
                    />
                  </div>
                )} */}
              </div>
            )}
          </div>

          {user?.role == "admin" ? (
            <div className="bottom-cards">
              <div className="single-card">
                <img
                  src="\assets\dashboard\noofpurchases.svg"
                  alt="img"
                  className="img-fluid"
                />
                <p>No. of Purchases</p>
                <h6>
                  {adminobj ? adminobj?.TotalPurchases : 0}{" "}
                  <span
                    className={pc > 0 ? "green-text ms-2" : "red-text ms-2"}
                  >
                    {pc ? pc.toFixed(1) + "% " : ""}
                  </span>
                </h6>
                <div className="bottom-text">
                  {/* <p className="uni-text">
                    <span></span>
                    {tokenNftStats
                      ? tokenNftStats?.tokensPurchasesCount?.toFixed(4)
                      : 0}{" "}
                    Token
                  </p> */}
                  {/* <p className="uni-text">
                    <span></span>
                    {tokenNftStats
                      ? parseInt(
                          tokenNftStats?.nftPurchasesCount?.toFixed(2)
                        )?.toLocaleString("en-US")
                      : 0}{" "}
                    NFT
                  </p> */}
                </div>
              </div>
              <div className="single-card" style={{ overflow: "hidden" }}>
                <img
                  src="\gemslogo.svg"
                  alt="img"
                  className="gems-logo-img"
                  style={{ width: "35px", height: "35px", overflow: "hidden" }}
                />
                <p>GEMS Purchased</p>
                <h6>
                  {adminobj?.totalDopPurchased
                    ? parseFloat(
                        (
                          (tokenNftStats?.stats?.length > 0
                            ? tokenNftStats.stats[0]?.totalDopPurchased
                            : 0) +
                          (tokenNftStats?.nftStats?.length > 0
                            ? tokenNftStats.nftStats[0]?.totalDopPurchased
                            : 0)
                        ).toFixed(2)
                      )?.toLocaleString("en-US")
                    : 0}
                  &nbsp;GEMS{" "}
                  <span className={dpc > 0 ? "green-text" : "red-text"}>
                    {dpc ? dpc.toFixed(1) + "% " : ""}
                  </span>
                </h6>
                <div className="bottom-text">
                  <p className="uni-text">
                    <span></span>
                    {tokenNftStats
                      ? parseFloat(
                          tokenNftStats?.stats[0]?.totalDopPurchased?.toFixed(4)
                        )?.toLocaleString("en-US")
                      : 0}{" "}
                    Token
                  </p>
                  <p className="uni-text">
                    <span></span>
                    {tokenNftStats?.nftStats?.length > 0
                      ? parseInt(
                          tokenNftStats?.nftStats[0]?.totalDopPurchased?.toFixed(
                            2
                          )
                        )?.toLocaleString("en-US")
                      : 0}{" "}
                    NFT
                  </p>
                </div>
                {/* <div className="bottom-text">
                  <p className="uni-text">
                    <span></span>~
                    {dops ? ((dops?.eth + dops?.us) * dopPrice)?.toFixed(2) : 0}{" "}
                    USD
                  </p>
                </div> */}
              </div>
              <div className="single-card">
                <img
                  src="\assets\dashboard\purchasedamount.svg"
                  alt="img"
                  className="img-fluid"
                />
                <p>Purchased Amount</p>
                {usdPrice ? (
                  <h6 className="datahead">
                    {adminobj?.totalPurchaseUsdt ||
                    adminobj?.totalPurchaseEth ||
                    adminobj?.totalPurchaseTomi ||
                    adminobj?.totalPurchaseWbtc ||
                    adminobj?.totalPurchaseUsdc
                      ? "~$" +
                        parseInt(
                          (
                            usdPrice * adminobj?.totalPurchaseEth +
                            adminobj?.totalPurchaseUsdt +
                            // tomiPrice * adminobj?.totalPurchaseTomi +
                            btcPrice * adminobj?.totalPurchaseWbtc +
                            adminobj?.totalPurchaseUsdc
                          )?.toFixed(2)
                        ).toLocaleString("en-US")
                      : 0}{" "}
                    <span className={pmc > 0 ? "green-text" : "red-text"}>
                      {pmc ? pmc.toFixed(1) + "% " : ""}
                    </span>
                  </h6>
                ) : (
                  <h6 className="datahead">~$0.00 USD</h6>
                )}
                <div className="bottom-text">
                  <p className="uni-text">
                    <span></span>
                    {adminobj ? adminobj?.totalPurchaseEth?.toFixed(4) : 0} ETH
                  </p>
                  <p className="uni-text">
                    <span></span>
                    {adminobj
                      ? parseInt(
                          adminobj?.totalPurchaseUsdt?.toFixed(2)
                        )?.toLocaleString("en-US")
                      : 0}{" "}
                    USDT
                  </p>
                  {/* <p className="uni-text">
                    <span></span>
                    {adminobj
                      ? parseInt(
                          adminobj?.totalPurchaseTomi?.toFixed(2)
                        )?.toLocaleString("en-US")
                      : 0}{" "}
                    TOMI
                  </p> */}
                  <p className="uni-text">
                    <span></span>
                    {adminobj
                      ? parseFloat(
                          adminobj?.totalPurchaseWbtc?.toFixed(5)
                        )?.toLocaleString("en-US")
                      : 0}{" "}
                    WBTC
                  </p>
                  <p className="uni-text">
                    <span></span>
                    {adminobj
                      ? parseInt(
                          adminobj?.totalPurchaseUsdc?.toFixed(2)
                        )?.toLocaleString("en-US")
                      : 0}{" "}
                    USDC
                  </p>
                </div>
              </div>
              <div className="single-card">
                <img
                  src="\assets\dashboard\agentearning.svg"
                  alt="img"
                  className="img-fluid"
                />
                <p>Leader's Earnings</p>
                {/* <h6>~50,000 USD</h6> */}
                {usdPrice ? (
                  <h6 className="datahead">
                    {adminobj?.totalLeaderEarningsEth ||
                    adminobj?.totalLeaderEarningsUsdt ||
                    adminobj?.totalLeaderEarningsTomi ||
                    adminobj?.totalLeaderEarningsWbtc ||
                    adminobj?.totalLeaderEarningsUsdc
                      ? "~$" +
                        parseFloat(
                          (
                            usdPrice * adminobj?.totalLeaderEarningsEth +
                            adminobj?.totalLeaderEarningsUsdt +
                            // tomiPrice * adminobj?.totalLeaderEarningsTomi +
                            btcPrice * adminobj?.totalLeaderEarningsWbtc +
                            adminobj?.totalLeaderEarningsUsdc
                          )?.toFixed(2)
                        ).toLocaleString("en-US")
                      : 0}{" "}
                    <span className={lec > 0 ? "green-text" : "red-text"}>
                      {lec ? lec.toFixed(1) + "% " : ""}
                    </span>
                  </h6>
                ) : (
                  <h6 className="datahead">~$0.00 USD</h6>
                )}
                <div className="bottom-text">
                  <p className="uni-text">
                    <span></span>
                    {adminobj
                      ? adminobj?.totalLeaderEarningsEth.toFixed(4)
                      : ""}{" "}
                    ETH
                  </p>
                  <p className="uni-text">
                    <span></span>
                    {adminobj
                      ? parseInt(
                          adminobj?.totalLeaderEarningsUsdt?.toFixed(2)
                        )?.toLocaleString("en-US")
                      : 0}{" "}
                    USDT
                  </p>
                  {/* <p className="uni-text">
                    <span></span>
                    {adminobj
                      ? parseInt(
                          adminobj?.totalLeaderEarningsTomi?.toFixed(2)
                        )?.toLocaleString("en-US")
                      : 0}{" "}
                    TOMI
                  </p> */}
                  <p className="uni-text">
                    <span></span>
                    {adminobj
                      ? parseFloat(
                          adminobj?.totalLeaderEarningsWbtc?.toFixed(5)
                        )?.toLocaleString("en-US")
                      : 0}{" "}
                    WBTC
                  </p>
                  <p className="uni-text">
                    <span></span>
                    {adminobj
                      ? parseInt(
                          adminobj?.totalLeaderEarningsUsdc?.toFixed(2)
                        )?.toLocaleString("en-US")
                      : 0}{" "}
                    USDC
                  </p>
                </div>
              </div>
              {user?.role === "admin" ? (
                <>
                  <div className="single-card mobile-spec-height noofleaders-card ordersetsm2">
                    <img
                      src="\assets\dashboard\noofagents.svg"
                      alt="img"
                      className="img-fluid"
                    />
                    <p>Leaders/Active Leaders</p>
                    <div
                      className="twice-textbtn"
                      onClick={() => SetShowtext(!showtext)}
                    >
                      <h6>
                        {totalleader ? totalleader : 0} /{" "}
                        {activeleader ? activeleader : 0}
                        <span
                          className={
                            lc > 0 ? "green-text ms-2" : "red-text ms-2"
                          }
                        >
                          {lc ? lc.toFixed(1) + "% " : ""}
                        </span>
                      </h6>
                      <img
                        src="\assets\arrow-down.svg"
                        alt="img"
                        className={
                          showtext
                            ? "img-fluid arrow-down-icon transform-img d-none displayblockinmobile"
                            : "img-fluid arrow-down-icon d-none displayblockinmobile"
                        }
                      />
                    </div>
                    <div
                      className={
                        showtext
                          ? "bottom-text showtext"
                          : "bottom-text hidetext"
                      }
                    >
                      <p className="uni-text">
                        <span></span>
                        {g ? g : 0} God{" "}
                      </p>
                      <p className="uni-text">
                        <span></span>
                        {m ? m : 0} Mega{" "}
                      </p>
                      <p className="uni-text">
                        <span></span>
                        {s ? s : 0} Super{" "}
                      </p>
                      <p className="uni-text">
                        <span></span>
                        {a ? a : 0} Leader{" "}
                      </p>
                      <p className="uni-text">
                        <span></span>
                        {gmini ? gmini : 0} Ambassador{" "}
                      </p>
                      {/* <p className='uni-text'><span></span>0 Mega </p>
                    <p className='uni-text'><span></span>0 Super </p>
                    <p className='uni-text'><span></span>0 Agent  </p>
                    <p className='uni-text'><span></span>0 God  </p> */}
                    </div>
                  </div>
                  <div className="single-card mobile-spec-height ordersetsm1">
                    <img
                      src="\assets\dashboard\netrevenue.svg"
                      alt="img"
                      className="img-fluid"
                    />
                    <p>Net Revenue</p>
                    {usdPrice ? (
                      <h6 className="datahead">
                        {adminobj?.totalPurchaseEth ||
                        adminobj?.totalPurchaseUsdt ||
                        adminobj?.totalPurchaseTomi ||
                        adminobj?.totalPurchaseWbtc ||
                        adminobj?.totalPurchaseUsdc
                          ? "~$" +
                            parseInt(
                              (
                                usdPrice *
                                  (adminobj?.totalPurchaseEth -
                                    adminobj?.totalLeaderEarningsEth) +
                                (adminobj?.totalPurchaseUsdt -
                                  adminobj?.totalLeaderEarningsUsdt) +
                                tomiPrice *
                                  (adminobj?.totalPurchaseTomi -
                                    adminobj?.totalLeaderEarningsTomi) +
                                btcPrice *
                                  (adminobj?.totalPurchaseWbtc -
                                    adminobj?.totalLeaderEarningsWbtc) +
                                (adminobj?.totalPurchaseUsdc -
                                  adminobj?.totalLeaderEarningsUsdc)
                              )?.toFixed(2)
                            ).toLocaleString("en-US")
                          : 0}{" "}
                        <span className={lec > 0 ? "green-text" : "red-text"}>
                          {lec ? lec.toFixed(1) + "% " : ""}
                        </span>
                      </h6>
                    ) : (
                      <h6 className="datahead">~$0.00 USD </h6>
                    )}
                    <div className="bottom-text">
                      <p className="uni-text">
                        <span></span>
                        {adminobj
                          ? (
                              adminobj?.totalPurchaseEth -
                              adminobj?.totalLeaderEarningsEth
                            ).toFixed(5)
                          : 0}{" "}
                        ETH
                      </p>
                      <p className="uni-text">
                        <span></span>
                        {adminobj
                          ? parseInt(
                              adminobj?.totalPurchaseUsdt -
                                adminobj?.totalLeaderEarningsUsdt
                            )?.toLocaleString("en-US")
                          : 0}{" "}
                        USDT
                      </p>
                      {/* <p className="uni-text">
                        <span></span>
                        {adminobj
                          ? parseInt(
                              adminobj?.totalPurchaseTomi -
                                adminobj?.totalLeaderEarningsTomi
                            )?.toLocaleString("en-US")
                          : 0}{" "}
                        TOMI
                      </p> */}
                      <p className="uni-text">
                        <span></span>
                        {adminobj
                          ? parseFloat(
                              (
                                adminobj?.totalPurchaseWbtc -
                                adminobj?.totalLeaderEarningsWbtc
                              )?.toFixed(5)
                            )?.toLocaleString("en-US")
                          : 0}{" "}
                        WBTC
                      </p>{" "}
                      <p className="uni-text">
                        <span></span>
                        {adminobj
                          ? parseInt(
                              adminobj?.totalPurchaseUsdc -
                                adminobj?.totalLeaderEarningsUsdc
                            )?.toLocaleString("en-US")
                          : 0}{" "}
                        USDC
                      </p>
                    </div>
                  </div>
                </>
              ) : (
                ""
              )}
            </div>
          ) : (
            <div
              className={
                user?.role == "mini_agent"
                  ? "bottom-cards dtfdttcdvt6dtvd newclassagent"
                  : user?.role == "god_agent" &&
                    specialAccess &&
                    specialAccess?.length > 0
                  ? "bottom-cards"
                  : "bottom-cards dtfdttcdvt6dtvd"
              }
            >
              {user?.role == "mini_agent" ? (
                ""
              ) : (
                <div className="single-card">
                  <img
                    src="\assets\dashboard\numberoflader.svg"
                    alt="img"
                    className="img-fluid"
                  />
                  {/* {user?.role == "god_agent" &&
                  specialAccess &&
                  specialAccess?.length > 0 ? (
                    <div>
                      <a
                        className="custom-tooltip-ico"
                        onMouseEnter={() => handleMouseEnter("icon5")}
                        onMouseLeave={() => handleMouseLeave("icon5")}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="18"
                          viewBox="0 0 18 18"
                          fill="none"
                        >
                          <path
                            d="M10.25 13.0625C10.25 13.3097 10.1767 13.5514 10.0393 13.757C9.90199 13.9625 9.70677 14.1227 9.47836 14.2174C9.24995 14.312 8.99862 14.3367 8.75614 14.2885C8.51366 14.2403 8.29094 14.1212 8.11612 13.9464C7.9413 13.7716 7.82225 13.5488 7.77402 13.3064C7.72579 13.0639 7.75054 12.8126 7.84515 12.5841C7.93976 12.3557 8.09998 12.1605 8.30554 12.0232C8.5111 11.8858 8.75278 11.8125 9 11.8125C9.33152 11.8125 9.64947 11.9442 9.88389 12.1786C10.1183 12.413 10.25 12.731 10.25 13.0625ZM17.4375 9C17.4375 10.6688 16.9427 12.3001 16.0155 13.6876C15.0884 15.0752 13.7706 16.1566 12.2289 16.7952C10.6871 17.4338 8.99064 17.6009 7.35393 17.2754C5.71721 16.9498 4.2138 16.1462 3.03379 14.9662C1.85379 13.7862 1.05019 12.2828 0.724628 10.6461C0.399065 9.00936 0.566156 7.31286 1.20477 5.77111C1.84338 4.22936 2.92484 2.9116 4.31238 1.98448C5.69992 1.05735 7.33122 0.5625 9 0.5625C11.237 0.564981 13.3817 1.45473 14.9635 3.03653C16.5453 4.61833 17.435 6.763 17.4375 9ZM15.5625 9C15.5625 7.70206 15.1776 6.43327 14.4565 5.35407C13.7354 4.27487 12.7105 3.43374 11.5114 2.93704C10.3122 2.44034 8.99272 2.31038 7.71972 2.5636C6.44672 2.81681 5.2774 3.44183 4.35962 4.35961C3.44183 5.27739 2.81682 6.44672 2.5636 7.71972C2.31038 8.99272 2.44034 10.3122 2.93704 11.5114C3.43374 12.7105 4.27488 13.7354 5.35407 14.4565C6.43327 15.1776 7.70206 15.5625 9 15.5625C10.7399 15.5606 12.408 14.8686 13.6383 13.6383C14.8686 12.408 15.5606 10.7399 15.5625 9ZM9 4C7.10469 4 5.5625 5.40156 5.5625 7.125V7.4375C5.5625 7.68614 5.66128 7.9246 5.83709 8.10041C6.01291 8.27623 6.25136 8.375 6.5 8.375C6.74864 8.375 6.9871 8.27623 7.16292 8.10041C7.33873 7.9246 7.4375 7.68614 7.4375 7.4375V7.125C7.4375 6.43594 8.14063 5.875 9 5.875C9.85938 5.875 10.5625 6.43594 10.5625 7.125C10.5625 7.81406 9.85938 8.375 9 8.375C8.75136 8.375 8.51291 8.47377 8.33709 8.64959C8.16128 8.8254 8.0625 9.06386 8.0625 9.3125V9.9375C8.06194 10.1691 8.14715 10.3927 8.30169 10.5653C8.45623 10.7378 8.66916 10.847 8.89945 10.8719C9.12973 10.8967 9.36106 10.8354 9.54884 10.6998C9.73662 10.5642 9.86756 10.3639 9.91641 10.1375C11.368 9.77187 12.4375 8.56016 12.4375 7.125C12.4375 5.40156 10.8953 4 9 4Z"
                            fill="white"
                          />
                        </svg>
                      </a>
                      {hoveredElements.icon5 && (
                        <div className="set-custom-tooltip">
                          <div className="inner-text">
                            <h6>My tree:</h6>
                            <h6 className="mt-2">
                              {(gg ? gg : 0) +
                                (mm ? mm : 0) +
                                (ss ? ss : 0) +
                                (ggmini ? ggmini : 0)}
                            </h6>
                            <div className="bottom-twice">
                              <p>
                                <span></span> {mm ? mm : 0} Mega{" "}
                              </p>
                              <p>
                                <span></span>
                                {ss ? ss : 0} Super
                              </p>
                              <p>
                                <span></span>
                                {gg ? gg : 0}{" "}
                                {gg == 1 || gg == 0 ? "Leader" : "Leaders"}
                              </p>
                              <p>
                                <span></span> {ggmini ? ggmini : 0} Ambassador s
                              </p>
                            </div>
                          </div>
                          <div className="inner-text">
                            <h6>Other Leaders:</h6>
                            <h6 className="mt-2">
                              {specialAccess ? specialAccess?.length : 0}
                            </h6>
                            <div className="bottom-twice">
                              <p>
                                <span></span>{" "}
                                {specialAccess ? specialAccess?.length : 0} God{" "}
                              </p>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  ) : null} */}
                  <p>Leaders/Active Leaders</p>
                  {user?.role === "god_agent" ? (
                    <>
                      <h6>
                        {(specialAccess ? specialAccess?.length : 0) +
                          (gg ? gg : 0) +
                          (mm ? mm : 0) +
                          (ss ? ss : 0) +
                          (ggmini ? ggmini : 0)}
                        /{activeleader ? activeleader : 0}
                        <span
                          className={lc ? "green-text ms-2" : "red-text ms-2"}
                        >
                          {lc ? lc.toFixed(1) + "% " : ""}
                        </span>
                      </h6>
                      <div className="bottom-text">
                        {specialAccess && specialAccess?.length > 0 ? (
                          <p className="uni-text">
                            <span></span>
                            {specialAccess ? specialAccess?.length : 0} God{" "}
                          </p>
                        ) : null}

                        <p className="uni-text">
                          <span></span>
                          {mm ? mm : 0} Mega
                        </p>
                        <p className="uni-text">
                          <span></span>
                          {ss ? ss : 0} Super
                        </p>
                        <p className="uni-text">
                          <span></span>
                          {gg ? gg : 0}{" "}
                          {gg == 1 || gg == 0 ? "Leader" : "Leaders"}
                        </p>
                        <p className="uni-text">
                          <span></span>
                          {ggmini ? ggmini : 0} Ambassador{" "}
                        </p>
                      </div>
                    </>
                  ) : user?.role === "mega_agent" ? (
                    <>
                      <h6>
                        {(gg ? gg : 0) + (ss ? ss : 0) + (ggmini ? ggmini : 0)}{" "}
                        /{activeleader ? activeleader : 0}
                      </h6>
                      <div className="bottom-text">
                        <p className="uni-text">
                          <span></span>
                          {ss ? ss : 0} Super
                        </p>
                        <p className="uni-text">
                          <span></span>
                          {gg ? gg : 0}{" "}
                          {gg == 1 || gg == 0 ? "Leader" : "Leaders"}
                        </p>
                        <p className="uni-text">
                          <span></span>
                          {ggmini ? ggmini : 0} Ambassador{" "}
                        </p>
                      </div>
                    </>
                  ) : user?.role === "super_agent" ? (
                    <>
                      <h6>
                        {(gg ? gg : 0) + (ggmini ? ggmini : 0)} /
                        {activeleader ? activeleader : 0}
                      </h6>
                      <div className="bottom-text">
                        <p className="uni-text">
                          <span></span>
                          {gg ? gg : 0}{" "}
                          {gg == 1 || gg == 0 ? "Leader" : "Leaders"}
                        </p>
                        <p className="uni-text">
                          <span></span>
                          {ggmini ? ggmini : 0} Ambassador{" "}
                        </p>
                      </div>
                    </>
                  ) : user?.role === "agent" ? (
                    <>
                      <h6>
                        {ggmini ? ggmini : 0} /{activeleader ? activeleader : 0}
                      </h6>
                      <div className="bottom-text">
                        <p className="uni-text">
                          <span></span>
                          {ggmini ? ggmini : 0} Ambassador{" "}
                        </p>
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                </div>
              )}
              <div className="single-card">
                <img
                  src="\assets\dashboard\noofpurchases.svg"
                  alt="img"
                  className="img-fluid"
                />
                {/* {user?.role == "god_agent" &&
                specialAccess &&
                specialAccess?.length > 0 ? (
                  <div>
                    <a
                      className="custom-tooltip-ico"
                      onMouseEnter={() => handleMouseEnter("icon1")}
                      onMouseLeave={() => handleMouseLeave("icon1")}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                      >
                        <path
                          d="M10.25 13.0625C10.25 13.3097 10.1767 13.5514 10.0393 13.757C9.90199 13.9625 9.70677 14.1227 9.47836 14.2174C9.24995 14.312 8.99862 14.3367 8.75614 14.2885C8.51366 14.2403 8.29094 14.1212 8.11612 13.9464C7.9413 13.7716 7.82225 13.5488 7.77402 13.3064C7.72579 13.0639 7.75054 12.8126 7.84515 12.5841C7.93976 12.3557 8.09998 12.1605 8.30554 12.0232C8.5111 11.8858 8.75278 11.8125 9 11.8125C9.33152 11.8125 9.64947 11.9442 9.88389 12.1786C10.1183 12.413 10.25 12.731 10.25 13.0625ZM17.4375 9C17.4375 10.6688 16.9427 12.3001 16.0155 13.6876C15.0884 15.0752 13.7706 16.1566 12.2289 16.7952C10.6871 17.4338 8.99064 17.6009 7.35393 17.2754C5.71721 16.9498 4.2138 16.1462 3.03379 14.9662C1.85379 13.7862 1.05019 12.2828 0.724628 10.6461C0.399065 9.00936 0.566156 7.31286 1.20477 5.77111C1.84338 4.22936 2.92484 2.9116 4.31238 1.98448C5.69992 1.05735 7.33122 0.5625 9 0.5625C11.237 0.564981 13.3817 1.45473 14.9635 3.03653C16.5453 4.61833 17.435 6.763 17.4375 9ZM15.5625 9C15.5625 7.70206 15.1776 6.43327 14.4565 5.35407C13.7354 4.27487 12.7105 3.43374 11.5114 2.93704C10.3122 2.44034 8.99272 2.31038 7.71972 2.5636C6.44672 2.81681 5.2774 3.44183 4.35962 4.35961C3.44183 5.27739 2.81682 6.44672 2.5636 7.71972C2.31038 8.99272 2.44034 10.3122 2.93704 11.5114C3.43374 12.7105 4.27488 13.7354 5.35407 14.4565C6.43327 15.1776 7.70206 15.5625 9 15.5625C10.7399 15.5606 12.408 14.8686 13.6383 13.6383C14.8686 12.408 15.5606 10.7399 15.5625 9ZM9 4C7.10469 4 5.5625 5.40156 5.5625 7.125V7.4375C5.5625 7.68614 5.66128 7.9246 5.83709 8.10041C6.01291 8.27623 6.25136 8.375 6.5 8.375C6.74864 8.375 6.9871 8.27623 7.16292 8.10041C7.33873 7.9246 7.4375 7.68614 7.4375 7.4375V7.125C7.4375 6.43594 8.14063 5.875 9 5.875C9.85938 5.875 10.5625 6.43594 10.5625 7.125C10.5625 7.81406 9.85938 8.375 9 8.375C8.75136 8.375 8.51291 8.47377 8.33709 8.64959C8.16128 8.8254 8.0625 9.06386 8.0625 9.3125V9.9375C8.06194 10.1691 8.14715 10.3927 8.30169 10.5653C8.45623 10.7378 8.66916 10.847 8.89945 10.8719C9.12973 10.8967 9.36106 10.8354 9.54884 10.6998C9.73662 10.5642 9.86756 10.3639 9.91641 10.1375C11.368 9.77187 12.4375 8.56016 12.4375 7.125C12.4375 5.40156 10.8953 4 9 4Z"
                          fill="white"
                        />
                      </svg>
                    </a>
                    {hoveredElements.icon1 && (
                      <div className="set-custom-tooltip">
                        <div className="inner-text">
                          <h6>My tree:</h6>
                          <h6 className="mt-2">
                            {myTree[0]?.myTreeTotalPurchases}
                          </h6>
                        </div>
                        <div className="inner-text">
                          <h6>Other Leaders:</h6>
                          <h6 className="mt-2">
                            {otherLeaders[0]?.otherLeadersTotalPurchases}
                          </h6>
                        </div>
                      </div>
                    )}
                  </div>
                ) : null} */}
                <p>Number of Purchases</p>
                <h6>
                  {totPurchases +
                    (otherLeaders && otherLeaders?.length > 0
                      ? otherLeaders[0]?.otherLeadersTotalPurchases
                      : 0)}{" "}
                  <span className={pc > 0 ? "green-text" : "red-text"}>
                    {pc ? pc.toFixed(1) + "% " : ""}
                  </span>
                </h6>
                <div className="bottom-text">
                  {/* <p className="uni-text">
                    <span></span>
                    {tokenNftStats
                      ? tokenNftStats?.tokensPurchasesCount?.toFixed(4)
                      : 0}{" "}
                    Token
                  </p> */}
                  {/* <p className="uni-text">
                    <span></span>
                    {tokenNftStats
                      ? parseInt(
                          tokenNftStats?.nftPurchasesCount?.toFixed(2)
                        )?.toLocaleString("en-US")
                      : 0}{" "}
                    NFT
                  </p> */}
                </div>
              </div>
              <div className="single-card">
                <img
                  src="\gemslogo.svg"
                  alt="img"
                  className="gems-logo-img"
                  style={{ width: "35px", height: "35px", overflow: "hidden" }}
                />
                {/* {user?.role == "god_agent" &&
                specialAccess &&
                specialAccess?.length > 0 ? (
                  <div>
                    <a
                      className="custom-tooltip-ico"
                      onMouseEnter={() => handleMouseEnter("icon2")}
                      onMouseLeave={() => handleMouseLeave("icon2")}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                      >
                        <path
                          d="M10.25 13.0625C10.25 13.3097 10.1767 13.5514 10.0393 13.757C9.90199 13.9625 9.70677 14.1227 9.47836 14.2174C9.24995 14.312 8.99862 14.3367 8.75614 14.2885C8.51366 14.2403 8.29094 14.1212 8.11612 13.9464C7.9413 13.7716 7.82225 13.5488 7.77402 13.3064C7.72579 13.0639 7.75054 12.8126 7.84515 12.5841C7.93976 12.3557 8.09998 12.1605 8.30554 12.0232C8.5111 11.8858 8.75278 11.8125 9 11.8125C9.33152 11.8125 9.64947 11.9442 9.88389 12.1786C10.1183 12.413 10.25 12.731 10.25 13.0625ZM17.4375 9C17.4375 10.6688 16.9427 12.3001 16.0155 13.6876C15.0884 15.0752 13.7706 16.1566 12.2289 16.7952C10.6871 17.4338 8.99064 17.6009 7.35393 17.2754C5.71721 16.9498 4.2138 16.1462 3.03379 14.9662C1.85379 13.7862 1.05019 12.2828 0.724628 10.6461C0.399065 9.00936 0.566156 7.31286 1.20477 5.77111C1.84338 4.22936 2.92484 2.9116 4.31238 1.98448C5.69992 1.05735 7.33122 0.5625 9 0.5625C11.237 0.564981 13.3817 1.45473 14.9635 3.03653C16.5453 4.61833 17.435 6.763 17.4375 9ZM15.5625 9C15.5625 7.70206 15.1776 6.43327 14.4565 5.35407C13.7354 4.27487 12.7105 3.43374 11.5114 2.93704C10.3122 2.44034 8.99272 2.31038 7.71972 2.5636C6.44672 2.81681 5.2774 3.44183 4.35962 4.35961C3.44183 5.27739 2.81682 6.44672 2.5636 7.71972C2.31038 8.99272 2.44034 10.3122 2.93704 11.5114C3.43374 12.7105 4.27488 13.7354 5.35407 14.4565C6.43327 15.1776 7.70206 15.5625 9 15.5625C10.7399 15.5606 12.408 14.8686 13.6383 13.6383C14.8686 12.408 15.5606 10.7399 15.5625 9ZM9 4C7.10469 4 5.5625 5.40156 5.5625 7.125V7.4375C5.5625 7.68614 5.66128 7.9246 5.83709 8.10041C6.01291 8.27623 6.25136 8.375 6.5 8.375C6.74864 8.375 6.9871 8.27623 7.16292 8.10041C7.33873 7.9246 7.4375 7.68614 7.4375 7.4375V7.125C7.4375 6.43594 8.14063 5.875 9 5.875C9.85938 5.875 10.5625 6.43594 10.5625 7.125C10.5625 7.81406 9.85938 8.375 9 8.375C8.75136 8.375 8.51291 8.47377 8.33709 8.64959C8.16128 8.8254 8.0625 9.06386 8.0625 9.3125V9.9375C8.06194 10.1691 8.14715 10.3927 8.30169 10.5653C8.45623 10.7378 8.66916 10.847 8.89945 10.8719C9.12973 10.8967 9.36106 10.8354 9.54884 10.6998C9.73662 10.5642 9.86756 10.3639 9.91641 10.1375C11.368 9.77187 12.4375 8.56016 12.4375 7.125C12.4375 5.40156 10.8953 4 9 4Z"
                          fill="white"
                        />
                      </svg>
                    </a>
                    {hoveredElements.icon2 && (
                      <div className="set-custom-tooltip">
                        <div className="inner-text">
                          <h6>My tree:</h6>
                          <h6 className="mt-2">
                            {myTree[0]?.myTreeTotalDopPurchased?.toLocaleString()}
                          </h6>
                          <div className="bottom-twice">
                           
                          </div>
                        </div>
                        <div className="inner-text">
                          <h6>Other Leaders:</h6>
                          <h6 className="mt-2">
                            {otherLeaders[0]?.otherLeadersTotalDopPurchased?.toLocaleString()}
                          </h6>
                          <div className="bottom-twice">
                            
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                ) : null} */}
                <p>GEMS Purchased</p>
                {usdPrice && dopPurchased ? (
                  <h6>
                    {(
                      dopPurchased +
                      (otherLeaders && otherLeaders?.length > 0
                        ? otherLeaders[0]?.otherLeadersTotalDopPurchased
                        : 0)
                    )?.toLocaleString()}
                    &nbsp;GEMS{" "}
                    <span className={dpc > 0 ? "green-text" : "red-text"}>
                      {dpc ? dpc.toFixed(1) + "% " : ""}
                    </span>
                  </h6>
                ) : (
                  <h6>0.00 GEMS</h6>
                )}
                <div className="bottom-text">
                  <p className="uni-text">
                    <span></span>
                    {dt[0]?.totalDirectDop
                      ? dt[0]?.totalDirectDop?.toFixed(4)
                      : 0}
                  </p>
                  <p className="uni-text">
                    <span></span>~
                    {ind[0]?.totalInDirectDop
                      ? ind[0]?.totalInDirectDop?.toFixed(4)
                      : 0}
                  </p>
                </div>

                <div className="bottom-text">
                  {/* <p className="uni-text">
                    <span></span>
                    {tokenNftStats
                      ? parseFloat(
                          tokenNftStats?.tokensDopPurchased?.toFixed(4)
                        )?.toLocaleString("en-US")
                      : 0}{" "}
                    Token
                  </p> */}
                  {/* <p className="uni-text">
                    <span></span>
                    {tokenNftStats
                      ? parseInt(
                          tokenNftStats?.nftDopPurchased?.toFixed(2)
                        )?.toLocaleString("en-US")
                      : 0}{" "}
                    NFT
                  </p> */}
                </div>
              </div>
              {user?.role == "god_agent" &&
              specialAccess &&
              specialAccess?.length > 0 ? (
                <div className="single-card">
                  <img
                    src="\assets\dashboard\agentearning.svg"
                    alt="img"
                    className="img-fluid"
                  />
                  <p>Leader's Earnings (Other Leaders)</p>
                  {/* <h6>~50,000 USD</h6> */}
                  {usdPrice && tomiPrice ? (
                    <h6 className="datahead">
                      {usdPrice ? (
                        <h6 className="datahead">
                          {otherLeadersEarnings &&
                          otherLeadersEarnings?.length > 0
                            ? "~$" +
                              parseFloat(
                                (
                                  usdPrice *
                                    (otherLeadersEarnings &&
                                    otherLeadersEarnings?.length > 0 &&
                                    otherLeadersEarnings[0]?._id == "ETH"
                                      ? otherLeadersEarnings[0]
                                          ?.totalOtherLeadersEarnings
                                      : otherLeadersEarnings &&
                                        otherLeadersEarnings?.length > 0 &&
                                        otherLeadersEarnings[1]?._id == "ETH"
                                      ? otherLeadersEarnings[1]
                                          ?.totalOtherLeadersEarnings
                                      : otherLeadersEarnings &&
                                        otherLeadersEarnings?.length > 0 &&
                                        otherLeadersEarnings[2]?._id == "ETH"
                                      ? otherLeadersEarnings[2]
                                          ?.totalOtherLeadersEarnings
                                      : otherLeadersEarnings &&
                                        otherLeadersEarnings?.length > 0 &&
                                        otherLeadersEarnings[3]?._id == "ETH"
                                      ? otherLeadersEarnings[3]
                                          ?.totalOtherLeadersEarnings
                                      : otherLeadersEarnings &&
                                        otherLeadersEarnings?.length > 0 &&
                                        otherLeadersEarnings[4]?._id == "ETH"
                                      ? otherLeadersEarnings[4]
                                          ?.totalOtherLeadersEarnings
                                      : 0) +
                                  (otherLeadersEarnings &&
                                  otherLeadersEarnings?.length > 0 &&
                                  otherLeadersEarnings[0]?._id == "USDT"
                                    ? otherLeadersEarnings[0]
                                        ?.totalOtherLeadersEarnings
                                    : otherLeadersEarnings &&
                                      otherLeadersEarnings?.length > 0 &&
                                      otherLeadersEarnings[1]?._id == "USDT"
                                    ? otherLeadersEarnings[1]
                                        ?.totalOtherLeadersEarnings
                                    : otherLeadersEarnings &&
                                      otherLeadersEarnings?.length > 0 &&
                                      otherLeadersEarnings[2]?._id == "USDT"
                                    ? otherLeadersEarnings[2]
                                        ?.totalOtherLeadersEarnings
                                    : otherLeadersEarnings &&
                                      otherLeadersEarnings?.length > 0 &&
                                      otherLeadersEarnings[3]?._id == "USDT"
                                    ? otherLeadersEarnings[3]
                                        ?.totalOtherLeadersEarnings
                                    : otherLeadersEarnings &&
                                      otherLeadersEarnings?.length > 0 &&
                                      otherLeadersEarnings[4]?._id == "USDT"
                                    ? otherLeadersEarnings[4]
                                        ?.totalOtherLeadersEarnings
                                    : 0) +
                                  tomiPrice *
                                    (otherLeadersEarnings &&
                                    otherLeadersEarnings?.length > 0 &&
                                    otherLeadersEarnings[0]?._id == "TOMI"
                                      ? otherLeadersEarnings[0]
                                          ?.totalOtherLeadersEarnings
                                      : otherLeadersEarnings &&
                                        otherLeadersEarnings?.length > 0 &&
                                        otherLeadersEarnings[1]?._id == "TOMI"
                                      ? otherLeadersEarnings[1]
                                          ?.totalOtherLeadersEarnings
                                      : otherLeadersEarnings &&
                                        otherLeadersEarnings?.length > 0 &&
                                        otherLeadersEarnings[2]?._id == "TOMI"
                                      ? otherLeadersEarnings[2]
                                          ?.totalOtherLeadersEarnings
                                      : otherLeadersEarnings &&
                                        otherLeadersEarnings?.length > 0 &&
                                        otherLeadersEarnings[3]?._id == "TOMI"
                                      ? otherLeadersEarnings[3]
                                          ?.totalOtherLeadersEarnings
                                      : otherLeadersEarnings &&
                                        otherLeadersEarnings?.length > 0 &&
                                        otherLeadersEarnings[4]?._id == "TOMI"
                                      ? otherLeadersEarnings[4]
                                          ?.totalOtherLeadersEarnings
                                      : 0) +
                                  btcPrice *
                                    (otherLeadersEarnings &&
                                    otherLeadersEarnings?.length > 0 &&
                                    otherLeadersEarnings[0]?._id == "WBTC"
                                      ? otherLeadersEarnings[0]
                                          ?.totalOtherLeadersEarnings
                                      : otherLeadersEarnings &&
                                        otherLeadersEarnings?.length > 0 &&
                                        otherLeadersEarnings[1]?._id == "WBTC"
                                      ? otherLeadersEarnings[1]
                                          ?.totalOtherLeadersEarnings
                                      : otherLeadersEarnings &&
                                        otherLeadersEarnings?.length > 0 &&
                                        otherLeadersEarnings[2]?._id == "WBTC"
                                      ? otherLeadersEarnings[2]
                                          ?.totalOtherLeadersEarnings
                                      : otherLeadersEarnings &&
                                        otherLeadersEarnings?.length > 0 &&
                                        otherLeadersEarnings[3]?._id == "WBTC"
                                      ? otherLeadersEarnings[3]
                                          ?.totalOtherLeadersEarnings
                                      : otherLeadersEarnings &&
                                        otherLeadersEarnings?.length > 0 &&
                                        otherLeadersEarnings[4]?._id == "WBTC"
                                      ? otherLeadersEarnings[4]
                                          ?.totalOtherLeadersEarnings
                                      : 0) +
                                  (otherLeadersEarnings &&
                                  otherLeadersEarnings?.length > 0 &&
                                  otherLeadersEarnings[0]?._id == "USDC"
                                    ? otherLeadersEarnings[0]
                                        ?.totalOtherLeadersEarnings
                                    : otherLeadersEarnings &&
                                      otherLeadersEarnings?.length > 0 &&
                                      otherLeadersEarnings[1]?._id == "USDC"
                                    ? otherLeadersEarnings[1]
                                        ?.totalOtherLeadersEarnings
                                    : otherLeadersEarnings &&
                                      otherLeadersEarnings?.length > 0 &&
                                      otherLeadersEarnings[2]?._id == "USDC"
                                    ? otherLeadersEarnings[2]
                                        ?.totalOtherLeadersEarnings
                                    : otherLeadersEarnings &&
                                      otherLeadersEarnings?.length > 0 &&
                                      otherLeadersEarnings[3]?._id == "USDC"
                                    ? otherLeadersEarnings[3]
                                        ?.totalOtherLeadersEarnings
                                    : otherLeadersEarnings &&
                                      otherLeadersEarnings?.length > 0 &&
                                      otherLeadersEarnings[4]?._id == "USDC"
                                    ? otherLeadersEarnings[4]
                                        ?.totalOtherLeadersEarnings
                                    : 0)
                                )?.toFixed(4)
                              ).toLocaleString("en-US")
                            : 0}{" "}
                        </h6>
                      ) : (
                        <h6 className="datahead">~$0.00 USD</h6>
                      )}
                    </h6>
                  ) : (
                    <h6 className="datahead">~$0.00 USD</h6>
                  )}
                  <div className="bottom-text">
                    <p className="uni-text">
                      <span></span>
                      {parseFloat(
                        (otherLeadersEarnings &&
                        otherLeadersEarnings?.length > 0 &&
                        otherLeadersEarnings[0]?._id == "ETH"
                          ? otherLeadersEarnings[0]?.totalOtherLeadersEarnings
                          : otherLeadersEarnings &&
                            otherLeadersEarnings[1]?._id == "ETH"
                          ? otherLeadersEarnings[1]?.totalOtherLeadersEarnings
                          : otherLeadersEarnings &&
                            otherLeadersEarnings[2]?._id == "ETH"
                          ? otherLeadersEarnings[2]?.totalOtherLeadersEarning
                          : otherLeadersEarnings &&
                            otherLeadersEarnings[3]?._id == "ETH"
                          ? otherLeadersEarnings[3]?.totalOtherLeadersEarning
                          : otherLeadersEarnings &&
                            otherLeadersEarnings[4]?._id == "ETH"
                          ? otherLeadersEarnings[4]?.totalOtherLeadersEarning
                          : 0
                        )?.toFixed(4)
                      )}{" "}
                      ETH
                    </p>
                    <p className="uni-text">
                      <span></span>
                      {parseFloat(
                        (otherLeadersEarnings &&
                        otherLeadersEarnings?.length > 0 &&
                        otherLeadersEarnings[0]?._id == "USDT"
                          ? otherLeadersEarnings[0]?.totalOtherLeadersEarnings
                          : otherLeadersEarnings &&
                            otherLeadersEarnings[1]?._id == "USDT"
                          ? otherLeadersEarnings[1]?.totalOtherLeadersEarnings
                          : otherLeadersEarnings &&
                            otherLeadersEarnings[2]?._id == "USDT"
                          ? otherLeadersEarnings[2]?.totalOtherLeadersEarnings
                          : otherLeadersEarnings &&
                            otherLeadersEarnings[3]?._id == "USDT"
                          ? otherLeadersEarnings[3]?.totalOtherLeadersEarnings
                          : otherLeadersEarnings &&
                            otherLeadersEarnings[4]?._id == "USDT"
                          ? otherLeadersEarnings[4]?.totalOtherLeadersEarnings
                          : 0
                        ).toFixed(2)
                      ).toLocaleString()}{" "}
                      USDT
                    </p>
                    {/* <p className="uni-text">
                      <span></span>
                      {parseFloat(
                        (otherLeadersEarnings &&
                        otherLeadersEarnings?.length > 0 &&
                        otherLeadersEarnings[0]?._id == "TOMI"
                          ? otherLeadersEarnings[0]?.totalOtherLeadersEarnings
                          : otherLeadersEarnings &&
                            otherLeadersEarnings[1]?._id == "TOMI"
                          ? otherLeadersEarnings[1]?.totalOtherLeadersEarnings
                          : otherLeadersEarnings &&
                            otherLeadersEarnings[2]?._id == "TOMI"
                          ? otherLeadersEarnings[2]?.totalOtherLeadersEarnings
                          : otherLeadersEarnings &&
                            otherLeadersEarnings[3]?._id == "TOMI"
                          ? otherLeadersEarnings[3]?.totalOtherLeadersEarnings
                          : otherLeadersEarnings &&
                            otherLeadersEarnings[4]?._id == "TOMI"
                          ? otherLeadersEarnings[4]?.totalOtherLeadersEarnings
                          : 0
                        ).toFixed(2)
                      ).toLocaleString()}{" "}
                      TOMI
                    </p> */}
                    <p className="uni-text">
                      <span></span>
                      {parseFloat(
                        (otherLeadersEarnings &&
                        otherLeadersEarnings?.length > 0 &&
                        otherLeadersEarnings[0]?._id == "WBTC"
                          ? otherLeadersEarnings[0]?.totalOtherLeadersEarnings
                          : otherLeadersEarnings &&
                            otherLeadersEarnings[1]?._id == "WBTC"
                          ? otherLeadersEarnings[1]?.totalOtherLeadersEarnings
                          : otherLeadersEarnings &&
                            otherLeadersEarnings[2]?._id == "WBTC"
                          ? otherLeadersEarnings[2]?.totalOtherLeadersEarnings
                          : otherLeadersEarnings &&
                            otherLeadersEarnings[3]?._id == "WBTC"
                          ? otherLeadersEarnings[3]?.totalOtherLeadersEarnings
                          : otherLeadersEarnings &&
                            otherLeadersEarnings[4]?._id == "WBTC"
                          ? otherLeadersEarnings[4]?.totalOtherLeadersEarnings
                          : 0
                        ).toFixed(5)
                      ).toLocaleString()}{" "}
                      WBTC
                    </p>
                    <p className="uni-text">
                      <span></span>
                      {parseFloat(
                        (otherLeadersEarnings &&
                        otherLeadersEarnings?.length > 0 &&
                        otherLeadersEarnings[0]?._id == "USDC"
                          ? otherLeadersEarnings[0]?.totalOtherLeadersEarnings
                          : otherLeadersEarnings &&
                            otherLeadersEarnings[1]?._id == "USDC"
                          ? otherLeadersEarnings[1]?.totalOtherLeadersEarnings
                          : otherLeadersEarnings &&
                            otherLeadersEarnings[2]?._id == "USDC"
                          ? otherLeadersEarnings[2]?.totalOtherLeadersEarnings
                          : otherLeadersEarnings &&
                            otherLeadersEarnings[3]?._id == "USDC"
                          ? otherLeadersEarnings[3]?.totalOtherLeadersEarnings
                          : otherLeadersEarnings &&
                            otherLeadersEarnings[4]?._id == "USDC"
                          ? otherLeadersEarnings[4]?.totalOtherLeadersEarnings
                          : 0
                        ).toFixed(2)
                      ).toLocaleString()}{" "}
                      USDC
                    </p>
                  </div>
                </div>
              ) : null}
              {user?.role == "god_agent" ? (
                <div className="single-card">
                  <img
                    src="\assets\dashboard\purchasedamount.svg"
                    alt="img"
                    className="img-fluid"
                  />
                  {/* {user?.role == "god_agent" &&
                specialAccess &&
                specialAccess?.length > 0 ? (
                  <div>
                    <a
                      className="custom-tooltip-ico"
                      onMouseEnter={() => handleMouseEnter("icon3")}
                      onMouseLeave={() => handleMouseLeave("icon3")}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                      >
                        <path
                          d="M10.25 13.0625C10.25 13.3097 10.1767 13.5514 10.0393 13.757C9.90199 13.9625 9.70677 14.1227 9.47836 14.2174C9.24995 14.312 8.99862 14.3367 8.75614 14.2885C8.51366 14.2403 8.29094 14.1212 8.11612 13.9464C7.9413 13.7716 7.82225 13.5488 7.77402 13.3064C7.72579 13.0639 7.75054 12.8126 7.84515 12.5841C7.93976 12.3557 8.09998 12.1605 8.30554 12.0232C8.5111 11.8858 8.75278 11.8125 9 11.8125C9.33152 11.8125 9.64947 11.9442 9.88389 12.1786C10.1183 12.413 10.25 12.731 10.25 13.0625ZM17.4375 9C17.4375 10.6688 16.9427 12.3001 16.0155 13.6876C15.0884 15.0752 13.7706 16.1566 12.2289 16.7952C10.6871 17.4338 8.99064 17.6009 7.35393 17.2754C5.71721 16.9498 4.2138 16.1462 3.03379 14.9662C1.85379 13.7862 1.05019 12.2828 0.724628 10.6461C0.399065 9.00936 0.566156 7.31286 1.20477 5.77111C1.84338 4.22936 2.92484 2.9116 4.31238 1.98448C5.69992 1.05735 7.33122 0.5625 9 0.5625C11.237 0.564981 13.3817 1.45473 14.9635 3.03653C16.5453 4.61833 17.435 6.763 17.4375 9ZM15.5625 9C15.5625 7.70206 15.1776 6.43327 14.4565 5.35407C13.7354 4.27487 12.7105 3.43374 11.5114 2.93704C10.3122 2.44034 8.99272 2.31038 7.71972 2.5636C6.44672 2.81681 5.2774 3.44183 4.35962 4.35961C3.44183 5.27739 2.81682 6.44672 2.5636 7.71972C2.31038 8.99272 2.44034 10.3122 2.93704 11.5114C3.43374 12.7105 4.27488 13.7354 5.35407 14.4565C6.43327 15.1776 7.70206 15.5625 9 15.5625C10.7399 15.5606 12.408 14.8686 13.6383 13.6383C14.8686 12.408 15.5606 10.7399 15.5625 9ZM9 4C7.10469 4 5.5625 5.40156 5.5625 7.125V7.4375C5.5625 7.68614 5.66128 7.9246 5.83709 8.10041C6.01291 8.27623 6.25136 8.375 6.5 8.375C6.74864 8.375 6.9871 8.27623 7.16292 8.10041C7.33873 7.9246 7.4375 7.68614 7.4375 7.4375V7.125C7.4375 6.43594 8.14063 5.875 9 5.875C9.85938 5.875 10.5625 6.43594 10.5625 7.125C10.5625 7.81406 9.85938 8.375 9 8.375C8.75136 8.375 8.51291 8.47377 8.33709 8.64959C8.16128 8.8254 8.0625 9.06386 8.0625 9.3125V9.9375C8.06194 10.1691 8.14715 10.3927 8.30169 10.5653C8.45623 10.7378 8.66916 10.847 8.89945 10.8719C9.12973 10.8967 9.36106 10.8354 9.54884 10.6998C9.73662 10.5642 9.86756 10.3639 9.91641 10.1375C11.368 9.77187 12.4375 8.56016 12.4375 7.125C12.4375 5.40156 10.8953 4 9 4Z"
                          fill="white"
                        />
                      </svg>
                    </a>
                    {hoveredElements.icon3 && (
                      <div className="set-custom-tooltip">
                        <div className="inner-text">
                          <h6>My tree:</h6>
                          <h6 className="mt-2">
                            {usdPrice ? (
                              <h6 className="datahead">
                                {myTreePurchasedAmount[0]
                                  ?.myTreePurchasedAmount ||
                                myTreePurchasedAmount[1]?.myTreePurchasedAmount
                                  ? "~$" +
                                    parseFloat(
                                      (
                                        usdPrice *
                                          (myTreePurchasedAmount[1]
                                            ?.myTreePurchasedAmount
                                            ? myTreePurchasedAmount[1]
                                                ?.myTreePurchasedAmount
                                            : 0) +
                                        (myTreePurchasedAmount[0]
                                          ?.myTreePurchasedAmount
                                          ? myTreePurchasedAmount[0]
                                              ?.myTreePurchasedAmount
                                          : 0)
                                      )?.toFixed(4)
                                    ).toLocaleString("en-US")
                                  : 0}{" "}
                              </h6>
                            ) : (
                              <h6 className="datahead">~$0.00 USD</h6>
                            )}
                          </h6>
                          <div className="bottom-twice">
                            <p>
                              <span></span>{" "}
                              {myTreePurchasedAmount[1]?.myTreePurchasedAmount
                                ? myTreePurchasedAmount[1]
                                    ?.myTreePurchasedAmount
                                : 0}{" "}
                              ETH
                            </p>
                            <p>
                              <span></span>{" "}
                              {myTreePurchasedAmount[0]?.myTreePurchasedAmount
                                ? myTreePurchasedAmount[0]
                                    ?.myTreePurchasedAmount
                                : 0}{" "}
                              USDT
                            </p>
                          </div>
                        </div>
                        <div className="inner-text">
                          <h6>Other Leaders:</h6>
                          <h6 className="mt-2">
                            {usdPrice ? (
                              <h6 className="datahead">
                                {otherLeadersPurchasedAmount[0]
                                  ?.otherLeadersPurchaseAmount ||
                                otherLeadersPurchasedAmount[1]
                                  ?.otherLeadersPurchaseAmount
                                  ? "~$" +
                                    parseFloat(
                                      (
                                        usdPrice *
                                          (otherLeadersPurchasedAmount[1]
                                            ?.otherLeadersPurchaseAmount
                                            ? otherLeadersPurchasedAmount[1]
                                                ?.otherLeadersPurchaseAmount
                                            : 0) +
                                        (otherLeadersPurchasedAmount[0]
                                          ?.otherLeadersPurchaseAmount
                                          ? otherLeadersPurchasedAmount[0]
                                              ?.otherLeadersPurchaseAmount
                                          : 0)
                                      )?.toFixed(4)
                                    ).toLocaleString("en-US")
                                  : 0}{" "}
                              </h6>
                            ) : (
                              <h6 className="datahead">~$0.00 USD</h6>
                            )}
                          </h6>
                          <div className="bottom-twice">
                            <p>
                              <span></span>{" "}
                              {otherLeadersPurchasedAmount[1]
                                ?.otherLeadersPurchaseAmount
                                ? otherLeadersPurchasedAmount[1]
                                    ?.otherLeadersPurchaseAmount
                                : 0}{" "}
                              ETH
                            </p>
                            <p>
                              <span></span>{" "}
                              {otherLeadersPurchasedAmount[0]
                                ?.otherLeadersPurchaseAmount
                                ? otherLeadersPurchasedAmount[0]
                                    ?.otherLeadersPurchaseAmount
                                : 0}{" "}
                              USDT
                            </p>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                ) : null} */}

                  <p>Purchased Amount</p>
                  {usdPrice &&
                  tomiPrice &&
                  (purchasesAndEarnings?.length > 0 ||
                    otherLeadersPurchasedAmount?.length > 0) ? (
                    <h6 className="datahead">
                      {usdPrice &&
                      tomiPrice &&
                      (purchasesAndEarnings?.length > 0 ||
                        otherLeadersPurchasedAmount?.length > 0)
                        ? "~$" +
                          parseFloat(
                            (
                              usdPrice *
                                (purchasesAndEarnings &&
                                purchasesAndEarnings?.length > 0 &&
                                purchasesAndEarnings[0]?._id?.tokenSelected ==
                                  "ETH"
                                  ? purchasesAndEarnings[0]?.totalPurchase
                                  : purchasesAndEarnings &&
                                    purchasesAndEarnings?.length > 0 &&
                                    purchasesAndEarnings[1]?._id
                                      ?.tokenSelected == "ETH"
                                  ? purchasesAndEarnings[1]?.totalPurchase
                                  : purchasesAndEarnings &&
                                    purchasesAndEarnings?.length > 0 &&
                                    purchasesAndEarnings[2]?._id
                                      ?.tokenSelected == "ETH"
                                  ? purchasesAndEarnings[2]?.totalPurchase
                                  : purchasesAndEarnings &&
                                    purchasesAndEarnings?.length > 0 &&
                                    purchasesAndEarnings[3]?._id
                                      ?.tokenSelected == "ETH"
                                  ? purchasesAndEarnings[3]?.totalPurchase
                                  : purchasesAndEarnings &&
                                    purchasesAndEarnings?.length > 0 &&
                                    purchasesAndEarnings[4]?._id
                                      ?.tokenSelected == "ETH"
                                  ? purchasesAndEarnings[4]?.totalPurchase
                                  : 0) +
                              (usdPrice *
                                (otherLeadersPurchasedAmount &&
                                otherLeadersPurchasedAmount?.length > 0 &&
                                otherLeadersPurchasedAmount[0]?._id == "ETH"
                                  ? otherLeadersPurchasedAmount[0]
                                      ?.otherLeadersPurchaseAmount
                                  : otherLeadersPurchasedAmount &&
                                    otherLeadersPurchasedAmount?.length > 0 &&
                                    otherLeadersPurchasedAmount[1]?._id == "ETH"
                                  ? otherLeadersPurchasedAmount[1]
                                      ?.otherLeadersPurchaseAmount
                                  : otherLeadersPurchasedAmount &&
                                    otherLeadersPurchasedAmount?.length > 0 &&
                                    otherLeadersPurchasedAmount[2]?._id == "ETH"
                                  ? otherLeadersPurchasedAmount[2]
                                      ?.otherLeadersPurchaseAmount
                                  : otherLeadersPurchasedAmount &&
                                    otherLeadersPurchasedAmount?.length > 0 &&
                                    otherLeadersPurchasedAmount[3]?._id == "ETH"
                                  ? otherLeadersPurchasedAmount[3]
                                      ?.otherLeadersPurchaseAmount
                                  : otherLeadersPurchasedAmount &&
                                    otherLeadersPurchasedAmount?.length > 0 &&
                                    otherLeadersPurchasedAmount[4]?._id == "ETH"
                                  ? otherLeadersPurchasedAmount[4]
                                      ?.otherLeadersPurchaseAmount
                                  : 0) +
                                (otherLeadersPurchasedAmount &&
                                otherLeadersPurchasedAmount?.length > 0 &&
                                otherLeadersPurchasedAmount[1]?._id == "USDT"
                                  ? otherLeadersPurchasedAmount[1]
                                      ?.otherLeadersPurchaseAmount
                                  : otherLeadersPurchasedAmount &&
                                    otherLeadersPurchasedAmount?.length > 0 &&
                                    otherLeadersPurchasedAmount[0]?._id ==
                                      "USDT"
                                  ? otherLeadersPurchasedAmount[0]
                                      ?.otherLeadersPurchaseAmount
                                  : otherLeadersPurchasedAmount &&
                                    otherLeadersPurchasedAmount?.length > 0 &&
                                    otherLeadersPurchasedAmount[2]?._id ==
                                      "USDT"
                                  ? otherLeadersPurchasedAmount[2]
                                      ?.otherLeadersPurchaseAmount
                                  : otherLeadersPurchasedAmount &&
                                    otherLeadersPurchasedAmount?.length > 0 &&
                                    otherLeadersPurchasedAmount[3]?._id ==
                                      "USDT"
                                  ? otherLeadersPurchasedAmount[3]
                                      ?.otherLeadersPurchaseAmount
                                  : otherLeadersPurchasedAmount &&
                                    otherLeadersPurchasedAmount?.length > 0 &&
                                    otherLeadersPurchasedAmount[4]?._id ==
                                      "USDT"
                                  ? otherLeadersPurchasedAmount[4]
                                      ?.otherLeadersPurchaseAmount
                                  : 0) +
                                (purchasesAndEarnings &&
                                purchasesAndEarnings?.length > 0 &&
                                purchasesAndEarnings[0]?._id?.tokenSelected ==
                                  "USDT"
                                  ? purchasesAndEarnings[0]?.totalPurchase
                                  : purchasesAndEarnings &&
                                    purchasesAndEarnings?.length > 0 &&
                                    purchasesAndEarnings[1]?._id
                                      ?.tokenSelected == "USDT"
                                  ? purchasesAndEarnings[1]?.totalPurchase
                                  : purchasesAndEarnings &&
                                    purchasesAndEarnings?.length > 0 &&
                                    purchasesAndEarnings[2]?._id
                                      ?.tokenSelected == "USDT"
                                  ? purchasesAndEarnings[2]?.totalPurchase
                                  : purchasesAndEarnings &&
                                    purchasesAndEarnings?.length > 0 &&
                                    purchasesAndEarnings[3]?._id
                                      ?.tokenSelected == "USDT"
                                  ? purchasesAndEarnings[3]?.totalPurchase
                                  : purchasesAndEarnings &&
                                    purchasesAndEarnings?.length > 0 &&
                                    purchasesAndEarnings[4]?._id
                                      ?.tokenSelected == "USDT"
                                  ? purchasesAndEarnings[4]?.totalPurchase
                                  : 0) +
                                tomiPrice *
                                  (otherLeadersPurchasedAmount &&
                                  otherLeadersPurchasedAmount?.length > 0 &&
                                  otherLeadersPurchasedAmount[1]?._id == "TOMI"
                                    ? otherLeadersPurchasedAmount[1]
                                        ?.otherLeadersPurchaseAmount
                                    : otherLeadersPurchasedAmount &&
                                      otherLeadersPurchasedAmount?.length > 0 &&
                                      otherLeadersPurchasedAmount[0]?._id ==
                                        "TOMI"
                                    ? otherLeadersPurchasedAmount[0]
                                        ?.otherLeadersPurchaseAmount
                                    : otherLeadersPurchasedAmount &&
                                      otherLeadersPurchasedAmount?.length > 0 &&
                                      otherLeadersPurchasedAmount[2]?._id ==
                                        "TOMI"
                                    ? otherLeadersPurchasedAmount[2]
                                        ?.otherLeadersPurchaseAmount
                                    : otherLeadersPurchasedAmount &&
                                      otherLeadersPurchasedAmount?.length > 0 &&
                                      otherLeadersPurchasedAmount[3]?._id ==
                                        "TOMI"
                                    ? otherLeadersPurchasedAmount[3]
                                        ?.otherLeadersPurchaseAmount
                                    : otherLeadersPurchasedAmount &&
                                      otherLeadersPurchasedAmount?.length > 0 &&
                                      otherLeadersPurchasedAmount[4]?._id ==
                                        "TOMI"
                                    ? otherLeadersPurchasedAmount[4]
                                        ?.otherLeadersPurchaseAmount
                                    : 0) +
                                tomiPrice *
                                  (purchasesAndEarnings &&
                                  purchasesAndEarnings?.length > 0 &&
                                  purchasesAndEarnings[0]?._id?.tokenSelected ==
                                    "TOMI"
                                    ? purchasesAndEarnings[0]?.totalPurchase
                                    : purchasesAndEarnings &&
                                      purchasesAndEarnings?.length > 0 &&
                                      purchasesAndEarnings[1]?._id
                                        ?.tokenSelected == "TOMI"
                                    ? purchasesAndEarnings[1]?.totalPurchase
                                    : purchasesAndEarnings &&
                                      purchasesAndEarnings?.length > 0 &&
                                      purchasesAndEarnings[2]?._id
                                        ?.tokenSelected == "TOMI"
                                    ? purchasesAndEarnings[2]?.totalPurchase
                                    : purchasesAndEarnings &&
                                      purchasesAndEarnings?.length > 0 &&
                                      purchasesAndEarnings[3]?._id
                                        ?.tokenSelected == "TOMI"
                                    ? purchasesAndEarnings[3]?.totalPurchase
                                    : purchasesAndEarnings &&
                                      purchasesAndEarnings?.length > 0 &&
                                      purchasesAndEarnings[4]?._id
                                        ?.tokenSelected == "TOMI"
                                    ? purchasesAndEarnings[4]?.totalPurchase
                                    : 0) +
                                btcPrice *
                                  (otherLeadersPurchasedAmount &&
                                  otherLeadersPurchasedAmount?.length > 0 &&
                                  otherLeadersPurchasedAmount[1]?._id == "WBTC"
                                    ? otherLeadersPurchasedAmount[1]
                                        ?.otherLeadersPurchaseAmount
                                    : otherLeadersPurchasedAmount &&
                                      otherLeadersPurchasedAmount?.length > 0 &&
                                      otherLeadersPurchasedAmount[0]?._id ==
                                        "WBTC"
                                    ? otherLeadersPurchasedAmount[0]
                                        ?.otherLeadersPurchaseAmount
                                    : otherLeadersPurchasedAmount &&
                                      otherLeadersPurchasedAmount?.length > 0 &&
                                      otherLeadersPurchasedAmount[2]?._id ==
                                        "WBTC"
                                    ? otherLeadersPurchasedAmount[2]
                                        ?.otherLeadersPurchaseAmount
                                    : otherLeadersPurchasedAmount &&
                                      otherLeadersPurchasedAmount?.length > 0 &&
                                      otherLeadersPurchasedAmount[3]?._id ==
                                        "WBTC"
                                    ? otherLeadersPurchasedAmount[3]
                                        ?.otherLeadersPurchaseAmount
                                    : otherLeadersPurchasedAmount &&
                                      otherLeadersPurchasedAmount?.length > 0 &&
                                      otherLeadersPurchasedAmount[4]?._id ==
                                        "WBTC"
                                    ? otherLeadersPurchasedAmount[4]
                                        ?.otherLeadersPurchaseAmount
                                    : 0) +
                                btcPrice *
                                  (purchasesAndEarnings &&
                                  purchasesAndEarnings?.length > 0 &&
                                  purchasesAndEarnings[0]?._id?.tokenSelected ==
                                    "WBTC"
                                    ? purchasesAndEarnings[0]?.totalPurchase
                                    : purchasesAndEarnings &&
                                      purchasesAndEarnings?.length > 0 &&
                                      purchasesAndEarnings[1]?._id
                                        ?.tokenSelected == "WBTC"
                                    ? purchasesAndEarnings[1]?.totalPurchase
                                    : purchasesAndEarnings &&
                                      purchasesAndEarnings?.length > 0 &&
                                      purchasesAndEarnings[2]?._id
                                        ?.tokenSelected == "WBTC"
                                    ? purchasesAndEarnings[2]?.totalPurchase
                                    : purchasesAndEarnings &&
                                      purchasesAndEarnings?.length > 0 &&
                                      purchasesAndEarnings[3]?._id
                                        ?.tokenSelected == "WBTC"
                                    ? purchasesAndEarnings[3]?.totalPurchase
                                    : purchasesAndEarnings &&
                                      purchasesAndEarnings?.length > 0 &&
                                      purchasesAndEarnings[4]?._id
                                        ?.tokenSelected == "WBTC"
                                    ? purchasesAndEarnings[4]?.totalPurchase
                                    : 0) +
                                (otherLeadersPurchasedAmount &&
                                otherLeadersPurchasedAmount?.length > 0 &&
                                otherLeadersPurchasedAmount[1]?._id == "USDC"
                                  ? otherLeadersPurchasedAmount[1]
                                      ?.otherLeadersPurchaseAmount
                                  : otherLeadersPurchasedAmount &&
                                    otherLeadersPurchasedAmount?.length > 0 &&
                                    otherLeadersPurchasedAmount[0]?._id ==
                                      "USDC"
                                  ? otherLeadersPurchasedAmount[0]
                                      ?.otherLeadersPurchaseAmount
                                  : otherLeadersPurchasedAmount &&
                                    otherLeadersPurchasedAmount?.length > 0 &&
                                    otherLeadersPurchasedAmount[2]?._id ==
                                      "USDC"
                                  ? otherLeadersPurchasedAmount[2]
                                      ?.otherLeadersPurchaseAmount
                                  : otherLeadersPurchasedAmount &&
                                    otherLeadersPurchasedAmount?.length > 0 &&
                                    otherLeadersPurchasedAmount[3]?._id ==
                                      "USDC"
                                  ? otherLeadersPurchasedAmount[3]
                                      ?.otherLeadersPurchaseAmount
                                  : otherLeadersPurchasedAmount &&
                                    otherLeadersPurchasedAmount?.length > 0 &&
                                    otherLeadersPurchasedAmount[4]?._id ==
                                      "USDC"
                                  ? otherLeadersPurchasedAmount[4]
                                      ?.otherLeadersPurchaseAmount
                                  : 0) +
                                (purchasesAndEarnings &&
                                purchasesAndEarnings?.length > 0 &&
                                purchasesAndEarnings[0]?._id?.tokenSelected ==
                                  "USDC"
                                  ? purchasesAndEarnings[0]?.totalPurchase
                                  : purchasesAndEarnings &&
                                    purchasesAndEarnings?.length > 0 &&
                                    purchasesAndEarnings[1]?._id
                                      ?.tokenSelected == "USDC"
                                  ? purchasesAndEarnings[1]?.totalPurchase
                                  : purchasesAndEarnings &&
                                    purchasesAndEarnings?.length > 0 &&
                                    purchasesAndEarnings[2]?._id
                                      ?.tokenSelected == "USDC"
                                  ? purchasesAndEarnings[2]?.totalPurchase
                                  : purchasesAndEarnings &&
                                    purchasesAndEarnings?.length > 0 &&
                                    purchasesAndEarnings[3]?._id
                                      ?.tokenSelected == "USDC"
                                  ? purchasesAndEarnings[3]?.totalPurchase
                                  : purchasesAndEarnings &&
                                    purchasesAndEarnings?.length > 0 &&
                                    purchasesAndEarnings[4]?._id
                                      ?.tokenSelected == "USDC"
                                  ? purchasesAndEarnings[4]?.totalPurchase
                                  : 0))
                            )?.toFixed(4)
                          ).toLocaleString("en-US")
                        : 0}{" "}
                      <span className={pmc > 0 ? "green-text" : "red-text"}>
                        {pmc ? pmc.toFixed(1) + "% " : ""}
                      </span>
                    </h6>
                  ) : (
                    <h6 className="datahead">~$0.00 USD</h6>
                  )}

                  <div className="bottom-text">
                    <p className="uni-text">
                      <span></span>
                      {(
                        (purchasesAndEarnings &&
                        purchasesAndEarnings?.length > 0 &&
                        purchasesAndEarnings[0]?._id?.tokenSelected == "ETH"
                          ? purchasesAndEarnings[0]?.totalPurchase
                          : purchasesAndEarnings &&
                            purchasesAndEarnings?.length > 0 &&
                            purchasesAndEarnings[1]?._id?.tokenSelected == "ETH"
                          ? purchasesAndEarnings[1]?.totalPurchase
                          : purchasesAndEarnings &&
                            purchasesAndEarnings?.length > 0 &&
                            purchasesAndEarnings[2]?._id?.tokenSelected == "ETH"
                          ? purchasesAndEarnings[2]?.totalPurchase
                          : purchasesAndEarnings &&
                            purchasesAndEarnings?.length > 0 &&
                            purchasesAndEarnings[3]?._id?.tokenSelected == "ETH"
                          ? purchasesAndEarnings[3]?.totalPurchase
                          : purchasesAndEarnings &&
                            purchasesAndEarnings?.length > 0 &&
                            purchasesAndEarnings[4]?._id?.tokenSelected == "ETH"
                          ? purchasesAndEarnings[4]?.totalPurchase
                          : 0) +
                        (otherLeadersPurchasedAmount &&
                        otherLeadersPurchasedAmount?.length > 0 &&
                        otherLeadersPurchasedAmount[0]?._id == "ETH"
                          ? otherLeadersPurchasedAmount[0]
                              ?.otherLeadersPurchaseAmount
                          : otherLeadersPurchasedAmount &&
                            otherLeadersPurchasedAmount[1]?._id == "ETH"
                          ? otherLeadersPurchasedAmount[1]
                              ?.otherLeadersPurchaseAmount
                          : otherLeadersPurchasedAmount &&
                            otherLeadersPurchasedAmount[2]?._id == "ETH"
                          ? otherLeadersPurchasedAmount[2]
                              ?.otherLeadersPurchaseAmount
                          : otherLeadersPurchasedAmount &&
                            otherLeadersPurchasedAmount[3]?._id == "ETH"
                          ? otherLeadersPurchasedAmount[3]
                              ?.otherLeadersPurchaseAmount
                          : otherLeadersPurchasedAmount &&
                            otherLeadersPurchasedAmount[4]?._id == "ETH"
                          ? otherLeadersPurchasedAmount[4]
                              ?.otherLeadersPurchaseAmount
                          : 0)
                      )?.toFixed(4)}{" "}
                      ETH
                    </p>
                    <p className="uni-text">
                      <span></span>
                      {parseFloat(
                        (
                          (purchasesAndEarnings &&
                          purchasesAndEarnings?.length > 0 &&
                          purchasesAndEarnings[0]?._id?.tokenSelected == "USDT"
                            ? purchasesAndEarnings[0]?.totalPurchase
                            : purchasesAndEarnings &&
                              purchasesAndEarnings?.length > 0 &&
                              purchasesAndEarnings[1]?._id?.tokenSelected ==
                                "USDT"
                            ? purchasesAndEarnings[1]?.totalPurchase
                            : purchasesAndEarnings &&
                              purchasesAndEarnings?.length > 0 &&
                              purchasesAndEarnings[2]?._id?.tokenSelected ==
                                "USDT"
                            ? purchasesAndEarnings[2]?.totalPurchase
                            : purchasesAndEarnings &&
                              purchasesAndEarnings?.length > 0 &&
                              purchasesAndEarnings[3]?._id?.tokenSelected ==
                                "USDT"
                            ? purchasesAndEarnings[3]?.totalPurchase
                            : purchasesAndEarnings &&
                              purchasesAndEarnings?.length > 0 &&
                              purchasesAndEarnings[4]?._id?.tokenSelected ==
                                "USDT"
                            ? purchasesAndEarnings[4]?.totalPurchase
                            : 0) +
                          (otherLeadersPurchasedAmount &&
                          otherLeadersPurchasedAmount?.length > 0 &&
                          otherLeadersPurchasedAmount[1]?._id == "USDT"
                            ? otherLeadersPurchasedAmount[1]
                                ?.otherLeadersPurchaseAmount
                            : otherLeadersPurchasedAmount &&
                              otherLeadersPurchasedAmount[0]?._id == "USDT"
                            ? otherLeadersPurchasedAmount[0]
                                ?.otherLeadersPurchaseAmount
                            : otherLeadersPurchasedAmount &&
                              otherLeadersPurchasedAmount[2]?._id == "USDT"
                            ? otherLeadersPurchasedAmount[2]
                                ?.otherLeadersPurchaseAmount
                            : otherLeadersPurchasedAmount &&
                              otherLeadersPurchasedAmount[3]?._id == "USDT"
                            ? otherLeadersPurchasedAmount[3]
                                ?.otherLeadersPurchaseAmount
                            : otherLeadersPurchasedAmount &&
                              otherLeadersPurchasedAmount[4]?._id == "USDT"
                            ? otherLeadersPurchasedAmount[4]
                                ?.otherLeadersPurchaseAmount
                            : 0)
                        )?.toFixed(2)
                      ).toLocaleString("en-US")}{" "}
                      USDT
                    </p>
                    {/* <p className="uni-text">
                      <span></span>
                      {parseFloat(
                        (
                          (purchasesAndEarnings &&
                          purchasesAndEarnings?.length > 0 &&
                          purchasesAndEarnings[0]?._id == "TOMI"
                            ? purchasesAndEarnings[0]?.totalPurchase
                            : purchasesAndEarnings &&
                              purchasesAndEarnings?.length > 0 &&
                              purchasesAndEarnings[1]?._id == "TOMI"
                            ? purchasesAndEarnings[1]?.totalPurchase
                            : purchasesAndEarnings &&
                              purchasesAndEarnings?.length > 0 &&
                              purchasesAndEarnings[2]?._id == "TOMI"
                            ? purchasesAndEarnings[2]?.totalPurchase
                            : purchasesAndEarnings &&
                              purchasesAndEarnings?.length > 0 &&
                              purchasesAndEarnings[3]?._id == "TOMI"
                            ? purchasesAndEarnings[3]?.totalPurchase
                            : purchasesAndEarnings &&
                              purchasesAndEarnings?.length > 0 &&
                              purchasesAndEarnings[4]?._id == "TOMI"
                            ? purchasesAndEarnings[4]?.totalPurchase
                            : 0) +
                          (otherLeadersPurchasedAmount &&
                          otherLeadersPurchasedAmount?.length > 0 &&
                          otherLeadersPurchasedAmount[1]?._id == "TOMI"
                            ? otherLeadersPurchasedAmount[1]
                                ?.otherLeadersPurchaseAmount
                            : otherLeadersPurchasedAmount &&
                              otherLeadersPurchasedAmount[0]?._id == "TOMI"
                            ? otherLeadersPurchasedAmount[0]
                                ?.otherLeadersPurchaseAmount
                            : otherLeadersPurchasedAmount &&
                              otherLeadersPurchasedAmount[2]?._id == "TOMI"
                            ? otherLeadersPurchasedAmount[2]
                                ?.otherLeadersPurchaseAmount
                            : otherLeadersPurchasedAmount &&
                              otherLeadersPurchasedAmount[3]?._id == "TOMI"
                            ? otherLeadersPurchasedAmount[3]
                                ?.otherLeadersPurchaseAmount
                            : otherLeadersPurchasedAmount &&
                              otherLeadersPurchasedAmount[4]?._id == "TOMI"
                            ? otherLeadersPurchasedAmount[4]
                                ?.otherLeadersPurchaseAmount
                            : 0)
                        )?.toFixed(2)
                      ).toLocaleString("en-US")}{" "}
                      TOMI
                    </p> */}
                    <p className="uni-text">
                      <span></span>
                      {parseFloat(
                        (
                          (purchasesAndEarnings &&
                          purchasesAndEarnings?.length > 0 &&
                          purchasesAndEarnings[0]?._id == "WBTC"
                            ? purchasesAndEarnings[0]?.totalPurchase
                            : purchasesAndEarnings &&
                              purchasesAndEarnings?.length > 0 &&
                              purchasesAndEarnings[1]?._id == "WBTC"
                            ? purchasesAndEarnings[1]?.totalPurchase
                            : purchasesAndEarnings &&
                              purchasesAndEarnings?.length > 0 &&
                              purchasesAndEarnings[2]?._id == "WBTC"
                            ? purchasesAndEarnings[2]?.totalPurchase
                            : purchasesAndEarnings &&
                              purchasesAndEarnings?.length > 0 &&
                              purchasesAndEarnings[3]?._id == "WBTC"
                            ? purchasesAndEarnings[3]?.totalPurchase
                            : purchasesAndEarnings &&
                              purchasesAndEarnings?.length > 0 &&
                              purchasesAndEarnings[4]?._id == "WBTC"
                            ? purchasesAndEarnings[4]?.totalPurchase
                            : 0) +
                          (otherLeadersPurchasedAmount &&
                          otherLeadersPurchasedAmount?.length > 0 &&
                          otherLeadersPurchasedAmount[1]?._id == "WBTC"
                            ? otherLeadersPurchasedAmount[1]
                                ?.otherLeadersPurchaseAmount
                            : otherLeadersPurchasedAmount &&
                              otherLeadersPurchasedAmount[0]?._id == "WBTC"
                            ? otherLeadersPurchasedAmount[0]
                                ?.otherLeadersPurchaseAmount
                            : otherLeadersPurchasedAmount &&
                              otherLeadersPurchasedAmount[2]?._id == "WBTC"
                            ? otherLeadersPurchasedAmount[2]
                                ?.otherLeadersPurchaseAmount
                            : otherLeadersPurchasedAmount &&
                              otherLeadersPurchasedAmount[3]?._id == "WBTC"
                            ? otherLeadersPurchasedAmount[3]
                                ?.otherLeadersPurchaseAmount
                            : otherLeadersPurchasedAmount &&
                              otherLeadersPurchasedAmount[4]?._id == "WBTC"
                            ? otherLeadersPurchasedAmount[4]
                                ?.otherLeadersPurchaseAmount
                            : 0)
                        )?.toFixed(5)
                      ).toLocaleString("en-US")}{" "}
                      WBTC
                    </p>
                    <p className="uni-text">
                      <span></span>
                      {parseFloat(
                        (
                          (purchasesAndEarnings &&
                          purchasesAndEarnings?.length > 0 &&
                          purchasesAndEarnings[0]?._id == "USDC"
                            ? purchasesAndEarnings[0]?.totalPurchase
                            : purchasesAndEarnings &&
                              purchasesAndEarnings?.length > 0 &&
                              purchasesAndEarnings[1]?._id == "USDC"
                            ? purchasesAndEarnings[1]?.totalPurchase
                            : purchasesAndEarnings &&
                              purchasesAndEarnings?.length > 0 &&
                              purchasesAndEarnings[2]?._id == "USDC"
                            ? purchasesAndEarnings[2]?.totalPurchase
                            : purchasesAndEarnings &&
                              purchasesAndEarnings?.length > 0 &&
                              purchasesAndEarnings[3]?._id == "USDC"
                            ? purchasesAndEarnings[3]?.totalPurchase
                            : purchasesAndEarnings &&
                              purchasesAndEarnings?.length > 0 &&
                              purchasesAndEarnings[4]?._id == "USDC"
                            ? purchasesAndEarnings[4]?.totalPurchase
                            : 0) +
                          (otherLeadersPurchasedAmount &&
                          otherLeadersPurchasedAmount?.length > 0 &&
                          otherLeadersPurchasedAmount[1]?._id == "USDC"
                            ? otherLeadersPurchasedAmount[1]
                                ?.otherLeadersPurchaseAmount
                            : otherLeadersPurchasedAmount &&
                              otherLeadersPurchasedAmount[0]?._id == "USDC"
                            ? otherLeadersPurchasedAmount[0]
                                ?.otherLeadersPurchaseAmount
                            : otherLeadersPurchasedAmount &&
                              otherLeadersPurchasedAmount[2]?._id == "USDC"
                            ? otherLeadersPurchasedAmount[2]
                                ?.otherLeadersPurchaseAmount
                            : otherLeadersPurchasedAmount &&
                              otherLeadersPurchasedAmount[3]?._id == "USDC"
                            ? otherLeadersPurchasedAmount[3]
                                ?.otherLeadersPurchaseAmount
                            : otherLeadersPurchasedAmount &&
                              otherLeadersPurchasedAmount[4]?._id == "USDC"
                            ? otherLeadersPurchasedAmount[4]
                                ?.otherLeadersPurchaseAmount
                            : 0)
                        )?.toFixed(2)
                      ).toLocaleString("en-US")}{" "}
                      USDC
                    </p>
                  </div>
                </div>
              ) : (
                <div className="single-card">
                  <img
                    src="\assets\dashboard\purchasedamount.svg"
                    alt="img"
                    className="img-fluid"
                  />
                  <p>Purchased Amount</p>
                  {usdPrice && tomiPrice && purchasesAndEarnings?.length > 0 ? (
                    <h6 className="datahead">
                      {purchasesAndEarnings?.length > 0
                        ? "~$" +
                          parseFloat(
                            (
                              usdPrice *
                                (purchasesAndEarnings &&
                                purchasesAndEarnings?.length > 0 &&
                                purchasesAndEarnings[0]?._id?.tokenSelected ==
                                  "ETH"
                                  ? purchasesAndEarnings[0]?.totalPurchase
                                  : purchasesAndEarnings &&
                                    purchasesAndEarnings?.length > 0 &&
                                    purchasesAndEarnings[1]?._id
                                      ?.tokenSelected == "ETH"
                                  ? purchasesAndEarnings[1]?.totalPurchase
                                  : purchasesAndEarnings &&
                                    purchasesAndEarnings?.length > 0 &&
                                    purchasesAndEarnings[2]?._id
                                      ?.tokenSelected == "ETH"
                                  ? purchasesAndEarnings[2]?.totalPurchase
                                  : purchasesAndEarnings &&
                                    purchasesAndEarnings?.length > 0 &&
                                    purchasesAndEarnings[3]?._id
                                      ?.tokenSelected == "ETH"
                                  ? purchasesAndEarnings[3]?.totalPurchase
                                  : purchasesAndEarnings &&
                                    purchasesAndEarnings?.length > 0 &&
                                    purchasesAndEarnings[4]?._id
                                      ?.tokenSelected == "ETH"
                                  ? purchasesAndEarnings[4]?.totalPurchase
                                  : 0) +
                              (purchasesAndEarnings &&
                              purchasesAndEarnings?.length > 0 &&
                              purchasesAndEarnings[0]?._id?.tokenSelected ==
                                "USDT"
                                ? purchasesAndEarnings[0]?.totalPurchase
                                : purchasesAndEarnings &&
                                  purchasesAndEarnings?.length > 0 &&
                                  purchasesAndEarnings[1]?._id?.tokenSelected ==
                                    "USDT"
                                ? purchasesAndEarnings[1]?.totalPurchase
                                : purchasesAndEarnings &&
                                  purchasesAndEarnings?.length > 0 &&
                                  purchasesAndEarnings[2]?._id?.tokenSelected ==
                                    "USDT"
                                ? purchasesAndEarnings[2]?.totalPurchase
                                : purchasesAndEarnings &&
                                  purchasesAndEarnings?.length > 0 &&
                                  purchasesAndEarnings[3]?._id?.tokenSelected ==
                                    "USDT"
                                ? purchasesAndEarnings[3]?.totalPurchase
                                : purchasesAndEarnings &&
                                  purchasesAndEarnings?.length > 0 &&
                                  purchasesAndEarnings[4]?._id?.tokenSelected ==
                                    "USDT"
                                ? purchasesAndEarnings[4]?.totalPurchase
                                : 0) +
                              tomiPrice *
                                (purchasesAndEarnings &&
                                purchasesAndEarnings?.length > 0 &&
                                purchasesAndEarnings[0]?._id?.tokenSelected ==
                                  "TOMI"
                                  ? purchasesAndEarnings[0]?.totalPurchase
                                  : purchasesAndEarnings &&
                                    purchasesAndEarnings?.length > 0 &&
                                    purchasesAndEarnings[1]?._id
                                      ?.tokenSelected == "TOMI"
                                  ? purchasesAndEarnings[1]?.totalPurchase
                                  : purchasesAndEarnings &&
                                    purchasesAndEarnings?.length > 0 &&
                                    purchasesAndEarnings[2]?._id
                                      ?.tokenSelected == "TOMI"
                                  ? purchasesAndEarnings[2]?.totalPurchase
                                  : purchasesAndEarnings &&
                                    purchasesAndEarnings?.length > 0 &&
                                    purchasesAndEarnings[3]?._id
                                      ?.tokenSelected == "TOMI"
                                  ? purchasesAndEarnings[3]?.totalPurchase
                                  : purchasesAndEarnings &&
                                    purchasesAndEarnings?.length > 0 &&
                                    purchasesAndEarnings[4]?._id
                                      ?.tokenSelected == "TOMI"
                                  ? purchasesAndEarnings[4]?.totalPurchase
                                  : 0) +
                              btcPrice *
                                (purchasesAndEarnings &&
                                purchasesAndEarnings?.length > 0 &&
                                purchasesAndEarnings[0]?._id?.tokenSelected ==
                                  "WBTC"
                                  ? purchasesAndEarnings[0]?.totalPurchase
                                  : purchasesAndEarnings &&
                                    purchasesAndEarnings?.length > 0 &&
                                    purchasesAndEarnings[1]?._id
                                      ?.tokenSelected == "WBTC"
                                  ? purchasesAndEarnings[1]?.totalPurchase
                                  : purchasesAndEarnings &&
                                    purchasesAndEarnings?.length > 0 &&
                                    purchasesAndEarnings[2]?._id
                                      ?.tokenSelected == "WBTC"
                                  ? purchasesAndEarnings[2]?.totalPurchase
                                  : purchasesAndEarnings &&
                                    purchasesAndEarnings?.length > 0 &&
                                    purchasesAndEarnings[3]?._id
                                      ?.tokenSelected == "WBTC"
                                  ? purchasesAndEarnings[3]?.totalPurchase
                                  : purchasesAndEarnings &&
                                    purchasesAndEarnings?.length > 0 &&
                                    purchasesAndEarnings[4]?._id
                                      ?.tokenSelected == "WBTC"
                                  ? purchasesAndEarnings[4]?.totalPurchase
                                  : 0) +
                              (purchasesAndEarnings &&
                              purchasesAndEarnings?.length > 0 &&
                              purchasesAndEarnings[0]?._id?.tokenSelected ==
                                "USDC"
                                ? purchasesAndEarnings[0]?.totalPurchase
                                : purchasesAndEarnings &&
                                  purchasesAndEarnings?.length > 0 &&
                                  purchasesAndEarnings[1]?._id?.tokenSelected ==
                                    "USDC"
                                ? purchasesAndEarnings[1]?.totalPurchase
                                : purchasesAndEarnings &&
                                  purchasesAndEarnings?.length > 0 &&
                                  purchasesAndEarnings[2]?._id?.tokenSelected ==
                                    "USDC"
                                ? purchasesAndEarnings[2]?.totalPurchase
                                : purchasesAndEarnings &&
                                  purchasesAndEarnings?.length > 0 &&
                                  purchasesAndEarnings[3]?._id?.tokenSelected ==
                                    "USDC"
                                ? purchasesAndEarnings[3]?.totalPurchase
                                : purchasesAndEarnings &&
                                  purchasesAndEarnings?.length > 0 &&
                                  purchasesAndEarnings[4]?._id?.tokenSelected ==
                                    "USDC"
                                ? purchasesAndEarnings[4]?.totalPurchase
                                : 0)
                            )?.toFixed(4)
                          ).toLocaleString("en-US")
                        : 0}{" "}
                      <span className={pmc > 0 ? "green-text" : "red-text"}>
                        {pmc ? pmc.toFixed(1) + "% " : ""}
                      </span>
                    </h6>
                  ) : (
                    <h6 className="datahead">~$0.00 USD</h6>
                  )}

                  <div className="bottom-text">
                    <p className="uni-text">
                      <span></span>
                      {(purchasesAndEarnings &&
                      purchasesAndEarnings?.length > 0 &&
                      purchasesAndEarnings[0]?._id?.tokenSelected == "ETH"
                        ? purchasesAndEarnings[0]?.totalPurchase
                        : purchasesAndEarnings &&
                          purchasesAndEarnings?.length > 0 &&
                          purchasesAndEarnings[1]?._id?.tokenSelected == "ETH"
                        ? purchasesAndEarnings[1]?.totalPurchase
                        : purchasesAndEarnings &&
                          purchasesAndEarnings?.length > 0 &&
                          purchasesAndEarnings[2]?._id?.tokenSelected == "ETH"
                        ? purchasesAndEarnings[2]?.totalPurchase
                        : purchasesAndEarnings &&
                          purchasesAndEarnings?.length > 0 &&
                          purchasesAndEarnings[3]?._id?.tokenSelected == "ETH"
                        ? purchasesAndEarnings[3]?.totalPurchase
                        : purchasesAndEarnings &&
                          purchasesAndEarnings?.length > 0 &&
                          purchasesAndEarnings[4]?._id?.tokenSelected == "ETH"
                        ? purchasesAndEarnings[4]?.totalPurchase
                        : 0
                      )?.toFixed(4)}{" "}
                      ETH
                    </p>
                    <p className="uni-text">
                      <span></span>
                      {parseFloat(
                        (purchasesAndEarnings &&
                        purchasesAndEarnings?.length > 0 &&
                        purchasesAndEarnings[0]?._id?.tokenSelected == "USDT"
                          ? purchasesAndEarnings[0]?.totalPurchase
                          : purchasesAndEarnings &&
                            purchasesAndEarnings?.length > 0 &&
                            purchasesAndEarnings[1]?._id?.tokenSelected ==
                              "USDT"
                          ? purchasesAndEarnings[1]?.totalPurchase
                          : purchasesAndEarnings &&
                            purchasesAndEarnings?.length > 0 &&
                            purchasesAndEarnings[2]?._id?.tokenSelected ==
                              "USDT"
                          ? purchasesAndEarnings[2]?.totalPurchase
                          : purchasesAndEarnings &&
                            purchasesAndEarnings?.length > 0 &&
                            purchasesAndEarnings[3]?._id?.tokenSelected ==
                              "USDT"
                          ? purchasesAndEarnings[3]?.totalPurchase
                          : purchasesAndEarnings &&
                            purchasesAndEarnings?.length > 0 &&
                            purchasesAndEarnings[4]?._id?.tokenSelected ==
                              "USDT"
                          ? purchasesAndEarnings[4]?.totalPurchase
                          : 0
                        )?.toFixed(2)
                      ).toLocaleString()}{" "}
                      USDT
                    </p>
                    {/* <p className="uni-text">
                      <span></span>
                      {parseFloat(
                        (purchasesAndEarnings &&
                        purchasesAndEarnings?.length > 0 &&
                        purchasesAndEarnings[0]?._id?.tokenSelected == "TOMI"
                          ? purchasesAndEarnings[0]?.totalPurchase
                          : purchasesAndEarnings &&
                            purchasesAndEarnings?.length > 0 &&
                            purchasesAndEarnings[1]?._id?.tokenSelected ==
                              "TOMI"
                          ? purchasesAndEarnings[1]?.totalPurchase
                          : purchasesAndEarnings &&
                            purchasesAndEarnings?.length > 0 &&
                            purchasesAndEarnings[2]?._id?.tokenSelected ==
                              "TOMI"
                          ? purchasesAndEarnings[2]?.totalPurchase
                          : purchasesAndEarnings &&
                            purchasesAndEarnings?.length > 0 &&
                            purchasesAndEarnings[3]?._id?.tokenSelected ==
                              "TOMI"
                          ? purchasesAndEarnings[3]?.totalPurchase
                          : purchasesAndEarnings &&
                            purchasesAndEarnings?.length > 0 &&
                            purchasesAndEarnings[4]?._id?.tokenSelected ==
                              "TOMI"
                          ? purchasesAndEarnings[4]?.totalPurchase
                          : 0
                        )?.toFixed(2)
                      ).toLocaleString()}{" "}
                      TOMI
                    </p> */}
                    <p className="uni-text">
                      <span></span>
                      {parseFloat(
                        (purchasesAndEarnings &&
                        purchasesAndEarnings?.length > 0 &&
                        purchasesAndEarnings[0]?._id?.tokenSelected == "WBTC"
                          ? purchasesAndEarnings[0]?.totalPurchase
                          : purchasesAndEarnings &&
                            purchasesAndEarnings?.length > 0 &&
                            purchasesAndEarnings[1]?._id?.tokenSelected ==
                              "WBTC"
                          ? purchasesAndEarnings[1]?.totalPurchase
                          : purchasesAndEarnings &&
                            purchasesAndEarnings?.length > 0 &&
                            purchasesAndEarnings[2]?._id?.tokenSelected ==
                              "WBTC"
                          ? purchasesAndEarnings[2]?.totalPurchase
                          : purchasesAndEarnings &&
                            purchasesAndEarnings?.length > 0 &&
                            purchasesAndEarnings[3]?._id?.tokenSelected ==
                              "WBTC"
                          ? purchasesAndEarnings[3]?.totalPurchase
                          : purchasesAndEarnings &&
                            purchasesAndEarnings?.length > 0 &&
                            purchasesAndEarnings[4]?._id?.tokenSelected ==
                              "WBTC"
                          ? purchasesAndEarnings[4]?.totalPurchase
                          : 0
                        )?.toFixed(5)
                      ).toLocaleString()}{" "}
                      WBTC
                    </p>
                    <p className="uni-text">
                      <span></span>
                      {parseFloat(
                        (purchasesAndEarnings &&
                        purchasesAndEarnings?.length > 0 &&
                        purchasesAndEarnings[0]?._id?.tokenSelected == "USDC"
                          ? purchasesAndEarnings[0]?.totalPurchase
                          : purchasesAndEarnings &&
                            purchasesAndEarnings?.length > 0 &&
                            purchasesAndEarnings[1]?._id?.tokenSelected ==
                              "USDC"
                          ? purchasesAndEarnings[1]?.totalPurchase
                          : purchasesAndEarnings &&
                            purchasesAndEarnings?.length > 0 &&
                            purchasesAndEarnings[2]?._id?.tokenSelected ==
                              "USDC"
                          ? purchasesAndEarnings[2]?.totalPurchase
                          : purchasesAndEarnings &&
                            purchasesAndEarnings?.length > 0 &&
                            purchasesAndEarnings[3]?._id?.tokenSelected ==
                              "USDC"
                          ? purchasesAndEarnings[3]?.totalPurchase
                          : purchasesAndEarnings &&
                            purchasesAndEarnings?.length > 0 &&
                            purchasesAndEarnings[4]?._id?.tokenSelected ==
                              "USDC"
                          ? purchasesAndEarnings[4]?.totalPurchase
                          : 0
                        )?.toFixed(2)
                      ).toLocaleString()}{" "}
                      USDC
                    </p>
                  </div>
                </div>
              )}

              <div className="single-card">
                <img
                  src="\assets\dashboard\agentearning.svg"
                  alt="img"
                  className="img-fluid"
                />
                <p>My Earnings</p>
                {/* <h6>~50,000 USD</h6> */}
                {usdPrice && tomiPrice && purchasesAndEarnings?.length > 0 ? (
                  <h6 className="datahead">
                    {purchasesAndEarnings?.length > 0
                      ? "~$" +
                        parseFloat(
                          (
                            usdPrice *
                              (purchasesAndEarnings &&
                              purchasesAndEarnings?.length > 0 &&
                              purchasesAndEarnings[0]?._id?.tokenSelected ==
                                "ETH"
                                ? purchasesAndEarnings[0]?.totalLeaderEarnings
                                : purchasesAndEarnings &&
                                  purchasesAndEarnings?.length > 0 &&
                                  purchasesAndEarnings[1]?._id?.tokenSelected ==
                                    "ETH"
                                ? purchasesAndEarnings[1]?.totalLeaderEarnings
                                : purchasesAndEarnings &&
                                  purchasesAndEarnings?.length > 0 &&
                                  purchasesAndEarnings[2]?._id?.tokenSelected ==
                                    "ETH"
                                ? purchasesAndEarnings[2]?.totalLeaderEarnings
                                : purchasesAndEarnings &&
                                  purchasesAndEarnings?.length > 0 &&
                                  purchasesAndEarnings[3]?._id?.tokenSelected ==
                                    "ETH"
                                ? purchasesAndEarnings[3]?.totalLeaderEarnings
                                : purchasesAndEarnings &&
                                  purchasesAndEarnings?.length > 0 &&
                                  purchasesAndEarnings[4]?._id?.tokenSelected ==
                                    "ETH"
                                ? purchasesAndEarnings[4]?.totalLeaderEarnings
                                : 0) +
                            (purchasesAndEarnings &&
                            purchasesAndEarnings?.length > 0 &&
                            purchasesAndEarnings[0]?._id?.tokenSelected ==
                              "USDT"
                              ? purchasesAndEarnings[0]?.totalLeaderEarnings
                              : purchasesAndEarnings &&
                                purchasesAndEarnings?.length > 0 &&
                                purchasesAndEarnings[1]?._id?.tokenSelected ==
                                  "USDT"
                              ? purchasesAndEarnings[1]?.totalLeaderEarnings
                              : purchasesAndEarnings &&
                                purchasesAndEarnings?.length > 0 &&
                                purchasesAndEarnings[2]?._id?.tokenSelected ==
                                  "USDT"
                              ? purchasesAndEarnings[2]?.totalLeaderEarnings
                              : purchasesAndEarnings &&
                                purchasesAndEarnings?.length > 0 &&
                                purchasesAndEarnings[3]?._id?.tokenSelected ==
                                  "USDT"
                              ? purchasesAndEarnings[3]?.totalLeaderEarnings
                              : purchasesAndEarnings &&
                                purchasesAndEarnings?.length > 0 &&
                                purchasesAndEarnings[4]?._id?.tokenSelected ==
                                  "USDT"
                              ? purchasesAndEarnings[4]?.totalLeaderEarnings
                              : 0) +
                            tomiPrice *
                              (purchasesAndEarnings &&
                              purchasesAndEarnings?.length > 0 &&
                              purchasesAndEarnings[0]?._id?.tokenSelected ==
                                "TOMI"
                                ? purchasesAndEarnings[0]?.totalLeaderEarnings
                                : purchasesAndEarnings &&
                                  purchasesAndEarnings?.length > 0 &&
                                  purchasesAndEarnings[1]?._id?.tokenSelected ==
                                    "TOMI"
                                ? purchasesAndEarnings[1]?.totalLeaderEarnings
                                : purchasesAndEarnings &&
                                  purchasesAndEarnings?.length > 0 &&
                                  purchasesAndEarnings[2]?._id?.tokenSelected ==
                                    "TOMI"
                                ? purchasesAndEarnings[2]?.totalLeaderEarnings
                                : purchasesAndEarnings &&
                                  purchasesAndEarnings?.length > 0 &&
                                  purchasesAndEarnings[3]?._id?.tokenSelected ==
                                    "TOMI"
                                ? purchasesAndEarnings[3]?.totalLeaderEarnings
                                : purchasesAndEarnings &&
                                  purchasesAndEarnings?.length > 0 &&
                                  purchasesAndEarnings[4]?._id?.tokenSelected ==
                                    "TOMI"
                                ? purchasesAndEarnings[4]?.totalLeaderEarnings
                                : 0) +
                            btcPrice *
                              (purchasesAndEarnings &&
                              purchasesAndEarnings?.length > 0 &&
                              purchasesAndEarnings[0]?._id?.tokenSelected ==
                                "WBTC"
                                ? purchasesAndEarnings[0]?.totalLeaderEarnings
                                : purchasesAndEarnings &&
                                  purchasesAndEarnings?.length > 0 &&
                                  purchasesAndEarnings[1]?._id?.tokenSelected ==
                                    "WBTC"
                                ? purchasesAndEarnings[1]?.totalLeaderEarnings
                                : purchasesAndEarnings &&
                                  purchasesAndEarnings?.length > 0 &&
                                  purchasesAndEarnings[2]?._id?.tokenSelected ==
                                    "WBTC"
                                ? purchasesAndEarnings[2]?.totalLeaderEarnings
                                : purchasesAndEarnings &&
                                  purchasesAndEarnings?.length > 0 &&
                                  purchasesAndEarnings[3]?._id?.tokenSelected ==
                                    "WBTC"
                                ? purchasesAndEarnings[3]?.totalLeaderEarnings
                                : purchasesAndEarnings &&
                                  purchasesAndEarnings?.length > 0 &&
                                  purchasesAndEarnings[4]?._id?.tokenSelected ==
                                    "WBTC"
                                ? purchasesAndEarnings[4]?.totalLeaderEarnings
                                : 0) +
                            (purchasesAndEarnings &&
                            purchasesAndEarnings?.length > 0 &&
                            purchasesAndEarnings[0]?._id?.tokenSelected ==
                              "USDC"
                              ? purchasesAndEarnings[0]?.totalLeaderEarnings
                              : purchasesAndEarnings &&
                                purchasesAndEarnings?.length > 0 &&
                                purchasesAndEarnings[1]?._id?.tokenSelected ==
                                  "USDC"
                              ? purchasesAndEarnings[1]?.totalLeaderEarnings
                              : purchasesAndEarnings &&
                                purchasesAndEarnings?.length > 0 &&
                                purchasesAndEarnings[2]?._id?.tokenSelected ==
                                  "USDC"
                              ? purchasesAndEarnings[2]?.totalLeaderEarnings
                              : purchasesAndEarnings &&
                                purchasesAndEarnings?.length > 0 &&
                                purchasesAndEarnings[3]?._id?.tokenSelected ==
                                  "USDC"
                              ? purchasesAndEarnings[3]?.totalLeaderEarnings
                              : purchasesAndEarnings &&
                                purchasesAndEarnings?.length > 0 &&
                                purchasesAndEarnings[4]?._id?.tokenSelected ==
                                  "USDC"
                              ? purchasesAndEarnings[4]?.totalLeaderEarnings
                              : 0)
                          )?.toFixed(4)
                        ).toLocaleString("en-US")
                      : 0}{" "}
                    <span className={lec > 0 ? "green-text" : "red-text"}>
                      {lec ? lec.toFixed(1) + "% " : ""}
                    </span>
                  </h6>
                ) : (
                  <h6 className="datahead">~$0.00 USD</h6>
                )}
                <div className="bottom-text">
                  <p className="uni-text">
                    <span></span>
                    {(purchasesAndEarnings &&
                    purchasesAndEarnings?.length > 0 &&
                    purchasesAndEarnings[0]?._id?.tokenSelected == "ETH"
                      ? purchasesAndEarnings[0]?.totalLeaderEarnings
                      : purchasesAndEarnings &&
                        purchasesAndEarnings?.length > 0 &&
                        purchasesAndEarnings[1]?._id?.tokenSelected == "ETH"
                      ? purchasesAndEarnings[1]?.totalLeaderEarnings
                      : purchasesAndEarnings &&
                        purchasesAndEarnings?.length > 0 &&
                        purchasesAndEarnings[2]?._id?.tokenSelected == "ETH"
                      ? purchasesAndEarnings[2]?.totalLeaderEarnings
                      : purchasesAndEarnings &&
                        purchasesAndEarnings?.length > 0 &&
                        purchasesAndEarnings[3]?._id?.tokenSelected == "ETH"
                      ? purchasesAndEarnings[3]?.totalLeaderEarnings
                      : purchasesAndEarnings &&
                        purchasesAndEarnings?.length > 0 &&
                        purchasesAndEarnings[4]?._id?.tokenSelected == "ETH"
                      ? purchasesAndEarnings[4]?.totalLeaderEarnings
                      : 0
                    ).toFixed(5)}{" "}
                    ETH
                  </p>
                  <p className="uni-text">
                    <span></span>
                    {parseFloat(
                      purchasesAndEarnings &&
                        purchasesAndEarnings?.length > 0 &&
                        purchasesAndEarnings[0]?._id?.tokenSelected == "USDT"
                        ? purchasesAndEarnings[0]?.totalLeaderEarnings
                        : purchasesAndEarnings &&
                          purchasesAndEarnings?.length > 0 &&
                          purchasesAndEarnings[1]?._id?.tokenSelected == "USDT"
                        ? purchasesAndEarnings[1]?.totalLeaderEarnings
                        : purchasesAndEarnings &&
                          purchasesAndEarnings?.length > 0 &&
                          purchasesAndEarnings[2]?._id?.tokenSelected == "USDT"
                        ? purchasesAndEarnings[2]?.totalLeaderEarnings
                        : purchasesAndEarnings &&
                          purchasesAndEarnings?.length > 0 &&
                          purchasesAndEarnings[3]?._id?.tokenSelected == "USDT"
                        ? purchasesAndEarnings[3]?.totalLeaderEarnings
                        : purchasesAndEarnings &&
                          purchasesAndEarnings?.length > 0 &&
                          purchasesAndEarnings[4]?._id?.tokenSelected == "USDT"
                        ? purchasesAndEarnings[4]?.totalLeaderEarnings
                        : 0
                    )?.toLocaleString("en-US")}{" "}
                    USDT
                  </p>
                  {/* <p className="uni-text">
                    <span></span>
                    {parseFloat(
                      (purchasesAndEarnings &&
                      purchasesAndEarnings?.length > 0 &&
                      purchasesAndEarnings[0]?._id?.tokenSelected == "TOMI"
                        ? purchasesAndEarnings[0]?.totalLeaderEarnings
                        : purchasesAndEarnings &&
                          purchasesAndEarnings?.length > 0 &&
                          purchasesAndEarnings[1]?._id?.tokenSelected == "TOMI"
                        ? purchasesAndEarnings[1]?.totalLeaderEarnings
                        : purchasesAndEarnings &&
                          purchasesAndEarnings?.length > 0 &&
                          purchasesAndEarnings[2]?._id?.tokenSelected == "TOMI"
                        ? purchasesAndEarnings[2]?.totalLeaderEarnings
                        : purchasesAndEarnings &&
                          purchasesAndEarnings?.length > 0 &&
                          purchasesAndEarnings[3]?._id?.tokenSelected == "TOMI"
                        ? purchasesAndEarnings[3]?.totalLeaderEarnings
                        : purchasesAndEarnings &&
                          purchasesAndEarnings?.length > 0 &&
                          purchasesAndEarnings[4]?._id?.tokenSelected == "TOMI"
                        ? purchasesAndEarnings[4]?.totalLeaderEarnings
                        : 0
                      )?.toFixed(2)
                    )?.toLocaleString("en-US")}{" "}
                    TOMI
                  </p> */}

                  <p className="uni-text">
                    <span></span>
                    {parseFloat(
                      (purchasesAndEarnings &&
                      purchasesAndEarnings?.length > 0 &&
                      purchasesAndEarnings[0]?._id?.tokenSelected == "WBTC"
                        ? purchasesAndEarnings[0]?.totalLeaderEarnings
                        : purchasesAndEarnings &&
                          purchasesAndEarnings?.length > 0 &&
                          purchasesAndEarnings[1]?._id?.tokenSelected == "WBTC"
                        ? purchasesAndEarnings[1]?.totalLeaderEarnings
                        : purchasesAndEarnings &&
                          purchasesAndEarnings?.length > 0 &&
                          purchasesAndEarnings[2]?._id?.tokenSelected == "WBTC"
                        ? purchasesAndEarnings[2]?.totalLeaderEarnings
                        : purchasesAndEarnings &&
                          purchasesAndEarnings?.length > 0 &&
                          purchasesAndEarnings[3]?._id?.tokenSelected == "WBTC"
                        ? purchasesAndEarnings[3]?.totalLeaderEarnings
                        : purchasesAndEarnings &&
                          purchasesAndEarnings?.length > 0 &&
                          purchasesAndEarnings[4]?._id?.tokenSelected == "WBTC"
                        ? purchasesAndEarnings[4]?.totalLeaderEarnings
                        : 0
                      )?.toFixed(5)
                    )?.toLocaleString("en-US")}{" "}
                    WBTC
                  </p>
                  <p className="uni-text">
                    <span></span>
                    {parseFloat(
                      (purchasesAndEarnings &&
                      purchasesAndEarnings?.length > 0 &&
                      purchasesAndEarnings[0]?._id?.tokenSelected == "USDC"
                        ? purchasesAndEarnings[0]?.totalLeaderEarnings
                        : purchasesAndEarnings &&
                          purchasesAndEarnings?.length > 0 &&
                          purchasesAndEarnings[1]?._id?.tokenSelected == "USDC"
                        ? purchasesAndEarnings[1]?.totalLeaderEarnings
                        : purchasesAndEarnings &&
                          purchasesAndEarnings?.length > 0 &&
                          purchasesAndEarnings[2]?._id?.tokenSelected == "USDC"
                        ? purchasesAndEarnings[2]?.totalLeaderEarnings
                        : purchasesAndEarnings &&
                          purchasesAndEarnings?.length > 0 &&
                          purchasesAndEarnings[3]?._id?.tokenSelected == "USDC"
                        ? purchasesAndEarnings[3]?.totalLeaderEarnings
                        : purchasesAndEarnings &&
                          purchasesAndEarnings?.length > 0 &&
                          purchasesAndEarnings[4]?._id?.tokenSelected == "USDC"
                        ? purchasesAndEarnings[4]?.totalLeaderEarnings
                        : 0
                      )?.toFixed(2)
                    )?.toLocaleString("en-US")}{" "}
                    USDC
                  </p>
                </div>
              </div>
              {/* {user?.role === "admin" ? (
                <>
                  <div className="single-card">
                    <img
                      src="\assets\dashboard\noofagents.svg"
                      alt="img"
                      className="img-fluid"
                    />
                    <p>No. of Leaders</p>
                    <h6>{totalleader ? totalleader : 0}</h6>
                    <div className="bottom-text">
                      <p className="uni-text">
                        <span></span>
                        {g ? g : 0} God{" "}
                      </p>
                      <p className="uni-text">
                        <span></span>
                        {m ? m : 0} Mega{" "}
                      </p>
                      <p className="uni-text">
                        <span></span>
                        {s ? s : 0} Super{" "}
                      </p>
                      <p className="uni-text">
                        <span></span>
                        {a ? a : 0} Agent{" "}
                      </p>
                    </div>
                  </div>
                  <div className="single-card">
                    <img
                      src="\assets\dashboard\netrevenue.svg"
                      alt="img"
                      className="img-fluid"
                    />
                    <p>Net Revenue</p>
                    {usdPrice && netRevenue ? (
                      <h6 className="datahead">
                        ~$
                        {parseInt(
                          (
                            usdPrice * netRevenue?.eth +
                            netRevenue?.us
                          )?.toFixed(2)
                        ).toLocaleString("en-US")}{" "}
                      </h6>
                    ) : (
                      <h6 className="datahead">~$0.00 USD</h6>
                    )}
                    <div className="bottom-text">
                      <p className="uni-text">
                        <span></span>
                        {netRevenue ? netRevenue?.eth?.toFixed(4) : 0} ETH
                      </p>
                      <p className="uni-text">
                        <span></span>
                        {netRevenue
                          ? parseInt(
                            netRevenue?.us?.toFixed(2)
                          )?.toLocaleString("en-US")
                          : 0}{" "}
                        USDT
                      </p>
                    </div>
                  </div>
                </>
              ) : (
                ""
              )} */}
            </div>
          )}
          {(topThreeLeadersData?.amountInvested ||
            topThreeLeadersData?.totalPurchases) &&
          user?.role != "admin" ? (
            <div className="leader-data">
              <div className="twice-tables-set">
                <section className="datatable">
                  <div className="leader-heading">
                    <h6>Top 3 By Purchases</h6>
                  </div>
                  <div className="table-responsive">
                    <table class="table">
                      <thead>
                        <tr>
                          <th>
                            <div className="parent-tag">
                              No.
                              <div className="filter-btn">
                                <svg
                                  width="9"
                                  height="6"
                                  viewBox="0 0 9 6"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M7.90908 5.14282H4.09498H0.660442C0.072714 5.14282 -0.22115 4.36222 0.195157 3.90463L3.36644 0.418863C3.87458 -0.139668 4.70107 -0.139668 5.20921 0.418863L6.41528 1.74453L8.38049 3.90463C8.79068 4.36222 8.49681 5.14282 7.90908 5.14282Z"
                                    fill="#242627"
                                  />
                                </svg>
                                <svg
                                  width="9"
                                  height="6"
                                  viewBox="0 0 9 6"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M7.90908 0.857178H4.09498H0.660442C0.072714 0.857178 -0.22115 1.63778 0.195157 2.09537L3.36644 5.58114C3.87458 6.13967 4.70107 6.13967 5.20921 5.58114L6.41528 4.25547L8.38049 2.09537C8.79068 1.63778 8.49681 0.857178 7.90908 0.857178Z"
                                    fill="#242627"
                                  />
                                </svg>
                              </div>
                            </div>
                          </th>
                          <th>
                            <div className="parent-tag">
                              Leader
                              <div className="filter-btn">
                                <svg
                                  width="9"
                                  height="6"
                                  viewBox="0 0 9 6"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M7.90908 5.14282H4.09498H0.660442C0.072714 5.14282 -0.22115 4.36222 0.195157 3.90463L3.36644 0.418863C3.87458 -0.139668 4.70107 -0.139668 5.20921 0.418863L6.41528 1.74453L8.38049 3.90463C8.79068 4.36222 8.49681 5.14282 7.90908 5.14282Z"
                                    fill="#242627"
                                  />
                                </svg>
                                <svg
                                  width="9"
                                  height="6"
                                  viewBox="0 0 9 6"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M7.90908 0.857178H4.09498H0.660442C0.072714 0.857178 -0.22115 1.63778 0.195157 2.09537L3.36644 5.58114C3.87458 6.13967 4.70107 6.13967 5.20921 5.58114L6.41528 4.25547L8.38049 2.09537C8.79068 1.63778 8.49681 0.857178 7.90908 0.857178Z"
                                    fill="#242627"
                                  />
                                </svg>
                              </div>
                            </div>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {topThreeLeadersData?.amountInvested?.length > 0
                          ? topThreeLeadersData?.amountInvested?.map(
                              (item, index) => {
                                return (
                                  <>
                                    <tr>
                                      <td>#{index + 1}</td>
                                      <td>
                                        <div className="twice-text">
                                          <h6>{item?.user[0]?.name}</h6>
                                        </div>
                                      </td>
                                    </tr>
                                  </>
                                );
                              }
                            )
                          : null}
                      </tbody>
                    </table>
                  </div>
                </section>
                <section className="datatable">
                  <div className="leader-heading">
                    <h6>Top 3 By Amount</h6>
                  </div>
                  <div className="table-responsive">
                    <table class="table">
                      <thead>
                        <tr>
                          <th>
                            <div className="parent-tag">
                              No.
                              <div className="filter-btn">
                                <svg
                                  width="9"
                                  height="6"
                                  viewBox="0 0 9 6"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M7.90908 5.14282H4.09498H0.660442C0.072714 5.14282 -0.22115 4.36222 0.195157 3.90463L3.36644 0.418863C3.87458 -0.139668 4.70107 -0.139668 5.20921 0.418863L6.41528 1.74453L8.38049 3.90463C8.79068 4.36222 8.49681 5.14282 7.90908 5.14282Z"
                                    fill="#242627"
                                  />
                                </svg>
                                <svg
                                  width="9"
                                  height="6"
                                  viewBox="0 0 9 6"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M7.90908 0.857178H4.09498H0.660442C0.072714 0.857178 -0.22115 1.63778 0.195157 2.09537L3.36644 5.58114C3.87458 6.13967 4.70107 6.13967 5.20921 5.58114L6.41528 4.25547L8.38049 2.09537C8.79068 1.63778 8.49681 0.857178 7.90908 0.857178Z"
                                    fill="#242627"
                                  />
                                </svg>
                              </div>
                            </div>
                          </th>
                          <th>
                            <div className="parent-tag">
                              Leader
                              <div className="filter-btn">
                                <svg
                                  width="9"
                                  height="6"
                                  viewBox="0 0 9 6"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M7.90908 5.14282H4.09498H0.660442C0.072714 5.14282 -0.22115 4.36222 0.195157 3.90463L3.36644 0.418863C3.87458 -0.139668 4.70107 -0.139668 5.20921 0.418863L6.41528 1.74453L8.38049 3.90463C8.79068 4.36222 8.49681 5.14282 7.90908 5.14282Z"
                                    fill="#242627"
                                  />
                                </svg>
                                <svg
                                  width="9"
                                  height="6"
                                  viewBox="0 0 9 6"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M7.90908 0.857178H4.09498H0.660442C0.072714 0.857178 -0.22115 1.63778 0.195157 2.09537L3.36644 5.58114C3.87458 6.13967 4.70107 6.13967 5.20921 5.58114L6.41528 4.25547L8.38049 2.09537C8.79068 1.63778 8.49681 0.857178 7.90908 0.857178Z"
                                    fill="#242627"
                                  />
                                </svg>
                              </div>
                            </div>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {topThreeLeadersData?.totalPurchases?.length > 0
                          ? topThreeLeadersData?.totalPurchases?.map(
                              (item, index) => {
                                return (
                                  <>
                                    <tr>
                                      <td>#{index + 1}</td>
                                      <td>
                                        <div className="twice-text">
                                          <h6>{item?.user[0]?.name}</h6>
                                        </div>
                                      </td>
                                    </tr>
                                  </>
                                );
                              }
                            )
                          : null}
                      </tbody>
                    </table>
                  </div>
                </section>
              </div>
            </div>
          ) : null}

          <div className="twice-charts">
            <div className="main-graph">
              <h6 className="main-heading">
                Top 10 Countries by Number of Purchases
              </h6>
              <Countrychart
                chartData={chartsData?.purchasesNumberStats?.slice(0, 10)}
                chartType={"purchases"}
              />
            </div>
            <div className="main-graph">
              <h6 className="main-heading">
                Top 10 Countries by Purchased Amount
              </h6>
              <Countrychart
                chartData={chartsData?.purchaseAmountStats?.slice(0, 10)}
                chartType={"amount"}
              />
            </div>
          </div>

          <DataTable
            btcPrice={btcPrice}
            tomiPrice={tomiPrice}
            setSearch={setSearch}
            setTopLeaderSearch={setTopLeaderSearch}
            user={user}
            getTransactionsData={getTransactionsData}
            usdPrice={usdPrice}
            transactions={transactions}
            setOrderDirection={setOrderDirection}
            setOrderField={setOrderField}
            setActiveTab={setActiveTab}
            activeTab={activeTab}
            topTenLeaders={topTenLeaders}
            topTenData={topTenData}
            topThreeData={topThreeData}
            topTenApiCalled={topTenApiCalled}
            topThreeApiCalled={topThreeApiCalled}
            transactionApiCalled={transactionApiCalled}
          />
        </div>
      </section>

      <Modal
        className="add-mega-modal global-modal-scss"
        show={show1}
        onHide={handleClose1}
        centered
      >
        <Modal.Header closeButton>
          {user?.role === "admin" ? (
            <Modal.Title>Add God Leader</Modal.Title>
          ) : (
            <Modal.Title>Add Leader</Modal.Title>
          )}
          {/* {user?.role === "admin" && <Modal.Title>Add Mega Agents</Modal.Title>}
                    {user?.role === "admin" && <Modal.Title>Add Mega Agents</Modal.Title>} */}
        </Modal.Header>
        <Modal.Body>
          <div className="add-mega-div">
            <div className="option-field">
              <div className="material-textfield">
                <input
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="Enter Leader’s Name"
                />
                <label>Leader’s Name</label>
              </div>
            </div>
            <div className="option-field">
              <div className="material-textfield">
                <input
                  type="text"
                  value={addr}
                  onChange={(e) => setAddr(e.target.value)}
                  placeholder="Enter Leader’s Wallet Address"
                />
                <label>Leader’s Wallet Address</label>
              </div>
            </div>
            <div className="option-field">
              <div className="material-textfield">
                <input
                  onChange={(e) => setEmail(e.target.value)}
                  value={email}
                  type="text"
                  placeholder="Enter Leader’s Email Address"
                />
                <label>Leader’s Email Address</label>
              </div>
            </div>
            {user?.role !== "admin" && (
              <div className="option-field">
                <div class="dropdown">
                  <button
                    class="btn btn-secondary dropdown-toggle"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    {role === null
                      ? "Type of Leader"
                      : convertToTitleCase(role)}
                  </button>
                  {user?.role === "god_agent" && (
                    <ul class="dropdown-menu">
                      <li onClick={() => setRole("mega_agent")}>
                        <a class="dropdown-item" href="#">
                          Mega Leader
                        </a>
                      </li>
                      <li onClick={() => setRole("super_agent")}>
                        <a class="dropdown-item" href="#">
                          Super Leader
                        </a>
                      </li>
                      <li onClick={() => setRole("agent")}>
                        <a class="dropdown-item" href="#">
                          Leader
                        </a>
                      </li>
                      <li onClick={() => setRole("mini_agent")}>
                        <a class="dropdown-item" href="#">
                          Ambassador
                        </a>
                      </li>
                    </ul>
                  )}
                  {user?.role === "mega_agent" && (
                    <ul class="dropdown-menu">
                      <li onClick={() => setRole("super_agent")}>
                        <a class="dropdown-item" href="#">
                          Super Leader
                        </a>
                      </li>
                      <li onClick={() => setRole("agent")}>
                        <a class="dropdown-item" href="#">
                          Leader
                        </a>
                      </li>
                      <li onClick={() => setRole("mini_agent")}>
                        <a class="dropdown-item" href="#">
                          Ambassador
                        </a>
                      </li>
                    </ul>
                  )}
                  {user?.role === "super_agent" && (
                    <ul class="dropdown-menu">
                      <li onClick={() => setRole("agent")}>
                        <a class="dropdown-item" href="#">
                          Leader
                        </a>
                      </li>
                      <li onClick={() => setRole("mini_agent")}>
                        <a class="dropdown-item" href="#">
                          Ambassador
                        </a>
                      </li>
                    </ul>
                  )}
                  {user?.role === "agent" && (
                    <ul class="dropdown-menu">
                      <li onClick={() => setRole("mini_agent")}>
                        <a class="dropdown-item" href="#">
                          Ambassador
                        </a>
                      </li>
                    </ul>
                  )}
                </div>
              </div>
            )}
          </div>
          <p
            style={{
              color: "red",
              textAlign: "center",
              marginTop: -15,
              marginBottom: 15,
            }}
          >
            {error}
          </p>
          <div className="twice-btn">
            <button
              onClick={() => {
                handleClose1();
                setError("");
              }}
              className="btn-cancel"
            >
              Back
            </button>
            <button
              disabled={loader}
              className="btn-add"
              onClick={() => AddAgent()}
            >
              {loader ? "Adding..." : "Add"}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="add-mega-modal global-modal-scss"
        show={show2}
        onHide={handleClose2}
        centered
      >
        <Modal.Header closeButton>
          {user?.role === "admin" ? (
            <Modal.Title>Add Mega Leaders</Modal.Title>
          ) : (
            <Modal.Title>Add Leaders</Modal.Title>
          )}
        </Modal.Header>
        <Modal.Body>
          <div className="add-mega-div">
            {user?.role === "admin" ? (
              <h6>God Leader has been added</h6>
            ) : (
              <h6>
                {convertToTitleCase(role)}{" "}
                {convertToTitleCase(role) === "Leader"
                  ? "has been added"
                  : convertToTitleCase(role) === "Mega Leader" ||
                    convertToTitleCase(role) === "Ambassador"
                  ? "has been added"
                  : "Leader has been added"}
              </h6>
            )}
          </div>
          <div className="twice-btn">
            <button
              onClick={() => handleClose2()}
              className="btn-add"
              style={{ flex: "auto" }}
            >
              Okay
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Dashboard;
